<template>
  <section>
    <div class="row">
      <div class="col-md-1">
        <label>Show Records</label>
        <select v-model="showRecords" class="form-control h-43">
          <option value="10">10</option>
          <option value="30">30</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>
      <div class="col-md-1">
        <label>Search By Type</label>
        <div class="mt-8">
          <div class="custom-control custom-checkbox">
            <input id="primary-type" v-model="typePrimary" class="custom-control-input" type="checkbox"
                   @change="filterByType('primary')"/>
            <label class="custom-control-label pt-3" for="primary-type">Primary</label>
          </div>
          <div class="custom-control custom-checkbox">
            <input id="addon" v-model="typeAddon" class="custom-control-input" type="checkbox"
                   @change="filterByType('addon')"/>
            <label class="custom-control-label pt-3" for="addon">Addon</label>
          </div>
        </div>

        <!--                <multi-select v-model="typeSearch" :options="tagsType" :multiple="true"-->
        <!--                              :close-on-select="true" :clear-on-select="true"-->
        <!--                              placeholder="Select type to filter out domains list" />-->
      </div>
      <div class="col-md-1">
        <label>Search By Status</label>
        <div class="mt-8">
          <div class="custom-control custom-checkbox">
            <input id="active" v-model="statusActive" class="custom-control-input" type="checkbox"
                   @change="filterByType('active')"/>
            <label class="custom-control-label pt-3" for="active">Active</label>
          </div>
          <div class="custom-control custom-checkbox">
            <input id="pending" v-model="statusPending" class="custom-control-input"
                   type="checkbox" @change="filterByType('pending')"/>
            <label class="custom-control-label pt-3" for="pending">Pending</label>
          </div>
        </div>
        <!--                <multi-select v-model="statusSearch" :options="tagsStatus" :multiple="true"-->
        <!--                              :close-on-select="true" :clear-on-select="true"-->
        <!--                              placeholder="Select status to filter out domains list" />-->
      </div>
      <div class="col-md-1">

        <label>Cloudflare Filter </label>
        <div class="mt-8">
          <div class="custom-control custom-checkbox">
            <input id="free" v-model="selectedFilters" class="custom-control-input" type="checkbox" value="free"/>
            <label class="custom-control-label pt-3" for="free">Free</label>
          </div>
          <div class="custom-control custom-checkbox">
            <input id="enterprise" v-model="selectedFilters" class="custom-control-input" type="checkbox"
                   value="enterprise"/>
            <label class="custom-control-label pt-3" for="enterprise">Enterprise</label>
          </div>
        </div>
      </div>
      <!--                <multi-select v-model="statusSearch" :options="tagsStatus" :multiple="true"-->
      <!--                              :close-on-select="true" :clear-on-select="true"-->
      <!--                              placeholder="Select status to filter out domains list" />-->
      <div class="col-md-3">
        <label>Search By Domain/Hostname/IP</label>
        <input v-model="searchQuery" class="form-control h-43" placeholder="example.com" type="text"/>
      </div>
      <div class="col-md-3 d-flex align-end mb-20">
        <button class="btn btn-info btn-md d-inline" type="button" @click.prevent="addNewHostingAccount">
          <i aria-hidden="true" class="fa fa-plus mr-1"></i>
          Add
        </button>
        <button class="btn btn-info btn-md d-inline" data-target="#swap-modal" data-toggle="modal" type="button">
          swap
        </button>
        <button class="btn btn-success pull-right" @click="updateCFForAllDomains()">
            <span v-if="updatingCF">
             <div class="loader" style="width: 20px;height: 20px; margin: 0 auto !important;"></div>
            </span>
          <span v-else>
            Update CF Status
            </span>
        </button>
        <!--              <div class="mb-8 ">-->
        <!--                <label>Cloudflare Filter</label>-->
        <!--                <div class="mt-4">-->
        <!--                  <div class="custom-control custom-checkbox">-->
        <!--                    <input type="checkbox"  v-model="selectedFilters" class="custom-control-input" id="free" value="free" />-->
        <!--                    <label class="custom-control-label pt-3" for="free">Free</label>-->
        <!--                  </div>-->
        <!--                  <div class="custom-control custom-checkbox">-->
        <!--                    <input type="checkbox"    v-model="selectedFilters"  class="custom-control-input" id="enterprise" value="enterprise"/>-->
        <!--                    <label class="custom-control-label pt-3" for="enterprise">Enterprise</label>-->
        <!--                  </div>-->
        <!--              </div>-->
        <!--            </div>-->
      </div>
    </div>
    <template v-if="hostingAccounts.length">
      <div class="row">
        <div class="col-md-12">
          <div id="accordionExample" class="accordion mt-3">
            <div v-for="(account, index) in hostingAccounts" :key="index" class="card card-body domain-card">
              <div class="media d-flex align-items-center">
                <button :aria-controls="'collapseOne_' + index"
                        :data-target="'#collapse_' + index"
                        :style="{background: colors[account.colorIndex].base, '--hover-color': colors[account.colorIndex].base ,  '--focus-color': colors[account.colorIndex].bold}"
                        class="custom-button mr-4 my-0" data-toggle="collapse"
                        @click="getNodeInfoFromNetbox(index, account)"><i
                    :class="openedTab ===`${account.colorIndex}-${account.domain}` ? 'fa-minus' : 'fa-plus' " class="fa"
                    style={color:red}></i>
                </button>
                <div class="media-body">
                  <div class="domain-head d-flex align-items-center">
                    <h5 class="mt-1 h5-m0">
                      <a v-if="account.domain !== ''" :href="'https://' + account.domain" class="mr-2" target="_blank">{{
                          account.domain
                        }}</a>
                      <a v-else class="mr-2" href="javascript:void(0)">{{
                          (account.type === 'Primary Domain') ? 'New WPO Primary Domain' : 'New WPO Add-on Domain'
                        }}</a>
                      <small><a
                          :class="{'badge-primary':(account.type === 'Primary Domain' && account.planType !== 'multisite'), 'badge-danger':(account.planType === 'multisite'),'badge-default':(account.type !== 'Primary Domain')}"
                          class="fs-10 badge mr-2 ml-5"
                          href="javascript:void(0)">
                        {{
                          account.planType === 'multisite' ? 'Multisite' : account.planType === 'hybrid' ? 'Hybrid' : (account.type === 'Primary Domain') ? 'Primary' : 'Add-On'
                        }}</a></small>
                      <small><a v-if="account.siteType === 'multisite'" class="fs-10 badge mr-2 ml-5 badge-primary"
                                href="javascript:void(0)"> {{ 'Multisite' }}</a></small>
                      <small v-if="account.staging.enabled"><a class="fs-10 badge badge-info mr-2"
                                                               href="javascript:void(0)"
                                                               @click="doCopy(account.staging.domain)"><i
                          class="fa fa-copy"></i> <i v-if="account.installation_type === 'staging'"
                                                     class="fa fa-exclamation-triangle"></i>
                        {{ account.installation_type === 'staging' ? 'Staging Only' : 'Staging' }}</a></small>
                      <small><span
                          :class="{'badge-danger' : account.status === 'pending', 'badge-success' : account.status === 'active'}"
                          class="fs-10 badge mr-2">{{ account.status }}</span></small>
                      <small><span v-for="(tag, tag_index) of account.tags" :key="tag_index" :class="tag.type"
                                   class="fs-10 badge mr-2">{{ tag.title }}</span></small>
                      <small><a class="fs-10 badge badge-info" href="javascript:void(0)"
                                @click="doCopy(account.serverIP)"><i class="fa fa-copy"></i>
                        {{ (account.serverIP) ? account.serverIP : 'N/A' }}</a></small>
                      <small v-if="account.suspended"><span
                          class="fs-10 badge ml-2 badge-danger">Suspended</span></small>
                      <small v-for="(row, w_index) in filterTags(account.domain)" :key="'tags' + w_index">
                        <!--                                        <span class="fs-10 badge ml-2 badge-secondary cursor-pointer">-->
                        <!--                                         <img style="width: 1px !important;" :src="getSource(row)" :title="`${row.tag.toUpperCase()}`" alt="">-->
                        <!--                                        </span>-->
                        <span class="fs-10 mt-0 ml-2">
                                          <img :src="getSource(row)"
                                               :title="`${row.category.toUpperCase()} ${row.tag.toUpperCase()}`" alt=""
                                               data-html="true" data-placement="top"
                                               data-toggle="tooltip" style="width: 20px !important;">
                                      </span>
                        <!--                                        <img  class="ml-10" style="width: 30px !important;" :src="getSource(row)" alt="">-->
                      </small>
                      <!--                                      <small v-if="account.uuid"><a @click="doCopy(account.uuid)" href="javascript:void(0)" class="fs-10 badge badge-danger ml-2"><i class="fa fa-copy"></i> {{(account.uuid) ? 'UUID: ' + account.uuid: 'N/A'}}</a></small>-->
                    </h5>
                    <section>
                      <ul class="list-inline ul-m0 position">
                        <li v-if="mainLoading && operationIndex === index" class="list-inline-item">
                          <i class="fa fa-spinner fa-spin fs-16"></i>
                          <!--                                              <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>-->
                        </li>
                        <li class="list-inline-item text-center cf-status-icons">
                          <i :class="sslClass(account.domain)" :title="getSSLTitle(account.domain)"
                             class="fs-28 fa fa-lock"></i>
                        </li>
                        <li class="list-inline-item text-center cf-status-icons">
                          <i :class="getCFClass(account.domain)" :title="getCFTitle(account.domain)"
                             class="fa fa-cloud fs-28"></i>
                        </li>
                        <li class="list-inline-item">
                          <!--                                              <div v-if="wpLoader && selectedIndex===index" class="loader mini_loader" style="width: 30px !important; height: 30px !important;"></div>-->
                          <span style="cursor: pointer" title="Open Ticket" @click="openTicketModal(account, index)"><i
                              class="fa fa-envelope fs-28 text-primary"/></span>
                        </li>
                        <li class="list-inline-item">
                          <div v-if="wpLoader && selectedIndex===index" class="loader mini_loader"
                               style="width: 30px !important; height: 30px !important;"></div>
                          <span v-else style="cursor: pointer" @click="getLoginLink(account, index)">
<!--                                                <img width="25px" src="../../../../assets/img/wordpress-logo.webp" alt="wp">-->
                                              <i class="fa fa-wordpress" style="font-size: 24px"></i>
                                            </span>
                        </li>
                        <li class="list-inline-item">
                          <div class="dropdown">
                            <button id="dropdownMenuButton"
                                    :disabled="mainLoading && operationIndex === index"
                                    aria-expanded="false" aria-haspopup="true"
                                    class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown"
                                    type="button"
                                    @click="account.type === 'Primary Domain' && isNewBackupEnabled(account)">
                              Choose Operation
                            </button>
                            <div aria-labelledby="dropdownMenuButton" class="dropdown-menu">
                              <a v-if="account.planType === 'multisite' || account.siteType === 'multisite'"
                                 class="dropdown-item"
                                 href="javascript:void(0)" @click.prevent="openSubsitesModal(account)">View Subsites</a>
                              <a :class="processingDomainList.length!==0 ? 'disabled' : '' " class="dropdown-item"
                                 href="javascript:void(0)" @click.prevent="openTagModal(account)">Add New Tags</a>
                              <a :data-target="`r`" class="dropdown-item" data-toggle="" href="javascript:void(0)">Auto
                                Populate Details</a>
                              <a :class="{'disabled': checkCFEnterprise(account.domain) || activatedDomains.includes(account.domain)}"
                                 class="dropdown-item"
                                 href="javascript:void(0)" @click="activateCloudflareEnterprise(account, index)">Activate
                                Cloudflare Enterprise</a>
                              <a v-if='account.addonIndex === null'
                                 :class="processingDomainList.length!==0 ? 'disabled' : '' " class="dropdown-item"
                                 href="javascript:void(0)"
                                 @click.prevent="openCustomBulkDomainDeletionModal(account, index)">Bulk Remove
                                Sites</a>
                              <a v-if='account.addonIndex === null && account.solusVM_VPS_ID' class="dropdown-item"
                                 href="javascript:void(0)"
                                 @click.prevent="runFsckOnServer(account, index)">Run FSCK on Server</a>
                              <a v-if="account.type === 'Primary Domain'"
                                 :class="processingDomainList.length!==0 ? 'disabled' : '' "
                                 class="dropdown-item" href="javascript:void(0)"
                                 @click.prevent="disableBackupAccess(account)">{{
                                  account.disableBackupAccess ? 'Enable' : 'Disable'
                                }} Backup Access</a>
                              <a v-if="account.type === 'Primary Domain' && !backupFlagsComputed.includes(account.hbServiceID)"
                                 class="dropdown-item" href="javascript:void(0)"
                                 @click.prevent="setBackupFlag(account, true)">Enable New Backup Flag </a>
                              <!--                                                      <a v-if="account.type === 'Primary Domain' && backupFlagsComputed.includes(account.hbServiceID)" class="dropdown-item" href="javascript:void(0)" @click.prevent="setBackupFlag(account, false)">Disable New Backup Flag </a>-->
                              <a v-if="account.type === 'Primary Domain'" class="dropdown-item disabled"
                                 href="javascript:void(0)" @click.prevent="initializeBackup(index)">Initialize
                                Backup </a>
                              <a v-if="account.type === 'Primary Domain' && (user.email.includes('khan@') || user.email.includes('justin@') || user.email.includes('sara@'))"
                                 :class="{'disabled': backupFlagsComputed.includes(account.hbServiceID)}"
                                 class="dropdown-item"
                                 href="javascript:void(0)" @click.prevent="initializeNewBackup(account,index)">Initialize
                                New Backup </a>
                              <a v-if="account.type === 'Primary Domain'"
                                 :class="processingDomainList.length!==0 ? 'disabled' : '' "
                                 class="dropdown-item" href="javascript:void(0)"
                                 @click.prevent="openMovePlanModal(account)">Move Plan</a>
                              <a v-if="account.installation_type === 'staging'"
                                 :class="processingDomainList.length!==0 ? 'disabled' : '' " class="dropdown-item"
                                 href="javascript:void(0)" @click.prevent="moveToActive(account, index)">Move To
                                Active</a>
                              <a v-if="account.installation_type !== 'staging'"
                                 :class="processingDomainList.length!==0 ? 'disabled' : '' "
                                 class="dropdown-item" href="javascript:void(0)"
                                 @click.prevent="monitorAction(account, index)">{{
                                  account.addonIndex === null ? 'Monitors Management' : (account.monitorId ? `Recreate Zabbix Monitor` : `Create Zabbix Monitor`)
                                }}</a>
                              <a class="dropdown-item" href="javascript:void(0)"
                                 @click="refreshDomainTags(account, index)">Refresh Domain Tags</a>
                              <a class="dropdown-item" href="javascript:void(0)"
                                 @click="syncPatchStackPlugins(account, index)">Sync PatchStack</a>
                              <a class="dropdown-item" href="javascript:void(0)" @click="syncVersions(account, index)">Sync
                                PHP/WP/Updates</a>
                              <a class="dropdown-item" href="javascript:void(0)"
                                 @click="runScriptAccountItem(account, true)">Sync FTP / DB</a>
                              <a v-if="account.type === 'Primary Domain'" class="dropdown-item"
                                 href="javascript:void(0)" @click.prevent="storageCosting(account, index)">Storage
                                Costing</a>
                              <!--                                                        <a class="dropdown-item" href="javascript:void(0)" @click="openTicketModal(account, index)">Open New Ticket</a>-->
                              <a v-if="account.type === 'Primary Domain'"
                                 :class="processingDomainList.length!==0 ? 'disabled' : '' "
                                 class="dropdown-item" href="javascript:void(0)"
                                 @click.prevent="account.vmType === 'lxd' ? syncLxdDetails(account) : syncVPSDetails(account)">Sync Service Details</a>
                              <a class="dropdown-item" href="javascript:void(0)"
                                 @click.prevent="openTempDomainModal(account)">Temporary Link</a>
                              <!--                                                        <a v-if="account.type === 'Primary Domain'" class="dropdown-item" href="javascript:void(0)" @click.prevent="initZabbix(account, index)">Initialize Zabbix</a>-->
                              <a v-if="account.type === 'Primary Domain'" class="dropdown-item"
                                 href="javascript:void(0)" @click.prevent="updateSearchIndex(index)">Update Search
                                Index</a>
                              <a v-if="account.type === 'Primary Domain'" class="dropdown-item"
                                 href="javascript:void(0)" @click.prevent="openIPModal(account)">Update IP</a>
                              <!--                                                        <a v-if="account.installation_type !== 'staging'" class="dropdown-item" href="javascript:void(0)" @click.prevent="createStatusCake(account, index)">Create Status Cake Test</a>-->
                              <a class="dropdown-item" href="javascript:void(0)"
                                 @click.prevent="updateCF(account, index)">Update CF Status</a>
                              <a class="dropdown-item" href="javascript:void(0)"
                                 @click="checkCloudflareSettings(account, index)">Update Cloudflare Settings</a>
                              <a class="dropdown-item" href="javascript:void(0)"
                                 @click.prevent="redirectToGraph(account)">View Monitor Graph</a>
                              <a class="dropdown-item" href="javascript:void(0)"
                                 @click.prevent="getWhoIsInformation(account)">WHOIS Information</a>
                            </div>
                          </div>
                          <!-- Modal -->
                          <div :id="`autoPopulateModal${index}`" :aria-labelledby="`autoPopulateModal${index}`"
                               aria-hidden="true" class="modal fade"
                               role="dialog" tabindex="-1">
                            <div class="modal-dialog" role="document">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <h5 class="modal-title d-inline">Auto Populate Details - {{ account.domain }}</h5>
                                  <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div class="modal-body">
                                  <div class="form-group">
                                    <label for="auto-populate-textarea">
                                      Enter the auto population data in JSON (
                                      <a href="https://gist.github.com/isaumya/12e386a9512947d1acac5a16b177b57d"
                                         rel="external nofollow" target="_blank" title="Example Format">Example
                                        Format</a>)
                                    </label>
                                    <textarea id="auto-populate-textarea" v-model="account.autopopulateData"
                                              class="form-control"
                                              rows="10"></textarea>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button class="btn btn-secondary" data-dismiss="modal" type="button">Close</button>
                                  <button class="btn btn-primary" data-dismiss="modal" type="button"
                                          @click.prevent="autoPopulateData(account.autopopulateData, index)">Populate
                                    Fields
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                        <!--                                            <li v-if="!account.statusCakeTestId" class="list-inline-item">-->
                        <!--                                                <div class="dropdown">-->
                        <!--                                                    <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
                        <!--                                                        Create-->
                        <!--                                                    </button>-->
                        <!--                                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2">-->
                        <!--                                                        <a class="dropdown-item" href="javascript:void(0)" @click.prevent="runScriptAccountItem(index, true)">Fresh Install</a>-->
                        <!--                                                        <a class="dropdown-item" href="javascript:void(0)" @click.prevent="runScriptAccountItem(index, false)">Non-Fresh Install</a>-->
                        <!--                                                    </div>-->
                        <!--                                                </div>-->
                        <!--                                            </li>-->
                        <li class="list-inline-item">
                          <button :disabled="removeLoader" class="btn btn-sm btn-danger"
                                  @click.prevent="deleteAccountItem(account)">
                            <span v-if="!removeLoader">Remove</span>
                            <i v-else aria-hidden="true" class="fa mr-1 fa-spinner"></i>
                          </button>
                        </li>
                        <!--                                          <li @click="openNotesModal(account)" class="list-inline-item"><button class="btn btn-sm btn-default"> <i  class="fa" :class="(account.notes && account.notes.length > 0) ? 'fa-pencil' : 'fa-plus'"></i> Notes</button></li>-->

                      </ul>
                    </section>
                  </div>
                </div>
              </div>

              <div :id="'collapse_' + index" class="collapse" data-parent="#accordionExample">
                <div class="card-body">
                  <h5>Account Details</h5>
                  <!-- Auto Populate Button Section - End -->
                  <div class="row">
                    <div class="form-group col-md-4">
                      <label>Domain Name<strong class="text-danger">*</strong></label>
                      <div class="input-group plan-limit" style="position: relative;">
                        <input v-model.trim="account.domain" class="form-control planlimit-input" readonly type="text">
                        <div class="lock">
                          <Lock :lock="lockDomain" style="right: 15%; top: 18%; position: relative;"
                                @click="unlockDomain(account)"/>
                        </div>
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.domain)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <!--                                  <div class="form-group col-md-4">-->
                    <!--                                      <label>Domain Name<strong class="text-danger">*</strong></label>-->
                    <!--                                      <div class="input-group plan-limit" style="position: relative;">-->
                    <!--                                        <input type="text" class="form-control planlimit-input" readonly v-model.trim="account.domain">-->
                    <!--&lt;!&ndash;                                        <input type="number" class="form-control planlimit-input"  :readonly="lockPlanLimit" v-model.number="account.planLimit">&ndash;&gt;-->
                    <!--                                        <div :class="{ lock: lockPlanLimit , unlock: lockPlanLimit == false}"></div>-->
                    <!--                                        <Lock style="right: 15%; top: 18%; position: relative;" :lock="lockPlanLimit" @click="unlock()"/>-->
                    <!--                                      </div>-->
                    <!--                                    <div class="input-group-append">-->
                    <!--                                      <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.domain)"><i class="fa fa-copy"></i></button>-->
                    <!--                                    </div>-->
                    <!--                                  </div>-->
                    <div class="form-group col-md-4">
                      <label>Server IP</label>
                      <div class="input-group">
                        <input v-model.trim="account.serverIP" class="form-control" type="text"/>
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.serverIP)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <div v-if="account.type === 'Primary Domain'" class="form-group col-md-4">
                      <label>Plan Name<strong class="text-danger">*</strong></label>
                      <div class="input-group">
                        <select v-model="account.planName" class="custom-select blue-select" required
                                @change="planLimitCountGenerator(account.planName, index, account)">
                          <!--                                              <option v-for="plan in plans" :key="plan.name" :value="plan.name">{{plan.name}}</option>-->
                          <optgroup
                              v-for="(category, index) in modifiedPlans"
                              :key="index"
                              :label="category.name"
                          >
                            <option
                                v-for="option in category.options"
                                :key="option.name"
                                :value="option.name"
                            >
                              {{ option.name }}
                            </option>
                          </optgroup>
                        </select>
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.planName)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-4">
                      <label>Account Status
                        <strong class="text-danger">*</strong>
                      </label>
                      <div class="input-group">
                        <select v-model="account.status"
                                :class="{ 'red-select': (account.status === 'pending'), 'green-select': (account.status === 'active') }"
                                class="custom-select blue-select"
                                @change="updateStatusCake($event, account, index)">
                          <option selected value="pending">Pending</option>
                          <option value="active">Active</option>
                        </select>
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.status)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <!--                                  <div class="form-group col-md-4">-->
                    <!--                                      <label>Comparison ID</label>-->
                    <!--                                      <div class="input-group">-->
                    <!--                                          <input type="number" class="form-control" v-model.number="account.comparisonID">-->
                    <!--                                          <div class="input-group-append">-->
                    <!--                                              <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.comparisonID)"><i class="fa fa-copy"></i></button>-->
                    <!--                                          </div>-->
                    <!--                                      </div>-->
                    <!--                                  </div>-->

                    <div v-if="account.type=='Primary Domain'" class="form-group col-md-4">
                      <label>Plan Type
                        <strong class="text-danger">*</strong>
                      </label>
                      <div class="input-group">
                        <select v-model="account.planType" class="custom-select blue-select">
                          <option selected value="standalone">Standalone</option>
                          <option value="multisite">Multisite</option>
                          <option value="hybrid">Hybrid</option>
                          <option value="whale">Whale</option>
                        </select>
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.planType)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>Account Type
                        <strong class="text-danger">*</strong>
                      </label>
                      <div class="input-group">
                        <select v-model="account.type" class="custom-select blue-select"
                                @click="clearAddonPrimaryDomain(account.type, index)">
                          <option selected value="Primary Domain">Primary Domain</option>
                          <option value="Addon Domain">Addon Domain</option>
                        </select>
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.type)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <div v-if="account.planType === 'hybrid'" class="form-group col-md-4">
                      <label>Site Type
                        <strong class="text-danger">*</strong>
                      </label>
                      <div class="input-group">
                        <select v-model="account.siteType" class="custom-select blue-select">
                          <option selected value="standalone">Standalone</option>
                          <option value="multisite">Multisite</option>
                        </select>
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.siteType)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div v-if="account.type === 'Addon Domain'" class="form-group col-md-4">
                      <label>Primary Domain Name
                        <strong class="text-danger">*</strong>
                        <i class="fa fa-question-circle ml-2 text-dark" data-placement="top" data-toggle="tooltip"
                           title="Make sure you enter the domain name EXACTLY as mentioned in the domain name section of the primary domain. Simply copy paste it to be sure."></i>
                      </label>

                      <div class="input-group">
                        <select v-model="account.addonPrimaryPlan" class="custom-select blue-select">
                          <option disabled selected value="">Select Primary Domain</option>
                          <option v-for="(acc, index) of realHostingAccounts" :key="index"
                                  :value="acc.primary.domain + ':' + acc.primary.serverIP">
                            {{ acc.primary.domain + ' ( ' + acc.primary.serverIP + ' )' }}
                          </option>
                        </select>
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button"
                                  @click="doCopy(getDomain(account.addonPrimaryPlan))"><i class="fa fa-copy"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div v-if="account.type === 'Primary Domain'" class="form-group col-md-4 ">
                      <label>Plan Limit
                        <strong class="text-danger">*</strong>
                      </label>
                      <div class="input-group plan-limit" style="position: relative;">
                        <input v-model.number="account.planLimit" :readonly="lockPlanLimit"
                               class="form-control planlimit-input"
                               type="number">
                        <div :class="{ lock: lockPlanLimit , unlock: lockPlanLimit == false}">
                          <Lock :lock="lockPlanLimit" style="right: 15%; top: 18%; position: relative;"
                                @click="unlock()"/>
                        </div>
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.planLimit)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                      </div>
                      <span
                          v-if="account.type='Primary Domain'"><small>Total Sites Used: {{
                          getUsedLimit(realHostingAccounts, account.planIndex)
                        }}</small></span>
                    </div>
                    <div v-if="account.type === 'Primary Domain'" class="form-group col-md-4">
                      <label>Extra Sites
                        <strong class="text-danger">*</strong>
                      </label>
                      <div class="input-group">
                        <input v-model.number="account.extraDomains" :disabled="account.planType === 'multisite'"
                               class="form-control" required
                               type="number">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.extraDomains)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <div v-if="account.planType === 'multisite'" class="form-group col-md-4">
                      <label>Max Sub-Sites Limit
                        <strong class="text-danger">*</strong>
                      </label>
                      <div class="input-group">
                        <input v-model.number="account.maxSubSitesLimit" class="form-control" required type="number">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button"
                                  @click="doCopy(account.maxSubSitesLimit)"><i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                      <!--                                  <span v-if="account.type='Primary Domain'"><small>Sub-sites used: {{}}</small></span>-->
                    </div>
                    <div v-if="account.planType === 'hybrid' && account.siteType === 'multisite'"
                         class="form-group col-md-4">
                      <label>Max Sub-Sites Limit
                        <strong class="text-danger">*</strong>
                      </label>
                      <div class="input-group">
                        <input v-model.number="account.maxSubSitesAddonLimit" class="form-control" required
                               type="number">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button"
                                  @click="doCopy(account.maxSubSitesAddonLimit)"><i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                      <!--                                  <span v-if="account.type='Primary Domain'"><small>Sub-sites used: {{}}</small></span>-->
                    </div>
                    <div v-if="account.type === 'Primary Domain'" class="form-group col-md-4">
                      <label>Max Storage Size (GB)
                        <strong class="text-danger">*</strong>
                      </label>
                      <div class="input-group">
                        <input v-model.number="account.maxStorageSize" class="form-control" required type="number">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.maxStorageSize)">
                            <i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <div v-else class="form-group col-md-4">
                      <label>Cloudflare Plan
                        <strong class="text-danger">*</strong>
                      </label>
                      <div class="input-group" style="flex-wrap: nowrap">
                        <multiselect v-model="account.cloudflarePlan" :clear-on-select="false"
                                     :close-on-select="false" :group-label="'label'" :group-values="'options'"
                                     :multiple="true"
                                     :options="mediavineCfPlans" :preselect-first="false" :preserve-search="true"
                                     class="multiselect-custom" placeholder="Select Cloudflare Plan"
                                     @select="removeOption($event, account)">
                          <template #tag="{ option, remove }">
                                          <span class="custom__tag make-cursor-pointer">
                                            <span class="d-flex align">
                                              <span class="ml-3 pb-4 badge badge-pill badge-primary"
                                                    style="text-transform: none; font-size: 13px; font-weight: 500">{{
                                                  getValidOption(option)
                                                }}</span>
                                              <span class="custom__remove fs-12 m-l-4 has-text-danger"
                                                    @click.stop="remove(option)"><i
                                                  class="fa text-danger ml-5 fa-times-circle"></i></span>
                                            </span>
                                          </span>
                          </template>
                          <template #option="props">
                            <div class="d-flex align">
                              <div class="option__desc">
                                <span class="option__title m-l-10">{{ getValidOption(props.option) }}</span>
                              </div>
                            </div>
                          </template>
                        </multiselect>
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.cloudflarePlan)">
                            <i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>Max Visitors
                        <strong class="text-danger">*</strong>
                      </label>
                      <div class="input-group">
                        <input v-model.number="account.maxVisitors" class="form-control" required type="number">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.maxVisitors)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="account.type === 'Primary Domain'" class="row">
                    <div class="form-group col-md-4">
                      <label>Max Migrations</label>
                      <div class="input-group">
                        <input v-model.number="account.maxMigrations" class="form-control" type="number">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.maxMigrations)">
                            <i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                      <span
                          v-if="account.type=='Primary Domain'"><small>Migrations used: {{
                          account.migration ? account.migration.count : 0
                        }}</small></span>
                    </div>
                    <div class="form-group col-md-4">
                      <label>Cloudflare Plan
                        <strong class="text-danger">*</strong>
                      </label>
                      <div class="input-group" style="flex-wrap: nowrap">
                        <multiselect v-model="account.cloudflarePlan" :clear-on-select="false"
                                     :close-on-select="false" :group-label="'label'" :group-values="'options'"
                                     :multiple="true" :options="mediavineCfPlans" :preselect-first="false"
                                     :preserve-search="true" placeholder="Select Cloudflare Plan"
                                     @select="removeOption($event, account)">
                          <template #tag="{ option, remove }">
                                          <span class="custom__tag make-cursor-pointer">
                                            <span class="d-flex align">
                                              <span class="ml-3 pb-4 badge badge-pill badge-primary"
                                                    style="text-transform: none; font-size: 13px; font-weight: 500">{{
                                                  getValidOption(option)
                                                }}</span>
                                              <span class="custom__remove fs-12 m-l-4 has-text-danger"
                                                    @click.stop="remove(option)"><i
                                                  class="fa text-danger ml-5 fa-times-circle"></i></span>
                                            </span>
                                          </span>
                          </template>
                          <template #option="props">
                            <div class="d-flex align">
                              <div class="option__desc">
                                <span class="option__title m-l-10">{{ getValidOption(props.option) }}</span>
                              </div>
                            </div>
                          </template>
                        </multiselect>
                        <!--                                      <select  class="custom-select blue-select" v-model="account.cloudflarePlan">-->
                        <!--                                        <option selected value="none">None</option>-->
                        <!--                                        <option value="mediavine_performance">Mediavine Performance</option>-->
                        <!--                                        <option value="mediavine_security">Mediavine Security</option>-->
                        <!--                                        <option value="cloudflare_enterprise">Cloudflare Enterprise</option>-->
                        <!--                                      </select>-->
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.cloudflarePlan)">
                            <i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>Last Updated Visitors
                        <strong class="text-danger">*</strong>
                      </label>
                      <div class="input-group">
                        <input v-model="account.last_updated" class="form-control" required type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.last_updated)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-4">
                      <label>Site UUID
                        <strong class="text-danger">*</strong>
                      </label>
                      <div class="input-group">
                        <input v-model="account.uuid" class="form-control" disabled required type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.uuid)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h5 v-if="account.type === 'Primary Domain'">Service Details</h5>
                  <div v-if="account.type === 'Primary Domain'" class="row">

                    <div class="form-group col-md-4">
                      <label>Hostbill Service ID</label>
                      <div class="input-group">
                        <input v-model.trim="account.hbServiceID" class="form-control" type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.hbServiceID)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>Hostname</label>
                      <div class="input-group">
                        <input disabled v-model.trim="account.hbHostname" class="form-control" type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.hbHostname)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <template v-if="nodeLoader && selectedIndexForNode === index">
                      <div v-for="i in 3" :key="i" class="col-md-4 form-group">
                        <div class="mb-3">
                          <div class="skeleton skeleton-label mb-2"></div>
                          <div class="skeleton skeleton-input"></div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="form-group col-md-4">
                        <label>Virtualization Type</label>
                        <div class="input-group">
                          <input v-model.trim="account.vmType" class="form-control" readonly type="text">
                          <div class="input-group-append">
                            <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.vmType)"><i
                                class="fa fa-copy"></i></button>
                          </div>
                        </div>
                      </div>
                      <template v-if="!account.vmType || account.vmType === 'openvz/default'">
                        <div class="form-group col-md-4">
                          <label>SolusVM VPS ID</label>
                          <div class="input-group">
                            <input v-model.trim="account.solusVM_VPS_ID" class="form-control" readonly type="text">
                            <div class="input-group-append">
                              <button class="btn btn-primary cpy-btn" type="button"
                                      @click="doCopy(account.solusVM_VPS_ID)">
                                <i class="fa fa-copy"></i></button>
                            </div>
                          </div>
                        </div>
                        <div class="form-group col-md-4">
                          <label>Hostname</label>
                          <div class="input-group">
                            <input v-model.trim="account.hbHostname" class="form-control" readonly type="text">
                            <div class="input-group-append">
                              <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.hbHostname)">
                                <i
                                    class="fa fa-copy"></i></button>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-if="account.vmType === 'lxd'">
                        <div class="form-group col-md-4">
                          <label>Instance Name</label>
                          <div class="input-group">
                            <input v-model.trim="account.instance" class="form-control" readonly type="text">
                            <div class="input-group-append">
                              <button class="btn btn-primary cpy-btn" type="button"
                                      @click="doCopy(account.instance)">
                                <i class="fa fa-copy"></i></button>
                            </div>
                          </div>
                        </div>
                        <div class="form-group col-md-4">
                          <label>Cluster</label>
                          <div class="input-group">
                            <input v-model.trim="account.cluster" class="form-control" readonly type="text">
                            <div class="input-group-append">
                              <button class="btn btn-primary cpy-btn" type="button"
                                      @click="doCopy(account.cluster)">
                                <i class="fa fa-copy"></i></button>
                            </div>
                          </div>
                        </div>
                        <div class="form-group col-md-4">
                          <label>Location</label>
                          <div class="input-group">
                            <input v-model.trim="account.datacenter" class="form-control" readonly type="text">
                            <div class="input-group-append">
                              <button class="btn btn-primary cpy-btn" type="button"
                                      @click="doCopy(account.datacenter)">
                                <i class="fa fa-copy"></i></button>
                            </div>
                          </div>
                        </div>
                        <div class="form-group col-md-4">
                          <label>Node Name</label>
                          <div class="input-group">
                            <input v-model.trim="account.nodeName" class="form-control" readonly type="text">
                            <div class="input-group-append">
                              <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.nodeName)"><i
                                  class="fa fa-copy"></i></button>
                            </div>
                            <div v-if="selectedIndexForNode===index && nodeLoader"
                                 class="loader small_loader pull-rightl ml-2" style="width: 25px;height:25px"></div>
                          </div>
                        </div>
                        <div class="form-group col-md-4">
                          <label>Rack Name</label>
                          <div class="input-group">
                            <input v-model.trim="account.rack" class="form-control" readonly type="text">
                            <div class="input-group-append">
                              <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.rack)"><i
                                  class="fa fa-copy"></i></button>
                            </div>
                            <div v-if="selectedIndexForNode===index && nodeLoader"
                                 class="loader small_loader pull-rightl ml-2" style="width: 25px;height:25px"></div>
                          </div>
                        </div>
                      </template>
                    </template>
                  </div>
                  <div
                      v-if="account.type === 'Primary Domain' && (!account.vmType || account.vmType === 'openvz/default') && !nodeLoader"
                      class="row">
                    <div class="form-group col-md-4">
                      <label>Node Name</label>
                      <div class="input-group">
                        <input v-model.trim="account.nodeName" class="form-control" readonly type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.nodeName)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                        <div v-if="selectedIndexForNode===index && nodeLoader"
                             class="loader small_loader pull-rightl ml-2" style="width: 25px;height:25px"></div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>Node Free Disk (GB)</label>
                      <div class="input-group">
                        <input v-model.trim="account.nodeFreeDisk" class="form-control" readonly type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.nodeFreeDisk)">
                            <i
                                class="fa fa-copy"></i></button>
                        </div>
                        <div v-if="selectedIndexForNode===index && nodeLoader"
                             class="loader small_loader pull-rightl ml-2" style="width: 25px;height:25px"></div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>Rack</label>
                      <div class="input-group">
                        <input v-model.trim="account.rack" class="form-control" readonly type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.rack)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                        <div v-if="selectedIndexForNode===index && nodeLoader"
                             class="loader small_loader pull-rightl ml-2" style="width: 25px;height:25px"></div>
                      </div>
                    </div>
                  </div>
                  <div v-if="account.type === 'Primary Domain' && account.hdd && account.vmType !== 'lxd'" class="row">
                    <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">SolusVM Disk Space (GB)</label>
                    <div class="col-sm-10 col-md-3 col-lg-3">
                      <div class="input-group">
                        <input :value="showNice(account.hdd.used)" class="form-control" name="used" readonly
                               type="text"/>
                        <b class="mt-2 ml-3 mr-3">Of</b>
                        <input :value="showNice(account.hdd.total)" class="form-control" name="total" readonly
                               type="text"/>
                        <div class="input-group-append">
                          <button class="btn btn-primary btn-sm" data-target="#changeHddModal" data-toggle="modal"
                                  style="margin: 0" type="button" @click="openChangeHddModal(account)"><i
                              class="fa fa-pencil"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="account.type === 'Primary Domain' && account.hdd && account.vmType === 'lxd'" class="row">
                    <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Disk Space (GB)</label>
                    <div class="col-sm-10 col-md-3 col-lg-3">
                      <div class="input-group">
                        <input :value="(account.hdd.used)" class="form-control" name="used" readonly
                               type="text"/>
                        <b class="mt-2 ml-3 mr-3">Of</b>
                        <input :value="(account.hdd.total)" class="form-control" name="total" readonly
                               type="text"/>
                        <div class="input-group-append">
                          <button class="btn btn-primary btn-sm" data-target="#changeHddModal" data-toggle="modal"
                                  style="margin: 0" type="button" @click="openChangeHddModal(account)"><i
                              class="fa fa-pencil"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--                                <h5>FTP Details - <small><a data-toggle="tooltip" title="Copy All" @click="doCopyFTP(account.ftp)" href="javascript:void(0)"><i class="fa fa-copy"></i></a></small></h5>-->
                  <!--                                <div class="row">-->
                  <!--                                    <div class="form-group col-md-4">-->
                  <!--                                        <label>FTP Hostname</label>-->
                  <!--                                        <div class="input-group">-->
                  <!--                                            <input type="text" class="form-control" v-model.trim="account.ftp.host">-->
                  <!--                                            <div class="input-group-append">-->
                  <!--                                                <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.ftp.host)"><i class="fa fa-copy"></i></button>-->
                  <!--                                            </div>-->
                  <!--                                        </div>-->
                  <!--                                    </div>-->
                  <!--                                    <div class="form-group col-md-4">-->
                  <!--                                        <label>FTP Port</label>-->
                  <!--                                        <div class="input-group">-->
                  <!--                                            <input type="text" class="form-control" v-model.trim="account.ftp.port">-->
                  <!--                                            <div class="input-group-append">-->
                  <!--                                                <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.ftp.port)"><i class="fa fa-copy"></i></button>-->
                  <!--                                            </div>-->
                  <!--                                        </div>-->
                  <!--                                    </div>-->
                  <!--                                    <div class="form-group col-md-4">-->
                  <!--                                        <label>FTP Mode</label>-->
                  <!--                                        <div class="input-group">-->
                  <!--                                            <input type="text" class="form-control" v-model.trim="account.ftp.mode">-->
                  <!--                                            <div class="input-group-append">-->
                  <!--                                                <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.ftp.mode)"><i class="fa fa-copy"></i></button>-->
                  <!--                                            </div>-->
                  <!--                                        </div>-->
                  <!--                                    </div>-->
                  <!--                                </div>-->
                  <!--                                <div class="row">-->
                  <!--                                    <div class="form-group col-md-4">-->
                  <!--                                        <label>FTP Passive (PASV)</label>-->
                  <!--                                        <div class="input-group">-->
                  <!--                                            <input type="text" class="form-control" v-model.trim="account.ftp.pasv">-->
                  <!--                                            <div class="input-group-append">-->
                  <!--                                                <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.ftp.pasv)"><i class="fa fa-copy"></i></button>-->
                  <!--                                            </div>-->
                  <!--                                        </div>-->
                  <!--                                    </div>-->
                  <!--                                    <div class="form-group col-md-4">-->
                  <!--                                        <label>FTP Username</label>-->
                  <!--                                        <div class="input-group">-->
                  <!--                                            <input type="text" class="form-control" v-model.trim="account.ftp.username">-->
                  <!--                                            <div class="input-group-append">-->
                  <!--                                                <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.ftp.username)"><i class="fa fa-copy"></i></button>-->
                  <!--                                            </div>-->
                  <!--                                        </div>-->
                  <!--                                    </div>-->
                  <!--                                    <div class="form-group col-md-4">-->
                  <!--                                        <label>FTP Password</label>-->
                  <!--                                        <div class="input-group">-->
                  <!--                                            <input type="text" class="form-control" v-model.trim="account.ftp.password">-->
                  <!--                                            <div class="input-group-append">-->
                  <!--                                                <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.ftp.password)"><i class="fa fa-copy"></i></button>-->
                  <!--                                            </div>-->
                  <!--                                        </div>-->
                  <!--                                    </div>-->
                  <!--                                     <div class="form-group col-md-4">-->
                  <!--                                        <label>FTP Homepath</label>-->
                  <!--                                        <div class="input-group">-->
                  <!--                                            <input type="text"  class="form-control"  v-model.trim="account.home_path">-->
                  <!--                                            <div class="input-group-append">-->
                  <!--                                                <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.home_path)"><i class="fa fa-copy"></i></button>-->
                  <!--                                            </div>-->
                  <!--                                        </div>-->
                  <!--                                    </div>-->
                  <!--                                </div>-->
                  <h5>PHP-My-Admin Details - <small><a data-toggle="tooltip" href="javascript:void(0)"
                                                       title="Copy All"
                                                       @click="doCopyPhpMyAdmin(account.phpMyAdmin, account.primaryPhpMyAdmin)"><i
                      class="fa fa-copy"></i></a></small>
                  </h5>
                  <!-- phpMyAdmin Details -->
                  <div v-if="account.type==='Primary Domain'" class="row">
                    <div class="form-group col-md-4">
                      <label>phpMyAdmin URL</label>
                      <div class="input-group">
                        <input v-model.trim="account.phpMyAdmin.url" class="form-control" type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.phpMyAdmin.url)">
                            <i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>phpMyAdmin Poup Username</label>
                      <div class="input-group">
                        <input v-model.trim="account.phpMyAdmin.popupUsername" class="form-control" type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button"
                                  @click="doCopy(account.phpMyAdmin.popupUsername)"><i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>phpMyAdmin Popup Password</label>
                      <div class="input-group">
                        <input v-model.trim="account.phpMyAdmin.popupPassword" class="form-control" type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button"
                                  @click="doCopy(account.phpMyAdmin.popupPassword)"><i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-4">
                      <label>phpMyAdmin Username</label>
                      <div class="input-group">
                        <input v-model.trim="account.phpMyAdmin.username" class="form-control" type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button"
                                  @click="doCopy(account.phpMyAdmin.username)"><i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>phpMyAdmin Password</label>
                      <div class="input-group">
                        <input v-model.trim="account.phpMyAdmin.password" class="form-control" type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button"
                                  @click="doCopy(account.phpMyAdmin.password)"><i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h5>Cloudflare Details - <small><a data-toggle="tooltip" href="javascript:void(0)"
                                                     title="Copy All"
                                                     @click="doCopyCloudFlare(account.cloudflare)"><i
                      class="fa fa-copy"></i></a></small>
                  </h5>
                  <!-- Section to show Cloudflare Details -->
                  <div class="row">
                    <div class="form-group col-md-4">
                      <label>Cloudflare Username</label>
                      <div class="input-group">
                        <input v-model.trim="account.cloudflare.username" class="form-control" type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button"
                                  @click="doCopy(account.cloudflare.username)"><i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>Cloudflare Password</label>
                      <div class="input-group">
                        <input v-model.trim="account.cloudflare.password" class="form-control" type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button"
                                  @click="doCopy(account.cloudflare.password)"><i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <!--                                    <div class="form-group col-md-4">-->
                    <!--                                        <label>Cloudflare Userkey</label>-->
                    <!--                                        <div class="input-group">-->
                    <!--                                            <input type="text" class="form-control" v-model.trim="account.cloudflare.userKey">-->
                    <!--                                            <div class="input-group-append">-->
                    <!--                                                <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.cloudflare.userKey)"><i class="fa fa-copy"></i></button>-->
                    <!--                                            </div>-->
                    <!--                                        </div>-->
                    <!--                                    </div>-->
                    <div class="form-group col-md-4">
                      <label>Cloudflare Nameserver 1</label>
                      <div class="input-group">
                        <input v-model.trim="account.cloudflare.nameserver1" class="form-control" type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button"
                                  @click="doCopy(account.cloudflare.nameserver1)"><i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-4">
                      <label>Cloudflare Nameserver 2</label>
                      <div class="input-group">
                        <input v-model.trim="account.cloudflare.nameserver2" class="form-control" type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button"
                                  @click="doCopy(account.cloudflare.nameserver2)"><i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>Cloudflare API key</label>
                      <div class="input-group">
                        <input v-model.trim="account.cloudflare.apiKey" class="form-control" type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button"
                                  @click="doCopy(account.cloudflare.apiKey)"><i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>Cloudflare Zone id</label>
                      <div class="input-group">
                        <input v-model="account.cloudflare.zone_id" class="form-control" type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button"
                                  @click="doCopy(account.cloudflare.zone_id)"><i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>Cloudflare Account ID</label>
                      <div class="input-group">
                        <input v-model="account.cloudflare.accountID" class="form-control" type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button"
                                  @click="doCopy(account.cloudflare.accountID)"><i class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h5 v-if="account.type === 'Primary Domain'">Backup Server Details</h5>
                  <!-- Section to show Backup Details -->
                  <div v-if="account.type === 'Primary Domain'" class="row">
                    <div class="form-group col-md-4">
                      <label>Backup Server</label>
                      <div class="input-group">
                        <input v-model.trim="account.backupServer" :disabled="customerInfo.enableNewBackupProcess"
                               class="form-control"
                               type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.backupServer)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>Backup Username</label>
                      <div class="input-group">
                        <input v-model.trim="account.backupUser" :disabled="customerInfo.enableNewBackupProcess"
                               class="form-control"
                               type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.backupUser)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>Backup Limit</label>
                      <div class="input-group">
                        <input v-model.trim="account.backupLimit" :disabled="customerInfo.enableNewBackupProcess"
                               class="form-control"
                               type="text">
                        <div class="input-group-append">
                          <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.backupLimit)"><i
                              class="fa fa-copy"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr :class="{ 'color-line': account.staging.enabled }">
                  <!-- Section to hold the Staging Details - Start -->
                  <div v-if="account.staging.enabled === true" class="staging-details">
                    <div class="domain-head">
                      <h5 class="text-secondary">Staging Site Details for: {{ account.domain }}</h5>
                      <section>
                        <ul class="list-inline">
                          <li class="list-inline-item">
                            <div class="dropdown">
                              <button id="dropdownMenuButton3"
                                      :disabled="stagingLoading && operationIndex === index" aria-expanded="false"
                                      aria-haspopup="true" class="btn btn-secondary btn-sm dropdown-toggle"
                                      data-toggle="dropdown"
                                      type="button">
                                Choose Operation
                              </button>
                              <div aria-labelledby="dropdownMenuButton3" class="dropdown-menu">
                                <a :data-target="`#autoPopulateStagingModal${index}`" class="dropdown-item"
                                   data-toggle="modal"
                                   href="javascript:void(0)">Auto Populate the Staging
                                  Details</a>
                                <a class="dropdown-item" href="javascript:void(0)" @click="syncStaging(account, index)">Sync
                                  Staging Domian</a>
                              </div>
                            </div>
                            <!-- Staging Data Modal -->
                            <div :id="`autoPopulateStagingModal${index}`"
                                 :aria-labelledby="`autoPopulateStagingModal${index}`" aria-hidden="true"
                                 class="modal fade"
                                 role="dialog" tabindex="-1">
                              <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                  <div class="modal-header">
                                    <h5 class="modal-title d-inline">Auto Populate Staging Details - {{
                                        account.domain
                                      }}</h5>
                                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div class="modal-body">
                                    <div class="form-group">
                                      <label>
                                        Enter the auto population data in JSON (
                                        <a href="https://gist.github.com/isaumya/a790bba1ec586b5c0b2f478e6608d23f"
                                           rel="external nofollow" target="_blank" title="Example STAGING Data Format">Example
                                          Staging Data Format</a>)
                                      </label>
                                      <textarea v-model="account.staging.autopopulateData" class="form-control"
                                                rows="10"></textarea>
                                    </div>
                                  </div>
                                  <div class="modal-footer">
                                    <button class="btn btn-secondary" data-dismiss="modal" type="button">Close</button>
                                    <button class="btn btn-primary" data-dismiss="modal" type="button"
                                            @click.prevent="autoPopulateStagingData(account.staging.autopopulateData, index)">
                                      Populate Fields
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li v-if="account.staging.enabled === true" class="list-inline-item">
                            <button class="btn btn-sm btn-danger" @click.prevent="removeStagingAcc(index)">Remove
                            </button>
                          </li>
                        </ul>
                      </section>
                    </div>
                    <!-- Domain Name & Auto Populate Button -->
                    <div class="row">
                      <div class="form-group col-md-4">
                        <label>Staging Domain Name</label>
                        <div class="input-group">
                          <input v-model.trim="account.staging.domain" class="form-control" type="text">
                          <div class="input-group-append">
                            <button class="btn btn-primary cpy-btn" type="button"
                                    @click="doCopy(account.staging.domain)"><i class="fa fa-copy"></i></button>
                          </div>
                        </div>
                      </div>
                      <!--                                        <div class="form-group col-md-4">-->
                      <!--                                            <label>Staging Flush OPcache URL</label>-->
                      <!--                                            <div class="input-group">-->
                      <!--                                                <input type="url" class="form-control" v-model.trim="account.staging.flushOpcacheURL">-->
                      <!--                                                <div class="input-group-append">-->
                      <!--                                                    <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.staging.flushOpcacheURL)"><i class="fa fa-copy"></i></button>-->
                      <!--                                                </div>-->
                      <!--                                            </div>-->
                      <!--                                        </div>-->
                    </div>
                    <!--                                    <h5>Staging's FTP Details - <small><a data-toggle="tooltip" title="Copy All" @click="doCopyFTP(account.staging.ftp)" href="javascript:void(0)"><i class="fa fa-copy"></i></a></small></h5>-->
                    <!--                                    &lt;!&ndash; Staging FTP Details &ndash;&gt;-->
                    <!--                                    <div class="row">-->
                    <!--                                        <div class="form-group col-md-4">-->
                    <!--                                            <label>FTP Hostname</label>-->
                    <!--                                            <div class="input-group">-->
                    <!--                                                <input type="text" class="form-control" v-model.trim="account.staging.ftp.host">-->
                    <!--                                                <div class="input-group-append">-->
                    <!--                                                    <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.staging.ftp.host)"><i class="fa fa-copy"></i></button>-->
                    <!--                                                </div>-->
                    <!--                                            </div>-->
                    <!--                                        </div>-->
                    <!--                                        <div class="form-group col-md-4">-->
                    <!--                                            <label>FTP Port</label>-->
                    <!--                                            <div class="input-group">-->
                    <!--                                                <input type="text" class="form-control" v-model.trim="account.staging.ftp.port">-->
                    <!--                                                <div class="input-group-append">-->
                    <!--                                                    <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.staging.ftp.port)"><i class="fa fa-copy"></i></button>-->
                    <!--                                                </div>-->
                    <!--                                            </div>-->
                    <!--                                        </div>-->
                    <!--                                        <div class="form-group col-md-4">-->
                    <!--                                            <label>FTP Mode</label>-->
                    <!--                                            <div class="input-group">-->
                    <!--                                                <input type="text" class="form-control" v-model.trim="account.staging.ftp.mode">-->
                    <!--                                                <div class="input-group-append">-->
                    <!--                                                    <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.staging.ftp.mode)"><i class="fa fa-copy"></i></button>-->
                    <!--                                                </div>-->
                    <!--                                            </div>-->
                    <!--                                        </div>-->
                    <!--                                    </div>-->
                    <!--                                    <div class="row">-->
                    <!--                                        <div class="form-group col-md-4">-->
                    <!--                                            <label>FTP Passive (PASV)</label>-->
                    <!--                                            <div class="input-group">-->
                    <!--                                                <input type="text" class="form-control" v-model.trim="account.staging.ftp.pasv">-->
                    <!--                                                <div class="input-group-append">-->
                    <!--                                                    <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.staging.ftp.pasv)"><i class="fa fa-copy"></i></button>-->
                    <!--                                                </div>-->
                    <!--                                            </div>-->
                    <!--                                        </div>-->
                    <!--                                        <div class='form-group col-md-4'>-->
                    <!--                                            <label>FTP Username</label>-->
                    <!--                                            <div class="input-group">-->
                    <!--                                                <input type="text" class="form-control" v-model.trim="account.staging.ftp.username">-->
                    <!--                                                <div class="input-group-append">-->
                    <!--                                                    <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.staging.ftp.username)"><i class="fa fa-copy"></i></button>-->
                    <!--                                                </div>-->
                    <!--                                            </div>-->
                    <!--                                        </div>-->
                    <!--                                        <div class="form-group col-md-4">-->
                    <!--                                            <label>FTP Password</label>-->
                    <!--                                            <div class="input-group">-->
                    <!--                                                <input type="text" class="form-control" v-model.trim="account.staging.ftp.password">-->
                    <!--                                                <div class="input-group-append">-->
                    <!--                                                    <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.staging.ftp.password)"><i class="fa fa-copy"></i></button>-->
                    <!--                                                </div>-->
                    <!--                                            </div>-->
                    <!--                                        </div>-->
                    <!--                                    </div>-->
                    <h5>Staging's PHP-MY-ADMIN Details - <small><a data-toggle="tooltip" href="javascript:void(0)"
                                                                   title="Copy All"
                                                                   @click="doCopyPhpMyAdmin(account.staging.phpMyAdmin, account.primaryPhpMyAdmin)"><i
                        class="fa fa-copy"></i></a></small>
                    </h5>
                    <!-- Staging phpMyAdmin Details -->
                    <!--                                    <div class="row" v-if="account.type==='Primary Domain'">-->
                    <!--                                        <div class="form-group col-md-4">-->
                    <!--                                            <label>phpMyAdmin URL</label>-->
                    <!--                                            <div class="input-group">-->
                    <!--                                                <input type="text" class="form-control" v-model.trim="account.primaryPhpMyAdmin.url">-->
                    <!--                                                <div class="input-group-append">-->
                    <!--                                                    <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.primaryPhpMyAdmin.url)"><i class="fa fa-copy"></i></button>-->
                    <!--                                                </div>-->
                    <!--                                            </div>-->
                    <!--                                        </div>-->
                    <!--                                        <div class="form-group col-md-4">-->
                    <!--                                            <label>phpMyAdmin Poup Username</label>-->
                    <!--                                            <div class="input-group">-->
                    <!--                                                <input type="text" class="form-control" v-model.trim="account.primaryPhpMyAdmin.popupUsername">-->
                    <!--                                                <div class="input-group-append">-->
                    <!--                                                    <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.primaryPhpMyAdmin.popupUsername)"><i class="fa fa-copy"></i></button>-->
                    <!--                                                </div>-->
                    <!--                                            </div>-->
                    <!--                                        </div>-->
                    <!--                                        <div class="form-group col-md-4">-->
                    <!--                                            <label>phpMyAdmin Popup Password</label>-->
                    <!--                                            <div class="input-group">-->
                    <!--                                                <input type="text" class="form-control" v-model.trim="account.primaryPhpMyAdmin.popupPassword">-->
                    <!--                                                <div class="input-group-append">-->
                    <!--                                                    <button class="btn btn-primary cpy-btn" type="button" @click="doCopy(account.primaryPhpMyAdmin.popupPassword)"><i class="fa fa-copy"></i></button>-->
                    <!--                                                </div>-->
                    <!--                                            </div>-->
                    <!--                                        </div>-->
                    <!--                                    </div>-->
                    <div class="row">
                      <div class="form-group col-md-4">
                        <label>phpMyAdmin Username</label>
                        <div class="input-group">
                          <input v-model.trim="account.staging.phpMyAdmin.username" class="form-control" type="text">
                          <div class="input-group-append">
                            <button class="btn btn-primary cpy-btn" type="button"
                                    @click="doCopy(account.staging.phpMyAdmin.username)"><i class="fa fa-copy"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-md-4">
                        <label>phpMyAdmin Password</label>
                        <div class="input-group">
                          <input v-model.trim="account.staging.phpMyAdmin.password" class="form-control" type="text">
                          <div class="input-group-append">
                            <button class="btn btn-primary cpy-btn" type="button"
                                    @click="doCopy(account.staging.phpMyAdmin.password)"><i class="fa fa-copy"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-sm-2 col-form-label"></label>
                    <div class="col-sm-10">
                      <div class="form-group d-flex">
                        <div id="update_account_btn"
                             :title="processingDomainList.length > 0 ? 'Button is disabled because job is either pending or running.': ''"
                             data-toggle="tooltip">
                          <button :disabled="processingDomainList.length > 0" class="btn btn-success d-inline mr-5"
                                  type="submit"
                                  @click="updateHostingAccounts()">
                            <i aria-hidden="true" class="fa fa-cloud-upload mr-1"></i>
                            Update Account Details
                          </button>
                        </div>
                        <button v-if="account.staging.enabled === false" class="btn btn-primary"
                                type="button"
                                @click.prevent="account.staging.enabled = true">Add Staging Details - {{
                            account.domain
                          }}
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
              <span class="lh-3 pull-left">
                  Page {{ this.pageNumber + 1 }} of {{ pageCount }}
              </span>
          <section class="dataTables_paginate paging_full_numbers">
            <paginate
                ref="paginate"
                :clickHandler="goToPage"
                :nextText="'Next'"
                :pageCount="pageCount"
                :prevText="'Prev'"
                containerClass="pagination"
                next-class="page-item"
                next-link-class="page-link"
                page-class="page-item"
                page-link-class="page-link"
                prev-class="page-item"
                prev-link-class="page-link">
            </paginate>
          </section>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="text-center pt-20 mt-20">
        No Hosting Accounts Available!
      </div>
    </template>
    <!-- Modal -->
    <div id="changeHddModal" aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal fade" role="dialog"
         tabindex="-1">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="exampleModalLabel" class="modal-title">Update Disk Space</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Disk Space:</label>
              <input v-model="newHdd" :disabled="fieldDisable" class="form-control" min="1" type="number"/>
            </div>
          </div>
          <div class="modal-footer">
            <button v-if="!hddLoading" class="btn btn-primary" type="button"
                    @click="selectedAccountForHDDUpdate.vmType === 'lxd' ? diskUpdate() : updateHdd()">Update
            </button>
            <div v-else class="loader small_loader"></div>
          </div>
        </div>
      </div>
    </div>
    <swap-accounts-modal :docID="docID" :swapAccounts="realHostingAccounts"/>
    <update-ip-modal ref="IPModal" :docID="docID"/>
    <!--      <add-tag-modal ref="tagModal" :docID="docID" />-->
    <storage-modal ref="storageModal" :docID="docID"/>
    <whois-information-modal ref="whoisModal"/>
    <ticket-modal ref="ticketModal"/>
    <update-bulk-c-f-modal ref="updateBulkCFModal"/>
    <custom-sync-better-up-time-modal ref="customSyncBetterUpTimeModal"/>
    <temp-domain-modal ref="tempDomainModal"/>
    <bulk-domain-deletion-modal ref="bulkDomainDeletionModalRef"/>

  </section>
</template>

<script>
import {v4 as uuidv4} from 'uuid';
import {db} from "@/firebase/init";
import swal from "sweetalert2";
import delay from "delay";
import copyButtonMixin from '../../../../mixins/copyButtonMixin';
import swapAccountsModal from './swapAccountsModal';
import multiSelect from 'vue-multiselect'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Paginate from 'vuejs-paginate'
import UpdateIpModal from "@/components/Admin/EditUser/HostingDetailsUpdate/updateIpModal";
import addTagModal from "@/components/Admin/EditUser/HostingDetailsUpdate/addTagModal";
import storageModal from "@/components/Admin/EditUser/HostingDetailsUpdate/storageModal";
import whoisInformationModal from "@/components/Admin/EditUser/HostingDetailsUpdate/whoisInformationModal";
import ticketModal from "@/components/Admin/EditUser/HostingDetailsUpdate/ticketModal";
import updateBulkCFModal from "@/components/Admin/EditUser/HostingDetailsUpdate/updateBulkCFModal";
import tempDomainModal from "@/components/Admin/Tasks/showTempDomainModal";
import CustomSyncBetterUpTimeModal
  from "@/components/Admin/EditUser/HostingDetailsUpdate/customSyncBetterUpTimeModal.vue";
import BulkDomainDeletionModal from "@/components/Admin/EditUser/HostingDetailsUpdate/bulkDomainDeletionModal.vue";
import Lock from "@/assets/icons/Lock.vue"
import isValidDomain from "is-valid-domain";
import {getOrderedDomainDocs, isMultiDocUser} from '@/utils/firestoreUtils';

const validate = require('ip-validator');
export default {
  name: "NewHostingDetailsUpdate",
  mixins: [copyButtonMixin],
  components: {
    Multiselect,
    BulkDomainDeletionModal,
    CustomSyncBetterUpTimeModal,
    tempDomainModal,
    addTagModal,
    UpdateIpModal,
    multiSelect,
    Paginate,
    swapAccountsModal,
    whoisInformationModal,
    storageModal,
    ticketModal,
    updateBulkCFModal,
    Lock
  },

  data() {
    return {
      showItUID: 'KHLq1RjrpMT7aV0JY9fy2yrcYvT2',
      mediavineCfPlans: [
        {
          label: 'Regular',
          options: ['free', 'tier_1', 'tier_2', 'tier_3','boost', 'performance_package', 'performance_and_security_package']
        },
        {
          label: 'Mediavine',
          options: ['mediavine_performance', 'mediavine_security', 'mediavine_integration']
        },
        {
          label: 'New Performance Plans',
          options: ['optimization_pro', 'security_pro']
        },
      ],
      selectedCfPlans: [],
      realCloudflarePlans: {
        'Free': 'free',
        'Enterprise Tier 1': 'tier_1',
        'Enterprise Tier 2': 'tier_2',
        'Enterprise Tier 3': 'tier_3',
        'Boost': 'boost',
        'Performance Package': 'performance_package',
        'Performance & Security Package': 'performance_and_security_package',
        'Mediavine Performance': 'mediavine_performance',
        'Mediavine Security': 'mediavine_security',
        'Mediavine Integration': 'mediavine_integration',
        'Optimization Pro': 'optimization_pro',
        'Security Pro': 'security_pro',
      },
      convertedCfPlans: {
        'free': 'Free',
        'tier_1': 'Enterprise Tier 1',
        'tier_2': 'Enterprise Tier 2',
        'tier_3': 'Enterprise Tier 3',
        'performance_package': 'Performance Package',
        'boost': 'Boost',
        'performance_and_security_package': 'Performance & Security Package',
        'mediavine_performance': 'Mediavine Performance',
        'mediavine_security': 'Mediavine Security',
        'mediavine_integration': 'Mediavine Integration',
        'optimization_pro': 'Optimization Pro',
        'security_pro': 'Security Pro',
      },
      accountOrdered: [],
      accountLoader: false,
      colors: {
        0: {base: "#5B7CFB", bold: "#2954FA"},
        1: {base: "#FF5733", bold: "#CC4629"},
        2: {base: "#33FF57", bold: "#28CC46"},
        3: {base: "#008080", bold: "#006666"},
        4: {base: "#F39C12", bold: "#BF7E0E"},
        5: {base: "#8E44AD", bold: "#6F347E"},
        6: {base: "#2ECC71", bold: "#24A358"},
        7: {base: "#E74C3C", bold: "#B53B2F"},
        8: {base: "#3498DB", bold: "#287AB0"},
        9: {base: "#1ABC9C", bold: "#148F77"},
        10: {base: "#9B59B6", bold: "#7D4792"},
        11: {base: "#D35400", bold: "#A04300"},
        12: {base: "#27AE60", bold: "#208A4D"},
        13: {base: "#2980B9", bold: "#206494"},
        14: {base: "#C0392B", bold: "#992D22"},
        15: {base: "#16A085", bold: "#12856B"},
        16: {base: "#2C3E50", bold: "#1F2C38"},
        17: {base: "#E67E22", bold: "#B6611B"},
        18: {base: "#F1C40F", bold: "#B69A0C"},
        19: {base: "#7F8C8D", bold: "#636D6D"},
        20: {base: "#BDC3C7", bold: "#989EA0"},
        21: {base: "#34495E", bold: "#283747"},
        22: {base: "#A93226", bold: "#822621"},
        23: {base: "#B03A2E", bold: "#8D2E24"},
        24: {base: "#6C3483", bold: "#552966"},
        25: {base: "#7D3C98", bold: "#63307A"},
        26: {base: "#1F618D", bold: "#194D71"},
        27: {base: "#2874A6", bold: "#205A81"},
        28: {base: "#117A65", bold: "#0E5D4F"},
        29: {base: "#148F77", bold: "#10705F"},
        30: {base: "#D68910", bold: "#AA6C0D"},
        31: {base: "#B9770E", bold: "#945F0B"},
        32: {base: "#6E2C00", bold: "#541F00"},
        33: {base: "#784212", bold: "#5D3210"},
        34: {base: "#2E4053", bold: "#22313F"},
        35:{base:"#ff6b6b",bold:"#cc5555"},
        36:{base:"#feca57",bold:"#cba046"},
        37:{base:"#48dbfb",bold:"#3aaec9"},
        38:{base:"#1dd1a1",bold:"#17a985"},
        39:{base:"#5f27cd",bold:"#4c1fa4"},
        40:{base:"#ff9ff3",bold:"#cc7fc2"},
        41:{base:"#54a0ff",bold:"#4380cc"},
        42:{base:"#00d2d3",bold:"#00a6a7"},
        43:{base:"#ee5253",bold:"#be4242"},
        44:{base:"#8395a7",bold:"#697785"},

        45:{base:"#ff7675",bold:"#cc5f5f"},
        46:{base:"#fd79a8",bold:"#ca617f"},
        47:{base:"#a29bfe",bold:"#827ccf"},
        48:{base:"#74b9ff",bold:"#5c94cc"},
        49:{base:"#55efc4",bold:"#44bf9d"},
        50:{base:"#ffeaa7",bold:"#ccb985"},
        51:{base:"#fab1a0",bold:"#c88e80"},
        52:{base:"#e17055",bold:"#b35a44"},
        53:{base:"#0984e3",bold:"#0769b5"},
        54:{base:"#6c5ce7",bold:"#5649b9"},

        55:{base:"#00b894",bold:"#009375"},
        56:{base:"#00cec9",bold:"#00a5a1"},
        57:{base:"#fdcb6e",bold:"#caa257"},
        58:{base:"#e84393",bold:"#ba3575"},
        59:{base:"#2d3436",bold:"#242a2b"},
        60:{base:"#636e72",bold:"#50585b"},
        61:{base:"#d63031",bold:"#aa2627"},
        62:{base:"#e17055",bold:"#b35a44"},
        63:{base:"#0984e3",bold:"#0769b5"},
        64:{base:"#6c5ce7",bold:"#5649b9"},

        65:{base:"#ff4757",bold:"#cc3946"},
        66:{base:"#ffa502",bold:"#cc8402"},
        67:{base:"#2ed573",bold:"#25aa5c"},
        68:{base:"#1e90ff",bold:"#1873cc"},
        69:{base:"#3742fa",bold:"#2c35c8"},
        70:{base:"#70a1ff",bold:"#5a80cc"},
        71:{base:"#5352ed",bold:"#4241bd"},
        72:{base:"#ff6b81",bold:"#cc5567"},
        73:{base:"#7bed9f",bold:"#62be7f"},
        74:{base:"#a4b0be",bold:"#838d97"},

        75:{base:"#ff6348",bold:"#cc503a"},
        76:{base:"#ff7f50",bold:"#cc6640"},
        77:{base:"#ffa07a",bold:"#cc8062"},
        78:{base:"#20b2aa",bold:"#199089"},
        79:{base:"#87cefa",bold:"#6da5c8"},
        80:{base:"#4682b4",bold:"#376890"},
        81:{base:"#5f9ea0",bold:"#4c7e80"},
        82:{base:"#7fff00",bold:"#66cc00"},
        83:{base:"#adff2f",bold:"#8acc26"},
        84:{base:"#32cd32",bold:"#28a428"},

        85:{base:"#ff1493",bold:"#cc1075"},
        86:{base:"#c71585",bold:"#9f1269"},
        87:{base:"#db7093",bold:"#af5a75"},
        88:{base:"#ff69b4",bold:"#cc5490"},
        89:{base:"#ba55d3",bold:"#9444a9"},
        90:{base:"#9370db",bold:"#7659af"},
        91:{base:"#8a2be2",bold:"#6e22b5"},
        92:{base:"#9400d3",bold:"#7600a8"},
        93:{base:"#9932cc",bold:"#7a28a3"},
        94:{base:"#8b008b",bold:"#6f006f"},

        95:{base:"#ff4500",bold:"#cc3700"},
        96:{base:"#ff8c00",bold:"#cc7000"},
        97:{base:"#ffd700",bold:"#ccac00"},
        98:{base:"#daa520",bold:"#ae841a"},
        99:{base:"#b8860b",bold:"#936b09"},
        100:{base:"#cd853f",bold:"#a66a32"},
        101:{base:"#d2691e",bold:"#a85418"},
        102:{base:"#8b4513",bold:"#6f370f"},
        103:{base:"#a0522d",bold:"#804125"},
        104:{base:"#deb887",bold:"#b3966c"},

        105:{base:"#2ecc71",bold:"#25a65a"},
        106:{base:"#27ae60",bold:"#1f8b4d"},
        107:{base:"#16a085",bold:"#127f6a"},
        108:{base:"#1abc9c",bold:"#15967c"},
        109:{base:"#3498db",bold:"#2878af"},
        110:{base:"#2980b9",bold:"#206693"},
        111:{base:"#9b59b6",bold:"#7c4792"},
        112:{base:"#8e44ad",bold:"#70368a"},
        113:{base:"#34495e",bold:"#283847"},
        114:{base:"#2c3e50",bold:"#22313f"},

        115:{base:"#e74c3c",bold:"#b53b2f"},
        116:{base:"#f1c40f",bold:"#b69a0c"},
        117:{base:"#e67e22",bold:"#b6611b"},
        118:{base:"#95a5a6",bold:"#778485"},
        119:{base:"#d35400",bold:"#a04300"},
        120:{base:"#7f8c8d",bold:"#636d6d"},
        121:{base:"#bdc3c7",bold:"#989ea0"},
        122:{base:"#c0392b",bold:"#992d22"},
        123:{base:"#16a085",bold:"#12856b"},
        124:{base:"#27ae60",bold:"#208a4d"},

        125:{base:"#2980b9",bold:"#206494"},
        126:{base:"#8e44ad",bold:"#6f347e"},
        127:{base:"#2c3e50",bold:"#1f2c38"},
        128:{base:"#f39c12",bold:"#bf7e0e"},
        129:{base:"#d35400",bold:"#a04300"},
        130:{base:"#c0392b",bold:"#992d22"},
        131:{base:"#7f8c8d",bold:"#636d6d"},
        132:{base:"#bdc3c7",bold:"#989ea0"},
        133:{base:"#34495e",bold:"#283747"},
        134:{base:"#2c3e50",bold:"#1f2c38"}
      },
      activatedDomains: [],
      backupFlags: [],
      selectedFilters: ['enterprise', 'free'],
      updatingCF: false,
      allTagsCategories: [],
      typePrimary: false,
      typeAddon: false,
      statusActive: false,
      statusPending: false,
      selectedIndex: -1,
      deleteDomains: [],
      newHdd: 0,
      fieldDisable: true,
      hddLoading: false,
      removeLoader: false,
      selectedAccountForHDDUpdate: {},
      mainLoading: false,
      stagingLoading: false,
      operationIndex: -1,
      searchQuery: '',
      typeSearch: ['Primary', 'Add-On'],
      statusSearch: ['Active', 'Pending'],
      // tagsType: ['Primary', 'Add-On'],
      // tagsStatus: ['Active', 'Pending'],
      isStagingSearch: false,
      showRecords: 10,
      pageNumber: 0,
      subCollection: [],
      wpLoader: false,
      presetMacros: [],
      collapseState: 'closed',
      selectedIndexForNode: -1,
      nodeLoader: false,
      openedTab: '',
      totalServices: 0,
      totalSites: 0,
      tagOptions: [
        {tag: 'cloudflare', category: 'service', src: require('@/assets/img/cloudflare.png')},
        {tag: 'ezoic', category: 'cache', src: require('@/assets/img/ezoic_cache.png')},
        {tag: 'sucuri', category: 'service', src: require('@/assets/img/sucuri.png')},
        {tag: 'bigscoots', category: 'cfe', src: require('@/assets/img/bigscoots_cf.png')},
        {tag: 'Squarespace', category: 'host', src: require('@/assets/img/squarespace.png')},
        {tag: 'nerdpress', category: 'cfe', src: require('@/assets/img/nerdpress.png')},
        {tag: 'ezoic', category: 'ads', src: require('@/assets/img/ezoic_ADS.png')},
        {tag: 'wix', category: 'host', src: require('@/assets/img/wix.png')},
        {tag: 'bigscoots', category: 'host', src: require('@/assets/img/bigscoots.jpg')},
        {tag: 'Shopify', category: 'host', src: require('@/assets/img/shopify-tag.png')},
      ],
      lockPlanLimit: true,
      lockDomain: true
    }
  },
  computed: {
    backupFlagsComputed() {
      console.log('computed called')
      return this.backupFlags;
    },
    hostingAccounts() {
      let filteredAccounts = [];
      this.totalServices = 0;
      this.totalSites = 0;
      const hostingAccounts = this.$store.getters["hosting/accountsOrdered"];
      filteredAccounts = hostingAccounts.filter(acc => {
        if (!this.processingDomainList.find(el => el.inputDomain === acc.domain && el.jobName === 'remove-domain')) {
          if (acc.type === 'Primary Domain') {
            this.totalServices++;
          }
          this.totalSites++;
          if (!acc.home_path) {
            acc.home_path = `/home/nginx/domains/${acc.domain}`
          }
          if (this.typeSearch.length > 0) {
            if (this.typeSearch.includes('Primary') && acc.type === 'Primary Domain') {
              return acc;
            }
            if (this.typeSearch.includes('Add-On') && acc.type === 'Addon Domain') {
              return acc;
            }
          } else {
            console.log(acc);
            return acc;
          }
        }
        return false;
      });
      this.$emit('updateCounts', {totalServices: this.totalServices, totalSites: this.totalSites})
      filteredAccounts = filteredAccounts.filter(acc => {
        if (this.statusSearch.length > 0) {
          if (this.statusSearch.includes('Active') && acc.status === 'active') {
            return acc;
          }
          if (this.statusSearch.includes('Pending') && acc.status === 'pending') {
            return acc;
          }
        } else {
          return acc;
        }
        return false;
      });
      filteredAccounts = filteredAccounts.filter(acc => {
        let obj = this.subCollection.find(el => {
          return el.domain === acc.domain && el.month === new Date().getMonth() + 1 && el.uniqueVisitors && el.uniqueVisitors.length > 0
        });
        if (obj) {
          acc.last_updated = obj.uniqueVisitors.reverse()[0].visitors
        }
        if (acc.hbHostname && acc.hbHostname.toLowerCase().includes(this.searchQuery.trim().toLowerCase())) {
          return true;
        } else if (acc.serverIP && acc.serverIP.includes(this.searchQuery.trim())) {
          return true;
        }
        return acc.domain.toLowerCase().includes(this.searchQuery.trim().toLowerCase());

      });

      if (this.selectedFilters.length) {

        filteredAccounts = filteredAccounts.filter((q) => {
          if (this.selectedFilters.includes('all')) {
            return true
          } else if (this.selectedFilters.includes('enterprise') && this.selectedFilters.includes('free')) {
            return true
          } else {
            let cloudFarePlan = q.cloudflarePlan || 'free';
            cloudFarePlan = cloudFarePlan === 'free' ? 'free' : 'enterprise'
            return this.selectedFilters.includes(cloudFarePlan)
          }
        });
      }
      // filteredAccounts = JSON.parse(JSON.stringify(filteredAccounts))
      // filteredAccounts.map((el, index) => {
      //   console.log(`accounts ${el.cloudflarePlan} ${Array.isArray(el.cloudflarePlan)}`)
      //   if(Array.isArray(el.cloudflarePlan)) {
      //     const obj = el.cloudflarePlan.find(el2 => el2 && (el2.includes('_') || el2 === 'free'));
      //     if(obj) {
      //       this.selectedCfPlans[index] = el.cloudflarePlan.map(el2 => this.convertedCfPlans[`${el2}`])
      //     }
      //   } else {
      //     this.selectedCfPlans[index] = el.cloudflarePlan && el.cloudflarePlan.includes('_') || el.cloudflarePlan === 'free' ? this.convertedCfPlans[`${el.cloudflarePlan}`] : el.cloudflarePlan
      //   }
      //   console.log(`accounts fter ${el.cloudflarePlan} ${Array.isArray(el.cloudflarePlan)}`)
      // })
      // filteredAccounts.map((el) => {
      //   if(el.monitorId){
      //     this.getNodeInfo(el.monitorId).then(data => {
      //       if(data){
      //         el.nodeName=data.nodeName || ''
      //         el.nodeFreeDisk=Math.floor(Number(data.freedisk)/(1024 * 1024)) || 0
      //       }
      //     })
      //   }
      // })
      const start = this.pageNumber * this.showRecords, end = start + this.showRecords;
      this.$store.commit('hosting/mutateLength', filteredAccounts.length);
      if (filteredAccounts[0] && filteredAccounts[0].serverIP) {
        this.$emit('updateIP', filteredAccounts[0].serverIP)
      }
      if (!this.allTagsCategories.length) {
        this.getTagsForAllDomains(filteredAccounts)
      }
      console.log('this filtered Accounts', filteredAccounts)
      return filteredAccounts.slice(start, end);
    },
    pageCount() {
      let l = parseInt(this.$store.getters['hosting/getLength']), s = parseInt(this.showRecords);
      return Math.ceil(l / s);
    },
    realHostingAccounts() {
      return this.$store.getters["hosting/accounts"];
    },
    isNewAccount() {
      const hostingDetail = this.$store.getters["hosting/accounts"];
      return (hostingDetail[0] && hostingDetail[0].primary.domain === '');
    },
    custID() {
      return this.$store.getters["customer/id"];
    },
    docID() {
      return this.$store.getters["customer/docID"];
    },
    plans() {
      const plans = this.$store.getters["plan/list"];
      return plans.sort((a, b) => Number(a.order) - Number(b.order));
    },
    modifiedPlans() {
      const plans = this.plans;
      const modifiedPlans = [];
      modifiedPlans.push({name: 'Regular', options: [...plans.filter(el => Number(el.order) <= 7 || Number(el.order) > 13)]})
      modifiedPlans.push({
        name: 'Mediavine',
        options: [...plans.filter(el => Number(el.order) > 7 && Number(el.order) < 13)]
      })
      modifiedPlans.push({name: 'NorthCommerce', options: [...plans.filter(el => Number(el.order) === 13)]})
      return modifiedPlans
    },
    user() {
      return this.$store.getters.user;
    },
    customerInfo() {
      return this.$store.getters["customer/details"];
    },
  },
  updated() {
    /* eslint-disable */
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    /* eslint-enable */
  },
  watch: {
    processingDomainList(val) {
      console.log('proess ', val.length)
      if (val.length !== 0) {
        $(function () {
          $('[data-toggle="tooltip"]').tooltip();
        });
      } else {
        const element = document.getElementById('update_account_btn');
        console.log('element ', element)
// Check if the element exists
        if (element) {
          // Get the tooltip instance using Bootstrap
          element.title = ''
        } else {
          console.log('Element not found.');
        }
      }
    },
    searchQuery() {
      this.pageNumber = 0
    },
    docID() {
      this.searchQuery = ''
      // this.fetchHostingAccount()
      this.$store.commit("hosting/updateUserAccountFilters", null);
    },
    selectedFilters() {
      this.pageNumber = 0;
      this.$refs.paginate.innerValue = 1;
    }
  },
  props: {
    processingDomainList: Array
  },
  async mounted() {
    this.typePrimary = true;
    this.typeAddon = true;
    this.statusActive = true;
    this.statusPending = true;
    /* eslint-disable */
    $("#changeHddModal").on('hidden.bs.modal', () => {
      this.fieldDisable = true;
    });
    /* eslint-enable */
    const accountFilters = this.$store.getters["hosting/getAccountFilters"];
    if (accountFilters) {
      this.showRecords = accountFilters.showRecords;
      this.typeSearch = accountFilters.typeSearch;
      this.statusSearch = accountFilters.statusSearch;
      this.searchQuery = accountFilters.searchQuery;
      this.$store.commit("hosting/updateUserAccountFilters", null);
    }

    // await this.fetchHostingAccount()
    await this.getLastUpdatedVisitors();
    await this.getPresetReplies()
  },
  methods: {
    convertToBytes(value) {
      if (!value) return 0;

      const num = parseFloat(value); // numeric part
      const unit = value.toLowerCase();
      console.log('unit', unit);
      console.log('num', num);
      if (unit.includes('gb') || unit.includes('g')) {
        return num * 1024 * 1024 * 1024; // 1 GB = 1024³ bytes
      }
      if (unit.includes('mb') || unit.includes('m')) {
        return num * 1024 * 1024; // 1 MB = 1024² bytes
      }
      if (unit.includes('kb') || unit.includes('k')) {
        return num * 1024; // 1 KB = 1024 bytes
      }
      if (unit.includes('b')) {
        return num; // already bytes
      }
      throw new Error('Unknown unit, must be B, KB, MB, or GB');
    },
    async diskUpdate() {
      try {
        this.hddLoading = true;
        const resp = await this.$http.post('/lxd/instance/action', {
          grant_type: 'token',
          action: 'resize',
          cluster: this.selectedAccountForHDDUpdate.cluster,
          name: this.selectedAccountForHDDUpdate.instance,
          data: {
            size: parseFloat(this.newHdd)
          }
        })
        const respOfGetinstance = await this.$http.post('/lxd/get-details', {
          grant_type: 'token',
          cluster: this.selectedAccountForHDDUpdate.cluster,
          name: this.selectedAccountForHDDUpdate.instance,
        })
        console.log('respOfGetinstance', respOfGetinstance.data)
        if(respOfGetinstance.data.success){
          const { disk, disk_usage, disk_usage_percent } = respOfGetinstance.data.data.resources;
          const hdd = {
            total: this.convertToBytes(disk),
            used: this.convertToBytes(disk_usage),
            free: '',
            usedPercent: disk_usage_percent && disk_usage_percent !== '-' ? disk_usage_percent.split('%')[0] : null,
          };
          const account = this.selectedAccountForHDDUpdate
          const uid =
              isMultiDocUser(this.docID)
                  ? account.sourceUid
                  : this.docID;
          const accountRef = await db.collection('hostingAccounts').doc(uid).get();
          const {accounts} = accountRef.data();
          accounts[account.planIndex].primary.hdd = hdd
          await db.collection('hostingAccounts').doc(uid).update({
            accounts: accounts
          });
        }
        this.showToast({message: 'You have successfully updated the disk', duration: 4000}, true, 'success')
        this.$store.dispatch("async/stateUpdate", {state: false});
      } catch (e) {
        console.log(e)
        this.showToast({message: 'Something went wrong while updating the disk', duration: 4000}, true, 'danger')
      } finally {
        this.hddLoading = false;
        setTimeout(() => {
          this.$store.dispatch("async/stateUpdate", {state: true});
          $("#changeHddModal").modal('hide');
          document.body.classList.remove('modal-open');
          document.body.style.overflow = 'auto';
        }, 1000)
      }
    },
    async setBackupFlag(account, value) {
      if (value) {
        await db.collection('newBackupFlags').add({
          ip: account.serverIP,
          hbServiceID: account.hbServiceID,
          hbHostname: account.hbHostname,
          uid: this.docID,
          new_backup: true,
          old_backup: true,
          from: 'adminSide',
          createdAt: new Date().toISOString()
        });
        this.backupFlags.push(account.hbServiceID)
      } else {
        const ref = await db.collection('newBackupFlags').where('hbServiceID', '==', account.hbServiceID).get();
        if (ref.size > 0) {
          for (const row of ref.docs) {
            await row.ref.delete()
          }
          this.backupFlags = this.backupFlags.filter(el => el !== account.hbServiceID)
          console.log('deleting', this.backupFlags)
        }
      }
    },
    async isNewBackupEnabled(account) {
      console.log('account', account)
      const ref = await db.collection('newBackupFlags').where('hbServiceID', '==', account.hbServiceID).get();
      console.log('ref', ref.size)
      if (ref.size > 0 && ref.docs[0].data().new_backup) {
        this.backupFlags = this.backupFlags.filter(el => el !== account.hbServiceID)
        this.backupFlags.push(account.hbServiceID)
      } else {
        this.backupFlags = this.backupFlags.filter(el => el !== account.hbServiceID)
      }
    },
    async redirectToGraph(account) {
      const {domain, serverIP} = account;
      this.mainLoading = true;
      const ref = await db.collection('zabbixMonitors')
          .where('url', '==', domain)
          .where('serverIP', '==', serverIP)
          .get()
      this.mainLoading = false;
      if (!ref.empty) {
        const monitorData = {id: ref.docs[0].id, ...ref.docs[0].data()};
        await this.$router.push({name: 'graph', params: {id: monitorData.id}});
        return;
      }
      return swal('Error!', 'Monitor not found', 'error');
    },
    getValidOption(option) {
      // console.log('1445', option)
      return option && option.$groupLabel ? option.$groupLabel : this.convertedCfPlans[`${option}`] || ''
    },
    removeOption(e, account) {
      console.log('selected', e, account.cloudflarePlan, typeof (account.cloudflarePlan))
      const mediavineRegularPlans = this.mediavineCfPlans[0].options;
      if (mediavineRegularPlans.includes(e)) {
        account.cloudflarePlan = account.cloudflarePlan.filter(el => !mediavineRegularPlans.includes(el))
        account.cloudflarePlan = [...account.cloudflarePlan, e]
      }
    },
    isRegular(account) {
      return account.planName === 'WPO Starter' || account.planName === 'WPO Professional' || account.planName === 'WPO Business' || account.planName === 'WPO Enterprise' || account.planName === 'Managed WordPress' || account.planName === 'WPO VPS' || account.planName === 'WPO Dedicated' || !account.cloudflarePlan || account.cloudflarePlan === 'free'
    },
    isMediavine(account) {
      return account.planName === 'Journey Plan' || account.planName === 'Mediavine Plan 2' || account.planName === 'Mediavine Plan 1' || account.planName === 'Mediavine Plan 3' || account.planName === 'Mediavine Enterprise'
    },
    openSubsitesModal(account) {
      this.$parent.$refs.subsiteModal.load(account);
    },
    getUsedLimit(realHostingAccounts, index) {
      if (!realHostingAccounts[index]) return 0
      if (!realHostingAccounts[index].primary.domain) return 0
      return realHostingAccounts[index].addon.length + 1
    },
    openCustomBulkDomainDeletionModal(account, index) {
      this.$refs.bulkDomainDeletionModalRef.load(account, index)
    },
    getSource(row) {
      const result = this.tagOptions.filter((value) => row.tag.toLowerCase() === value.tag.toLowerCase() && row.category.toLowerCase() === value.category.toLowerCase());
      if (result.length) {
        console.log('This result value', result[0])
        return result[0].src || '';
      }
      return false;
    },
    async activateCloudflareEnterprise(data) {
      try {
        console.log('1231', data)
        const {cloudflare, type} = data;
        if (data.status !== 'active') {
          swal('Error', 'Domain is not active to activate CF Enterprise.', 'error');
          return false;
        }
        if (!data.serverIP) {
          swal('Error', 'No IP exists to activate CF Enterprise.', 'error');
          return false;
        }
        if (!cloudflare.apiKey || cloudflare.username === 'N/A' || cloudflare.apiKey === 'N/A' || !cloudflare.username) {
          swal('Error', 'Please check if you have proper CF details.', 'error');
          return false;
        }
        data.from = 'hostingAccount';
        data.uid = this.docID
        try {
          this.activatedDomains.push(data.domain)
          // const domainRef = await db.collection('domains').where('domain', '==', data.domain).where('ip', '==',data.serverIP).limit(1).get()
          // if (domainRef.size) {
          //   const {id} = domainRef.docs[0];
          //   const cfEnterprise = domainRef.docs[0].data().cfEnterprise || {}
          //   cfEnterprise.pending = true;
          //   delete cfEnterprise.steps;
          //   await db.collection('domains').doc(id).update({ cfEnterprise, cfPlan: 'mediavine_integration', isNewCFReq: true });
          // }
          // console.log('done')
          // swal('Success!', `CF activation request for this domain has been added.`, "success");
        } catch (e) {
          console.log('Error', e.toString())
        }
        this.$emit('loadActivateCfModal', data)
//             const result = await swal({
//               title: 'Plan Selection',
//               html: `<div style="text-align: left !important;">
// <input type="radio" checked id="option1" name="options" value="performance_package">
//         <label for="option1">Performance Package</label><br>
//         <input type="radio" disabled id="option2" name="options" value="security_package">
//         <label for="option2">Security Package</label><br>
//         <input type="radio" id="option3" name="options" value="performance_and_security_package">
//         <label for="option3">Performance & Security Package</label><br>
//         <input type="radio" id="option4" disabled name="options" value="maintenance_I">
//         <label for="option4">Maintenance I</label><br>
//         <input type="radio" disabled id="option5" name="options" value="maintenance_II">
//         <label for="option5">Maintenance II</label><br>
//         <input type="radio" disabled id="option6" name="options" value="maintenance_III">
//         <label for="option6">Maintenance III</label>
// </div>
//       `,
//               showCancelButton: true,
//               confirmButtonText: 'Submit',
//               cancelButtonText: 'Cancel',
//               confirmButtonClass: 'swal2-confirm--right',
//               cancelButtonClass: 'swal2-cancel--right',
//               cancelButtonColor: "#EE8057",
//               preConfirm: () => {
//                 const selectedOption = document.querySelector('input[name="options"]:checked');
//                 return selectedOption ? selectedOption.value : null;
//               }
//             })
//             if(result.value) {
//               const ref = await db.collection('hostingAccounts').doc(this.docID).get();
//               if(ref.exists) {
//                 const { accounts } =ref.data();
//                 const selectedPlan = accounts[data.planIndex];
//                 if(type === 'Primary Domain' && data.domain === selectedPlan.primary.domain) {
//                    selectedPlan.primary.cloudflarePlan = result.value;
//                 }else if(type === 'Addon Domain' && data.domain === selectedPlan.addon[data.addonIndex].domain) {
//                    selectedPlan.addon[data.addonIndex].cloudflarePlan = result.value;
//                 }
//                 await db.collection('hostingAccounts').doc(this.docID).update({accounts});
//               }
//               console.log('now making option greyed out');
//               this.activatedDomains.push(data.domain)
//               const domainRef = await db.collection('domains').where('domain', '==', data.domain).where('ip', '==', data.serverIP).limit(1).get();
//               if(domainRef.size) {
//                 const {id} = domainRef.docs[0];
//                 const cfEnterprise = domainRef.docs[0].data().cfEnterprise || {}
//                 cfEnterprise.status = 'running'
//                 await db.collection('domains').doc(id).update({ cfEnterprise, cfPlan: result.value });
//               }
//               const response = await this.$http.post("provider/activate_cf_enterprise", {
//                 grant_type: "token",
//                 domain: data.domain,
//                 email: data.cloudflare.username,
//                 apiKey: data.cloudflare.apiKey,
//                 ip: data.serverIP
//               })
//               console.log('response', response)
//             }
      } catch (e) {
        console.log('error at 1266', e.toString())
        this.activatedDomains = this.activatedDomains.filter(el => el !== data.domain)
        // swal('Error', 'Something went wrong while processing of activating CF Enterprise', 'error');
      } finally {
        this.mainLoading = false;
        this.operationIndex = -1;
      }
    },
    updateData() {
      const hostingAccounts = this.$store.getters["hosting/accountsOrdered"];
      this.getTagsForAllDomains(hostingAccounts)
    },
    sslClass(domain) {
      const obj = this.filterSSL(domain);
      return obj.ssl === 'full' ? 'enabled' : obj.ssl === 'flexible' ? 'yellow' : 'default';
    },
    getSSLTitle(domain) {
      const obj = this.filterSSL(domain);
      return (obj.ssl === 'full') ? 'SSL - FULL' : (obj.ssl === 'flexible') ? 'SSL - FLEXIBLE' : 'SSL - Not Active'
    },
    getCFClass(domain) {
      const obj = this.filterSSL(domain);
      return (obj.cf == 'true' || obj.cf === true) ? 'enabled' : obj.cf === 'paused' ? 'yellow' : 'default';
    },
    getCFTitle(domain) {
      const obj = this.filterSSL(domain);
      return (obj.cf === 'paused') ? 'CF - Paused' : (obj.cf == 'true' || obj.cf === true) ? 'CF - Active & Un-Paused' : 'CF - Not Active'
    },
    async updateCF(account, index) {
      try {
        this.mainLoading = true;
        this.operationIndex = index;
        console.log('account', account)
        const res = await this.$http.post(`utilities/updateCFStatusForDomain`, {
          grant_type: 'token',
          domain: account.domain,
          uid: account.sourceUid || this.docID
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        await this.updateData()

        this.mainLoading = false;
        this.operationIndex = -1;
        console.log('response', res)
        this.updateData()
        swal('Success!', `You have successfully updated CF status!`, "success");
      } catch (e) {
        this.mainLoading = false;
        this.operationIndex = -1;
        swal('Error!', `Something went wrong while updating CF status!`, "error");
      }
    },
    async updateCFForAllDomains() {
      try {
        this.updatingCF = true
        await this.$http.post(`utilities/updateCFStatusForAllDomains`, {
          grant_type: 'token',
          uid: this.docID
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        this.updatingCF = false
        this.updateData()
        swal('Success!', `You have successfully updated CF status!`, "success");
      } catch (e) {
        this.updatingCF = false
        swal('Error!', `Something went wrong while updating CF status!`, "error");

      }
    },
    filterSSL(domain) {
      const data = this.allTagsCategories.find(t => t.domain === domain);
      if (data) {
        return {ssl: data.ssl || '', cf: data.cf || ''}
      }
      return {ssl: '', cf: ''};
    },
    checkCFEnterprise(domain) {
      const data = this.allTagsCategories.find(t => t.domain === domain);
      if (data) {
        return !!(data.cfEnterprise && data.cfEnterprise.activated)
      }
      return false
    },
    filterTags(domain) {
      const tags = this.allTagsCategories.find(t => t.domain === domain)
      if (tags) {
        return tags.data || []
      }
      return []
    },
    async getTagsForAllDomains(accounts) {
      this.allTagsCategories = [];

      try {
        const uid = this.docID;
        const isMulti = isMultiDocUser(uid);
        const domainDocs = isMulti
            ? await getOrderedDomainDocs(uid)
            : (await db.collection('domains').where('uid', '==', uid).get()).docs;

        const allDomains = [];

        domainDocs.forEach(doc => {
          const row = doc.data();
          allDomains.push({
            domain: row.domain,
            ip: row.ip,
            tagCategories: row.tagCategories,
            ssl: row.ssl,
            cf: row.cf,
            cfEnterprise: row.cfEnterprise,
          });
        });

        console.log('all domains length', allDomains.length);

        for (const acc of accounts) {
          const exists = this.allTagsCategories.find(t => t.domain === acc.domain);
          if (!exists) {
            const match = allDomains.find(
                el => el.domain === acc.domain && el.ip === acc.serverIP
            );
            if (match) {
              this.allTagsCategories.push({
                domain: acc.domain,
                data: match.tagCategories || [],
                ssl: match.ssl || '',
                cf: match.cf || '',
                cfEnterprise: match.cfEnterprise || {},
              });
            }
          }
        }
      } catch (e) {
        console.error('Error in getTagsForAllDomains:', e.toString());
      }
    },
    async getTags(domain, serverIP, allDomains) {
      if (domain) {
        let query = allDomains.find(el => el.ip === serverIP && el.domain === domain)
        if (query) {
          return query
        }
      }
      return {tagCategories: []}
    },
    filterByType(val) {
      console.log(this.typePrimary)
      if (val === 'primary') {
        if (this.typePrimary) {
          this.typeSearch.push('Primary');
        } else {
          const index = this.typeSearch.indexOf('Primary')
          this.typeSearch.splice(index, 1)
        }
      }
      if (val === 'addon') {
        if (this.typeAddon) {
          this.typeSearch.push('Add-On');
        } else {
          const index = this.typeSearch.indexOf('Add-On')
          this.typeSearch.splice(index, 1)
        }
      }
      if (val === 'active') {
        if (this.statusActive) {
          this.statusSearch.push('Active');
        } else {
          const index = this.statusSearch.indexOf('Active')
          this.statusSearch.splice(index, 1)
        }
      }
      if (val === 'pending') {
        if (this.statusPending) {
          this.statusSearch.push('Pending');
        } else {
          const index = this.statusSearch.indexOf('Pending')
          this.statusSearch.splice(index, 1)
        }
      }
      this.pageNumber = 0
      console.log('type search', this.typeSearch)
      console.log('status search', this.statusSearch)
    },
    async getNodeInfo(index, account) {
      this.openedTab = this.openedTab === `${index}-${account.domain}` ? '' : `${index}-${account.domain}`
      try {
        if (this.collapseState === 'opened' && this.selectedIndexForNode === index) {
          this.collapseState = 'closed'
          this.selectedIndexForNode = -1
          return
        }
        this.nodeLoader = true
        this.collapseState = 'opened'
        this.selectedIndexForNode = index
        // if(account.monitorId){
        //   const monitorRef= await db.collection('monitors').doc(account.monitorId).get()
        //   if(monitorRef.exists){
        //     const {nodeId} = monitorRef.data()
        //     console.log('node id', nodeId)
        //     if(nodeId){
        //       const nodeRef= await db.collection('nodes').doc(nodeId).get()
        //       if(nodeRef.exists){
        //         const {nodeName, freedisk}=nodeRef.data()
        //         account.nodeName=nodeName
        //         account.nodeFreeDisk=Math.floor(Number(freedisk)/(1024 * 1024))
        //       }
        //     }
        //   }
        // }
        // get node info from the domain collection
        const ref = await db.collection('domains').where('domain', '==', account.domain).where('uid', '==', this.docID).get()
        if (ref.size) {
          const data = ref.docs[0].data()
          if (data.nodeInfo) {
            console.log('found')
            account.nodeName = data.nodeInfo.nodeName
            account.nodeFreeDisk = Math.floor(Number(data.nodeInfo.freedisk) / (1024 * 1024))
          } else {
            // get node info from backend
            let resp = await this.$http.post('/outage/vm_id', {
              grant_type: 'token',
              vmId: account.solusVM_VPS_ID
            })
            if (resp.data) {
              const {nodeId} = Object.values(resp.data)[0][0]
              if (nodeId) {
                const nodeRef = await db.collection('nodes').doc(nodeId).get()
                if (nodeRef.exists) {
                  const {nodeName, freedisk} = nodeRef.data()
                  account.nodeName = nodeName
                  account.nodeFreeDisk = Math.floor(Number(freedisk) / (1024 * 1024))
                  await db.collection('domains').doc(ref.docs[0].id).update({
                    nodeInfo: {
                      id: nodeId,
                      nodeName,
                      freedisk
                    }
                  })
                }
              }
            }
          }
        }
        this.nodeLoader = false
      } catch (e) {
        console.log(e.toString())
        this.selectedIndexForNode = -1
        this.nodeLoader = false
        this.collapseState = 'closed'

      }
    },
    async getNodeDataFromNetbox(netboxNodeId, account) {
      const netboxNodeRef = await db.collection('netboxNodes').doc(netboxNodeId).get();
      if (netboxNodeRef.exists) {
        const {name, solusvm_node_id, freedisk, rack} = netboxNodeRef.data()
        account.nodeName = name;
        account.rack = rack ? rack.name : '';
        account.nodeFreeDisk = freedisk ? ((freedisk) / 1024 ** 2).toFixed(2) : '';
      }
      return account
    },
    async getDetailsFromConsul(serviceId) {
      try{
        const resp = await this.$http.post('/lxd/n8n-apis-for-lxd-migration', {
          action: 'get-info-from-consul',
          serviceId: serviceId,
          grant_type: 'token',
        })
        if (resp.data.success) {
          const {Address, ServiceMeta} = resp.data.data
          return {ip: Address, meta: ServiceMeta}

        }
        console.log('resp', resp.data)
        return {meta: {hb_service_type: 'openvz'}}
      } catch (e) {
        return {meta: {hb_service_type: 'openvz'}}
      }
    },
    convertToBytes(value) {
      if (!value) return 0;

      const num = parseFloat(value); // numeric part
      const unit = value.toLowerCase();
      console.log('unit', unit);
      console.log('num', num);
      if (unit.includes('gb') || unit.includes('g')) {
        return num * 1024 * 1024 * 1024; // 1 GB = 1024³ bytes
      }
      if (unit.includes('mb') || unit.includes('m')) {
        return num * 1024 * 1024; // 1 MB = 1024² bytes
      }
      if (unit.includes('kb') || unit.includes('k')) {
        return num * 1024; // 1 KB = 1024 bytes
      }
      if (unit.includes('b')) {
        return num; // already bytes
      }
      throw new Error('Unknown unit, must be B, KB, MB, or GB');
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));
      const value = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

      return `${value} ${sizes[i]}`;
    },
    async getNodeInfoFromNetbox(index, account) {
      this.openedTab = this.openedTab === `${index}-${account.domain}` ? '' : `${index}-${account.domain}`
      try {
        if (this.collapseState === 'opened' && this.selectedIndexForNode === index) {
          this.collapseState = 'closed'
          this.selectedIndexForNode = -1
          return
        }
        console.log('160111', account)
        this.nodeLoader = true
        this.collapseState = 'opened'
        this.selectedIndexForNode = index
        const respFromConsul = await this.getDetailsFromConsul(account.hbServiceID)
        console.log('respFromConsul', respFromConsul)
        account.vmType = respFromConsul.meta.hb_service_type === 'openvz'  ? 'openvz/default' : respFromConsul.meta.hb_service_type

        if (account.vmType === 'lxd') {
          account.cluster = respFromConsul.meta.lxd_cluster
          account.instance = respFromConsul.meta.lxd_instance_name
          account.datacenter = respFromConsul.meta.datacenter
          account.nodeName = respFromConsul.meta.netbox_node_name
          account.rack = respFromConsul.meta.netbox_rack_name
          if(account.hdd) {
            account.hdd.total = this.formatBytes(account.hdd.total)
            account.hdd.used = this.formatBytes(account.hdd.used)
          }
          // const instanceResp = await this.$http.post('/lxd/get-details', {
          //   grant_type: 'token',
          //   name: account.instance,
          //   cluster: account.cluster
          // })
          // if (instanceResp.data.success) {
          //   const {resources} = instanceResp.data.data
          //   account.hdd.used = resources.disk_usage
          //   account.hdd.total = resources.disk
          // }
          // console.log('instanceResp', instanceResp)
          this.nodeLoader = false;
          this.selectedIndexForNode = -1
          return
        }
        // get node info from the domain collection
        const ref = await db.collection('domains').where('domain', '==', account.domain).where('ip', '==', account.serverIP).get()
        console.log('ref', ref.size)
        if (ref.size) {
          const data = ref.docs[0].data()
          console.log('netbx', data.netboxNodeId)
          if (data.netboxNodeId) {
            console.log('found');
            account = await this.getNodeDataFromNetbox(data.netboxNodeId, account)
            // account.nodeName=data.nodeInfo.nodeName
            // account.nodeFreeDisk=Math.floor(Number(data.nodeInfo.freedisk)/(1024 * 1024))
          }
        }
        this.selectedIndexForNode = -1
        this.nodeLoader = false
      } catch (e) {
        console.log(e.toString())
        this.selectedIndexForNode = -1
        this.nodeLoader = false
        this.collapseState = 'closed'
      }
    },
    async fetchHostingAccount() {
      try {
        this.accountLoader = true;
        const ref = await db.collection('hostingAccounts').doc(this.docID).get();
        if (ref.exists) {
          const accountOrdered = [];
          const {accounts} = ref.data();
          this.$store.commit('hosting/loadAccountsMutate', ref.data())
          this.$store.commit('hosting/loadAccountsWithOrderMutate', ref.data())
          let number = 1;
          for (const [pIndex, acc] of accounts.entries()) {
            if (acc.primary.domain === '') {
              continue;
            }
            accountOrdered.push({
              ...acc.primary,
              type: "Primary Domain",
              planName: acc.planName,
              planIndex: pIndex,
              addonPrimaryDomain: null,
              addonPrimaryPlan: null,
              primaryPhpMyAdmin: acc.primary.phpMyAdmin,
              planLimit: acc.planLimit,
              extraDomains: acc.extraDomains,
              addonIndex: null,
              maxStorageSize: acc.maxStorageSize,
              maxVisitors: acc.maxVisitors,
              maxMigrations: acc.maxMigrations,
              migration: acc.migration,
              fullDiskSpace: acc.fullDiskSpace,
              accountNumber: number
            });
            for (const [aIndex, addonAcc] of acc.addon.entries()) {
              number += 1
              accountOrdered.push({
                ...addonAcc,
                type: "Addon Domain",
                addonPrimaryDomain: acc.primary.domain,
                primaryPhpMyAdmin: acc.primary.phpMyAdmin,
                addonPrimaryPlan: acc.primary.domain + ':' + acc.primary.serverIP,
                planName: acc.planName,
                planIndex: pIndex,
                addonIndex: aIndex,
                accountNumber: number,
                suspended: acc.primary.suspended,
                hbHostname: acc.primary.hbHostname,
              });
            }
            number += 1;
          }
          this.accountOrdered = accountOrdered
          console.log('length at 1650', this.accountOrdered.length, this.allTagsCategories.length)
          if (!this.allTagsCategories.length) {
            await this.getTagsForAllDomains(accountOrdered)
          }
        }
      } catch (e) {
        console.log('error at 1653', e.toString())
      } finally {
        this.accountLoader = false;
      }
    },
    async getPresetReplies() {
      this.presetMacros = []
      let result = await db.collection("permissions")
          .doc("preset_macros_domain")
          .get();
      if (result.exists) {
        this.presetMacros = result.data().replies;
      }
    },
    openTicketModal(account) {
      console.log(account)
      this.$refs.ticketModal.load(this.presetMacros, account)
    },
    async getLoginLink(row, index) {
      this.selectedIndex = index
      try {
        this.wpLoader = true;
        let response = await this.$http.post('admin-user/admin-login-link', {
          grant_type: 'token',
          ip: row.serverIP,
          domain: row.domain,
          username: 'bigscoots'
        });
        response = JSON.parse(response.data);
        console.log((response));
        if (response.status === 'success') {
          await swal({
            title: 'Success!',
            type: 'success',
            html: response.msg,
            confirmButtonText: 'OK'
          });
          window.open(response.link, '_blank');
        } else {
          await swal({
            title: 'Error!',
            html: response.msg,
            type: 'error',
            confirmButtonText: 'OK'
          });
        }
        this.wpLoader = false;
      } catch (e) {
        this.wpLoader = false;
        console.log(e.toString());
        await swal({
          title: 'Error!',
          html: 'Something went wrong!',
          type: 'error',
          confirmButtonText: 'OK'
        });
      }
    },
    async storageCosting(data) {
      this.$refs.storageModal.load(data);
    },
    openTempDomainModal(data) {
      this.$refs.tempDomainModal.load({
        domain: data.domain,
        uid: this.docID,
        ip: data.serverIP,
      })
    },
    async getLastUpdatedVisitors() {
      let response = await db.collection('hostingAccounts').doc(this.docID).collection('billings')
          .where("month", "==", new Date().getMonth() + 1)
          .where("year", "==", new Date().getFullYear())
          .get();
      response.forEach(doc => {
        this.subCollection.push(doc.data())
      });

    },
    openNotesModal(account) {
      this.$parent.$refs.notes.load(account)
    },
    openMovePlanModal(account) {
      console.log(account)
      this.$parent.$refs.planModal.load(account)
    },

    async moveToActive(account, index) {
      account.installation_type = 'fresh'
      await this.createMonitor(account, index)
      await this.updateHostingAccounts();
    },
    getWhoIsInformation(data) {
      this.$refs.whoisModal.load(data.domain);
    },
    getDomain(value) {
      if (value) {
        return value.split(':')[0]
      }
      return ''
    },
    async createTest(account) {
      try {
        this.mainLoading = true;
        const hbHostname = this.realHostingAccounts[account.planIndex].primary.hbHostname;
        const resp = await this.$http.post('/status_cake/create-test', {
          grant_type: 'token',
          uid: this.docID,
          freshInstall: account.freashInstall,
          domain: account.domain,
          hbHostname: hbHostname,
          planIndex: account.planIndex,
          addonIndex: account.addonIndex,
          ip: account.serverIP
        });
        console.log(resp.data.msg)
        this.addLog({
          primaryPlan: this.realHostingAccounts[account.planIndex].primary.domain,
          message: `Successfully Better uptime monitor for ${account.domain}`,
          level: 'info'
        })
        swal('Success!', `Successfully created Better uptime monitor for ${account.domain}`, "success");
      } catch (e) {
        console.error(e);
        this.addLog({
          message: `Error in creating better uptime monitor`,
          level: 'danger'
        })
        swal('ERROR!', 'Error in creating better uptime monitor', "error");
      }
    },
    async disableBackupAccess(account) {
      try {
        const uid =
            isMultiDocUser(this.docID)
                ? account.sourceUid
                : this.docID;
        const text = account.disableBackupAccess ? 'enable' : 'disable';
        const result = await swal({
          title: "Backup Access!",
          text: `Are you sure to ${text} backup access?`,
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        })
        if (result.value) {
          // this.hostingAccounts.unshift();
          console.log('account', account)
          this.mainLoading = true;
          const accountRef = await db.collection('hostingAccounts').doc(uid).get();
          const {accounts} = accountRef.data();
          const beforePayload = JSON.parse(JSON.stringify(accounts));
          console.log('Before Payload', beforePayload)
          accounts[account.planIndex].primary.disableBackupAccess = !account.disableBackupAccess;
          // await this.addHostingAccountEventLog({hostingAccountId : this.docID ,  afterPayload: accounts , action: 'Disable Backup Access', beforePayload: beforePayload})
          await db.collection('hostingAccounts').doc(uid).update({
            accounts: accounts
          });
          this.addLog({
            primaryPlan: accounts[account.planIndex].primary.domain,
            message: `Successfully disabled backup access`,
            level: 'info'
          })
          swal('Success!', `You have successfully ${text}d backup access!`, "success");
        }

      } catch (e) {
        console.error(e);
        this.addLog({
          message: `Error in disabling backup access!`,
          level: 'danger'
        })
        swal('ERROR!', 'Error in disabling backup access', "error");
      }
    },
    async runFsckOnServer(account) {
      try {
        console.log(`account details ${account.toString()}`)
        const result = await swal({
          title: "Are you sure?",
          text: `Please only use this option once and in the event the server is in a readonly state. If unsure please click Cancel and ask in #team-chat.`,
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "Cancel",
          cancelButtonColor: "#EE8057"
        })
        if (result.value) {
          // this.hostingAccounts.unshift();
          console.log('account', account)
          this.mainLoading = true;
          const response = await this.$http.post('/solus-vm/run-fsck-on-server', {
            grant_type: 'token',
            UID: this.docID,
            ip: account.serverIP,
            vmId: account.solusVM_VPS_ID
          })
          console.log(`response from api ${response}`)
          this.addLog({
            primaryPlan: account.domain,
            message: `Successfully ran fsck on server`,
            level: 'info'
          })
          swal('Success!', `Request for running fsck has been received.`, "success");
        }

      } catch (e) {
        console.error(e);
        this.addLog({
          message: `Error in running fsck on server`,
          level: 'danger'
        })
        swal('ERROR!', 'Error in running fsck on server', "error");
      }
    },
    async createStatusCake(account, index) {
      this.mainLoading = true;
      this.operationIndex = index
      // if (account.statusCakeTestId) {
      //     const resp = await this.$http.get(`/status_cake/get_test?testId=${account.statusCakeTestId}`);
      //     if(resp.data.test.TestID){
      //         this.mainLoading=false;
      //         const result=await swal({
      //             title: "Alert!",
      //             text: `Status cake test already exists! TestID: ${account.statusCakeTestId}`,
      //             type: "info",
      //             confirmButtonText: "Recreate",
      //             confirmButtonColor: "#6ACF98",
      //             showCancelButton: true,
      //             cancelButtonText: "Ok",
      //             cancelButtonColor: "#EE8057"
      //             });
      //         if(result.value){
      //             this.createTest(account);
      //             return
      //
      //         }
      //
      //     }
      //     else {
      //         this.createTest(account);
      //         this.mainLoading=false;
      //         return
      //     }
      //
      // }
      // else {
      await this.createTest(account)
      this.mainLoading = false;
      return
      // }

    },

    async createMonitor(account, index) {
      try {
        console.log('account', account)
        this.mainLoading = true;
        this.operationIndex = index;
        const {domain, planName, pDomain, serverIP, hbHostname, hbServiceID} = account;
        const {firstName, lastName, docID: UID} = this.customerInfo;
        const {data: response} = await this.$http.post('zabbix/monitor', {
          grant_type: "token",
          action: 'create',
          token: this.user.idToken,
          domain: domain,
          hostname: hbHostname,
          service_id: hbServiceID,
          type: domain === pDomain? 'primary' : 'addon',
        });
        console.log('response from api', response)
        if(response.success) {
          const consul = await this.$http.post('/lxd/n8n-apis-for-lxd-migration', {
            action: 'get-info-from-consul',
            serviceId: hbServiceID,
            grant_type: 'token',
          })
          let datacenter = ''
          if (consul.data.success) {
            const {ServiceMeta = {}} = consul.data.data
            const netboxRef = await db.collection('netboxNodes').where('name', '==', ServiceMeta.netbox_node_name).limit(1).get();
            if(netboxRef.size) {
              const {id} = netboxRef.docs[0]
              console.log(id)
              account.netboxNodeId = id
              datacenter = ServiceMeta.datacenter
            }
          }
          const zabbixObj = {
            netboxNodeId: account.netboxNodeId || '',
            newNetboxId: account.netboxNodeId || '',
            datacenter,
            wpoPlan: planName || '',
            url: domain,
            firstName: firstName || '',
            lastName: lastName || '',
            name: domain,
            status: 'paused',
            plan: pDomain,
            uid: UID || '',
            downCount: 0,
            incidents: [{
              start: '',
              end: '',
              status: 'paused',
              event: '',
              aStatus: 'paused',
            }],
            statusCake: 'New Domain',
            serverIP: serverIP || '',
            isPrimary: domain === pDomain,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          };
          await db.collection('zabbixMonitors').doc(response.monitor_id.toString()).set(zabbixObj);
        }
        swal('Success', 'Monitor has been successfully created', 'success');
      } catch (e) {
        console.log(e)
        swal('Error', 'Something went wrong while creating monitor', 'error')
      } finally {
        this.mainLoading = false;
        this.operationIndex = -1
      }
    },
    async createMonitorForSingleDomain(account, index) {
      try {
        if (account.monitorId) {
          console.log('this monitor id', account.monitorId)
          try {
            console.log('already exists')
            const result = await swal({
              title: "Are you sure?",
              text: `Are you sure that you want to re-create new monitor?`,
              type: "info",
              confirmButtonText: "Recreate",
              confirmButtonColor: "#6ACF98",
              showCancelButton: true,
              cancelButtonText: "Cancel",
              cancelButtonColor: "#EE8057"
            });
            if (result.value) {
              console.log('already exists and still create')
              await this.createMonitor(account, index);
            }
          } catch (e) {
            console.log('Error occurred in creating better up time monitor')
          }
        } else {
          await this.createMonitor(account, index);
        }
      } catch (e) {
        console.log('Error in updating better up time monitors for single domain', e)
      }
    },
    async createBetterUpTimeForPrimaryStaging(account, index) {
      try {
        this.mainLoading = true;
        this.operationIndex = index;
        const {firstName, lastName, docID} = this.customerInfo;
        console.log('this customer info', this.customerInfo);
        const {data: response} = await this.$http.post('monitor/create-monitor-bulk', {
          grant_type: "token",
          firstName,
          lastName,
          ip: account.serverIP,
          hostingAccountId: docID,
          selectedDomains: [],
          type: 'primary-addon',
        });
        console.log('response from api', response)
        swal('Success', 'Monitor has been successfully created', 'success');
      } catch (e) {
        swal('Error', 'Something went wrong while creating monitor', 'error')
      } finally {
        this.mainLoading = false;
        this.operationIndex = -1
      }
    },
    async monitorAction(account, index) {
      this.mainLoading = true;
      this.operationIndex = index
      console.log(account, 'this here')
      if (account.addonIndex === null) {
        try {
          const self = this;
          let buttonHtml = '<div>' +
              // eslint-disable-next-line no-useless-escape
              `<div>Select \'Primary\' to ${account.monitorId ? "recreate" : "create "}  monitor in Zabbix for  ${account.domain} or click \'Custom\' to do bulk monitors management for all all the domains within this service. </div>` +
              '<br/>' +
              '<ul class="list-inline">' +
              '<li><button class="sw_butt1 swal2-styled" style="display: inline-block;background-color: rgb(106, 207, 152); border-left-color: rgb(106, 207, 152); border-right-color: rgb(106, 207, 152);">Primary Account</button></li>' +
              // '<li><button class="sw_butt2 swal2-styled" style="display: inline-block; background: #e6c652" >Primary + Addons</button></li>' +
              '<li><button class="sw_butt4 swal2-styled" style="display: inline-block; background: #e6c652" >Custom</button></li>' +
              '<li><button class="sw_butt3 swal2-styled" style="display: inline-block; background-color: rgb(238, 128, 87);">Cancel</button></li>' +
              '</ul></div>'
          swal({
            title: "Would you like to proceed?",
            html: buttonHtml,
            type: 'question',
            showCancelButton: false,
            showConfirmButton: false,
            onOpen: function () {
              console.log('On Opne');
              /* eslint-disable */
              $('.sw_butt1').on('click', function () {
                self.createMonitorForSingleDomain(account, index)
              });
              // $('.sw_butt2').on('click',function () {
              //   console.log('All Accounts');
              //   self.createBetterUpTimeForPrimaryStaging(account, index)
              //   swal.close();
              // });
              $('.sw_butt4').on('click', function () {
                console.log('All Accounts');
                self.openCustomSyncBetterUpTimeModal(account, index)
                // self.createBetterUpTimeForPrimaryStaging(account, index)
                swal.close();
              });
              $('.sw_butt3').on('click', function () {
                console.log('close');
                self.mainLoading = false;
                self.operationIndex = -1;
                swal.close();
              });
              /* eslint-enable */
            }
          });
        } catch (e) {
          console.log('Error in updating better up time monitors for primary domain', e.toString())
        }
      } else {
        try {
          if (account.monitorId) {
            console.log('this monitor id', account.monitorId)
            try {
              console.log('already exists')
              const result = await swal({
                title: "Are you sure?",
                text: `Are you sure that you want to re-create new monitor?`,
                type: "info",
                confirmButtonText: "Recreate",
                confirmButtonColor: "#6ACF98",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                cancelButtonColor: "#EE8057"
              });
              if (result.value) {
                console.log('already exists and still create')
                await this.createMonitor(account, index);
              }
            } catch (e) {
              console.log('Error occurred in creating better up time monitor')
            }
          } else {
            await this.createMonitor(account, index);
          }
        } catch (e) {
          console.log('Error in updating better up time monitors for single domain', e)
        }
      }
      this.mainLoading = false;
      this.operationIndex = -1
    },
    openTagModal(account) {
      this.$parent.$refs.tagModal.load(account);
    },
    openIPModal(account) {
      this.$refs.IPModal.load(account);
    },
    updateSearchIndex(index) {
      this.mainLoading = true;
      this.operationIndex = index;
      this.$http.post('/algolia/reinitialize-user-all-record', {
        grant_type: 'token',
        uid: this.docID,
      }).then(resp => {
        swal('SUCCESS!', 'Search indexes have been updated for this account', "success");
        this.addLog({
          uid: this.docID,
          message: 'User has Updated Search Index for all accounts!',
          level: "info"
        });
      }).catch(e => {
        console.error(e);
        swal('ERROR!', 'Error in updating search indexes', "error");
        this.addLog({
          uid: this.docID,
          message: 'Error in updating Search indexes!',
          level: "error"
        });
      }).finally(() => {
        this.mainLoading = false;
        this.operationIndex = -1;
      })
    },
    goToPage(pageNum) {
      this.pageNumber = pageNum - 1;
    },
    returnNAIfNoValue(value) {
      if (value === undefined || value === null || value === '') {
        return 'N/A';
      }
      return value;
    },
    clearAddonPrimaryDomain(accType, currentIndex) {
      if (accType === "Primary Domain") {
        this.hostingAccounts[currentIndex].addonPrimaryPlan = null;
      }
    },
    planLimitCountGenerator(planName, pIndex, account) {
      let plan = this.plans.filter((item) => item.name == planName);
      if (plan.length) {
        if (plan[0].name !== 'WPO VPS') {
          const usedDomain = this.getUsedLimit(this.realHostingAccounts, account.planIndex)
          let extraDomains = usedDomain - Number(plan[0].planLimit)
          extraDomains = extraDomains > 0 ? extraDomains : 0
          this.hostingAccounts[pIndex].extraDomains = extraDomains
        }
        this.hostingAccounts[pIndex].planLimit = plan[0].planLimit;
        this.hostingAccounts[pIndex].maxStorageSize = plan[0].maxStorageSize;
        this.hostingAccounts[pIndex].maxVisitors = plan[0].visitors;
      } else {
        this.hostingAccounts[pIndex].planLimit = 1
      }
      // account.cloudflarePlan = this.isRegular(account) ? 'free' : []
      // this.hostingAccounts = this.hostingAccounts.map(el => {
      //   if(el.serverIP === account.serverIP) {
      //     el.planName = planName
      //     el.cloudflarePlan = []
      //   }
      //   return {...el}
      // })
      // for(const row of this.hostingAccounts) {
      //   console.log(`2343 ${row.serverIP} ${account.serverIP}`)
      //   if(row.serverIP === account.serverIP) {
      //     row.planName = planName
      //   }
      // }
      console.log(`2343 ${JSON.stringify(this.hostingAccounts)}`)
    },
    async initZabbix(account, index) {
      this.mainLoading = true;
      this.operationIndex = index;
      this.$http.post('utilities/zabbix', {
        grant_type: 'token',
        UID: this.docID,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        ip: account.serverIP
      }).then(resp => {
        swal('SUCCESS!', resp.data.msg, "success");
        this.addLog({
          uid: this.docID,
          message: 'User has Initialize Zabbix, IP: ' + account.serverIP,
          level: "info"
        });
      }).catch(e => {
        console.error(e);
        swal('ERROR!', e.response.data.msg, "error");
        this.addLog({
          uid: this.docID,
          message: 'Error in Initialize Zabbix, IP: ' + account.serverIP,
          level: "error"
        });
      }).finally(() => {
        this.mainLoading = false;
        this.operationIndex = -1;
      })
    },
    showNice(bytes) {
      return (bytes / Math.pow(1024, 3)).toFixed(2) + ' GB';
    },
    openChangeHddModal(account) {
      console.log(account);
      this.selectedAccountForHDDUpdate = account;
      this.fieldDisable = false;
      if (account.vmType === 'lxd') {
        console.log('account', account.hdd)
        this.newHdd = parseFloat(account.hdd.total);
      } else {
        this.newHdd = parseFloat((account.hdd.total / Math.pow(1024, 3)).toFixed(1));
      }
    },
    async updateHdd() {
      const account = this.selectedAccountForHDDUpdate;
      const used = account.hdd.used;
      const vmId = account.solusVM_VPS_ID;
      try {
        const usedInGB = parseFloat((used / Math.pow(1024, 3)).toFixed(1));
        const usedBuffer = parseFloat((usedInGB * 0.10).toFixed(1)); // 10% buffer
        const finalComparisonWithUsed = usedInGB + usedBuffer;
        console.log(this.newHdd, finalComparisonWithUsed);
        if (parseFloat(this.newHdd) < parseFloat(finalComparisonWithUsed)) {
          swal('Error!', 'Disk space must be greater than used space!', 'error');
          return;
        }
        this.hddLoading = true;
        const changeHDDResp = await this.$http.post('/solus-vm/change_hdd', {
          vmId: vmId,
          newHdd: parseFloat(this.newHdd),
          grant_type: 'token'
        });
        $("#changeHddModal").modal('hide');
        this.hddLoading = false;
        await this.syncVPSDetails(account);
        swal('HDD Changed!', changeHDDResp.data.message, 'success');
        await this.addLog({
          uid: this.docID,
          message: 'User has Updated Disk Space of SolusVM VPS! Account: ' + account.domain,
          level: "info"
        });
      } catch (err) {
        await this.addLog({
          uid: this.docID,
          message: 'Error in updating Disk Space of SolusVM VPS! Account: ' + account.domain,
          level: "error"
        });
        console.error(err);
        swal('Error!', err.response.data.message, 'error');
      }
    },
    async syncVPSDetails(account) {
      console.log(account);
      this.$store.dispatch("async/stateUpdate", {state: false});
      let vmId = '';
      const uid =
          isMultiDocUser(this.docID)
              ? account.sourceUid
              : this.docID;
      try {
        const accountResp = await this.$http.post('/solus-vm/fetch_client_accounts', {
          clientId: account.hbServiceID,
          grant_type: 'token'
        });
        if (accountResp.data.hbAccounts) {
          const hbAccountDetails = accountResp.data.hbAccounts;
          const accountRef = await db.collection('hostingAccounts').doc(uid).get();
          const {accounts} = accountRef.data();
          accounts[account.planIndex].primary.solusVM_VPS_ID = (!hbAccountDetails.extra_details.option6) ? '' : hbAccountDetails.extra_details.option6;
          accounts[account.planIndex].primary.hbHostname = hbAccountDetails.domain;
          accounts[account.planIndex].primary.hbServiceID = account.hbServiceID;
          await db.collection('hostingAccounts').doc(uid).update({
            accounts: accounts
          });
          vmId = hbAccountDetails.extra_details.option6;
          try {
            const accMapRef = await db.collection('account-hb')
                .where('uid', '==', this.docID)
                .where('domain', '==', accounts[account.planIndex].primary.domain)
                .get();
            if (accMapRef.size > 0) {
              await db.collection('account-hb')
                  .doc(accMapRef.docs[0].id)
                  .update({
                    hbServiceID: account.hbServiceID,
                    solusVM_VPS_ID: (!hbAccountDetails.extra_details.option6) ? '' : hbAccountDetails.extra_details.option6,
                    hbHostname: hbAccountDetails.domain,
                  });
            }
          } catch (e) {
            console.log(e.toString())
            this.addLog({
              message: e.toString(),
              level: 'danger'
            })
          }
        } else {
          this.addLog({
            message: accountResp.data.message,
            level: 'danger'
          })
          swal('Error!', accountResp.data.message, 'error');
        }
        const response = await this.$http.post('/solus-vm/sync_nodes_per_plan', {
          planIndex: account.planIndex,
          uid: this.docID,
          grant_type: 'token'
        });
        console.log('response', response)
        if (vmId) {
          // synchronize node info
          // try {
          //   const syncServiceDetailsResponse = await this.$http.post('/outage/sync_service_details', {
          //     vmId: vmId,
          //     monitorId: account.monitorId,
          //     domain: account.domain,
          //     uid: this.docID,
          //     grant_type: 'token'
          //   });
          //   console.log(syncServiceDetailsResponse)
          // } catch (e) {
          //   console.log(e.toString())
          // }
          let nodeInfoResp = {data: {success: false}}
          try {
            nodeInfoResp = await this.$http.post('/solus-vm/fetch_node_info', {
              vmId: vmId,
              grant_type: 'token'
            });
            console.log('node resp', nodeInfoResp)
          } catch (e) {
            console.log('error while fetching node info', e.toString())
          }
          if (nodeInfoResp.data.status === 'success') {
            const hddInfo = nodeInfoResp.data.hdd.split(',');
            const accountRef = await db.collection('hostingAccounts').doc(uid).get();
            const {accounts} = accountRef.data();
            // const beforePayload = JSON.parse(JSON.stringify(accounts));
            accounts[account.planIndex].primary.hdd = {
              total: hddInfo[0],
              used: hddInfo[1],
              free: hddInfo[2],
              usedPercent: hddInfo[3]
            };
            // await this.addHostingAccountEventLog({hostingAccountId : this.docID ,  afterPayload: accounts , action: 'Sync VPS Details' , beforePayload: beforePayload})
            await db.collection('hostingAccounts').doc(uid).update({
              accounts: accounts
            })
            await this.$http.post('/algolia/reinitialize-user-all-record', {
              grant_type: 'token',
              uid: this.docID,
            });
            await this.addLog({
              uid: this.docID,
              primaryPlan: accounts[account.planIndex].primary.domain,
              message: 'User has Synchronized Service Details!',
              level: "info"
            });
          }
          // else {
          //   this.addLog({
          //     message:nodeInfoResp.data.message,
          //     level : 'danger'
          //   })
          //     swal('Error!', nodeInfoResp.data.message, 'error');
          // }
        } else {
          const accountRef = await db.collection('hostingAccounts').doc(uid).get();
          const {accounts} = accountRef.data();
          // const beforePayload = JSON.parse(JSON.stringify(accounts));
          accounts[account.planIndex].primary.hdd = '';
          // await this.addHostingAccountEventLog({hostingAccountId : this.docID ,  afterPayload: accounts , action: 'Sync VPS Details' , beforePayload: beforePayload})
          await db.collection('hostingAccounts').doc(uid).update({
            accounts: accounts
          })
          await this.addLog({
            uid: this.docID,
            primaryPlan: accounts[account.planIndex].primary.domain,
            message: 'User has Synchronized Service Details!',
            level: "info"
          });
        }
        this.$store.dispatch("async/stateUpdate", {state: true});
      } catch (err) {
        console.error(err);
        this.$store.dispatch("async/stateUpdate", {state: true});

        this.addLog({
          uid: this.docID,
          message: 'Error in synchronizing Service Details!',
          level: "error"
        });
        swal('Error!', err.response.data.message, 'error');
      }
    },
    async syncLxdDetails(account) {
      console.log(account);
      this.$store.dispatch("async/stateUpdate", {state: false});
      let vmId = '';
      const uid =
          isMultiDocUser(this.docID)
              ? account.sourceUid
              : this.docID;
      try {
        const vmtype = account.vmType
        let hbHostname = account.hbHostname
        if(!account.cluster || !account.lxd) {
          const respFromConsul = await this.getDetailsFromConsul(account.hbServiceID)
          console.log('respFromConsul', respFromConsul)
          const {lxd_instance_name, lxd_cluster, hb_hostname} = respFromConsul.meta
          account.cluster = lxd_cluster
          account.instance = lxd_instance_name
          hbHostname = hb_hostname
        }
        const respOfGetinstance = await this.$http.post('/lxd/get-details', {
          grant_type: 'token',
          cluster: account.cluster,
          name: account.instance,
        })
        console.log('respOfGetinstance', respOfGetinstance.data)
        if(respOfGetinstance.data.success) {
          const {disk, disk_usage, disk_usage_percent} = respOfGetinstance.data.data.resources;
          const hdd = {
            total: this.convertToBytes(disk),
            used: this.convertToBytes(disk_usage),
            free: '',
            usedPercent: disk_usage_percent && disk_usage_percent !== '-' ? disk_usage_percent.split('%')[0] : null,
          };
          account.hdd = hdd
          const accountRef = await db.collection('hostingAccounts').doc(uid).get();
          const {accounts} = accountRef.data();
          // const beforePayload = JSON.parse(JSON.stringify(accounts));
          accounts[account.planIndex].primary.hdd = hdd
          accounts[account.planIndex].primary.hbHostname = hbHostname
          // await this.addHostingAccountEventLog({hostingAccountId : this.docID ,  afterPayload: accounts , action: 'Sync VPS Details' , beforePayload: beforePayload})
          await db.collection('hostingAccounts').doc(uid).update({
            accounts: accounts
          })
          try {
            const accMapRef = await db.collection('account-hb')
                .where('uid', '==', this.docID)
                .where('domain', '==', accounts[account.planIndex].primary.domain)
                .get();
            if (accMapRef.size > 0) {
              await db.collection('account-hb')
                  .doc(accMapRef.docs[0].id)
                  .update({
                    hbHostname: hbHostname,
                  });
            }
          } catch (e) {
            console.log(e.toString())
            this.addLog({
              message: e.toString(),
              level: 'danger'
            })
          }
          await this.$http.post('/algolia/reinitialize-user-all-record', {
            grant_type: 'token',
            uid: this.docID,
          });
          await this.addLog({
            uid: this.docID,
            primaryPlan: accounts[account.planIndex].primary.domain,
            message: 'User has Synchronized LXD Details!',
            level: "info"
          });

        }
        this.$store.dispatch("async/stateUpdate", {state: true});
      } catch (err) {
        console.error(err);
        this.$store.dispatch("async/stateUpdate", {state: true});

        this.addLog({
          uid: this.docID,
          message: 'Error in synchronizing LXD Service Details!',
          level: "error"
        });
        swal('Error!', err.response.data.message, 'error');
      }
    },
    async initializeNewBackup(account, index) {
      try {
        console.log('account', account);
        const initiateJob = await this.$http.post('/backup/new-initialize', {
          domain: account.pDomain,
          actionTakenBy: `${this.user.firstName} ${this.user.lastName}`,
          ip: account.serverIP,
          serviceId: account.hbServiceID,
          hostname: account.hbHostname,
          grant_type: 'token',
          uid: this.docID,
          email: this.user.email,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
        });
        this.showToast({
          message: 'You have successfully initialized new backup process.',
          duration: 2000
        }, true, 'success')
      } catch (e) {
        console.log(e.toString())
        this.showToast({
          message: `Something went wrong while initializing new backup. ${e.toString()}`,
          duration: 2000
        }, true, 'danger')
      }

    },
    async initializeBackup(index) {
      if (this.hostingAccounts[index].type === 'Primary Domain') {
        this.mainLoading = true;
        this.operationIndex = index;
        console.log(this.hostingAccounts[index].serverIP);
        await this.$http.post('backup/initialize', {
          grant_type: "token",
          ip: this.hostingAccounts[index].serverIP,
          uid: this.docID,
          email: this.user.email,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
        }).then(() => {
          swal({
            title: "Request Received!",
            text: 'We are initializing the backup server for IP: ' + this.hostingAccounts[index].serverIP,
            type: "success",
          });
          this.addLog({
            uid: this.docID,
            message: 'User has initialize backup for IP: ' + this.hostingAccounts[index].serverIP,
            level: "info"
          });
          this.mainLoading = false;
          this.operationIndex = -1;
        }).catch(e => {
          this.addLog({
            uid: this.docID,
            message: 'Error in Initialize backup request for IP: ' + this.hostingAccounts[index].serverIP,
            level: "error"
          });
          swal({
            title: "Something went wrong!",
            text: e.response.data.message,
            type: "error",
          });
          this.mainLoading = false;
          this.operationIndex = -1;
        });
      }
    },
    updateStatusCake(e, account, index) {
      console.log('2458', account, e.target.value)
      if (e.target.value === 'active') {
        let flag = false;
        let message = ''
        const vmtype = account.vmType || 'openvz/default'
        if (!account.domain || !account.serverIP || (!account.hbServiceID && account.type === 'Primary Domain') || (!account.hbHostname && account.type === 'Primary Domain') || (!account.phpMyAdmin.url && account.type === 'Primary Domain') ||
            !account.phpMyAdmin.password || !account.phpMyAdmin.username || (!account.phpMyAdmin.popupPassword && account.type === 'Primary Domain') || (!account.phpMyAdmin.popupUsername && account.type === 'Primary Domain')) {
          flag = true;
          if (!account.domain) {
            message = 'You cannot set this domain to active because domain field is empty.'
          } else if (!account.serverIP) {
            message = 'You cannot set this domain to active because serverIP field is empty.'
          } else if (!account.hbServiceID && account.type === 'Primary Domain') {
            message = 'You cannot set this domain to active because hbServiceID field is empty.'
          } else if (!account.hbHostname && account.type === 'Primary Domain') {
            message = 'You cannot set this domain to active because hbHostname field is empty.'
          } else if (!account.phpMyAdmin.url && account.type === 'Primary Domain') {
            message = 'You cannot set this domain to active because phpMyAdmin url field is empty.'
          } else if (!account.phpMyAdmin.password) {
            message = 'You cannot set this domain to active because phpMyAdmin password field is empty.'
          } else if (!account.phpMyAdmin.username) {
            message = 'You cannot set this domain to active because phpMyAdmin username field is empty.'
          } else if (!account.phpMyAdmin.popupPassword && account.type === 'Primary Domain') {
            message = 'You cannot set this domain to active because phpMyAdmin popupPassword field is empty.'
          } else if (!account.phpMyAdmin.popupUsername && account.type === 'Primary Domain') {
            message = 'You cannot set this domain to active because phpMyAdmin popupUsername field is empty.'
          }
          // else if(!account.backupUser && account.type === 'Primary Domain') {
          //   message = 'You cannot set this domain to active because backupUser field is empty.'
          // } else if(!account.backupServer && account.type === 'Primary Domain') {
          //   message = 'You cannot set this domain to active because backupServer field is empty.'
          // }
        }
        if (flag) {
          account.status = 'pending'
          swal('Error', message, 'error')
          return false;
        }
      }
      this.mainLoading = true;
      this.operationIndex = index;
      console.log(account);
      console.log(account.status);
      this.$http.post('/status_cake/update_monitor_status', {
        status: account.status,
        UID: this.docID,
        domain: account.domain,
        monitorId: account.monitorId
      }).then(resp => {
        console.log(resp.data);
        swal('Updated!', resp.data.msg, 'success');
        this.addLog({
          uid: this.docID,
          message: 'User has updated Account Status for domain: ' + account.domain,
          level: "info"
        });
      }).catch(e => {
        console.error(e);
        console.log(e.response.data.msg);
        account.status = (account.status === 'pending') ? 'active' : 'pending';
        swal('Error!', e.response.data.msg, 'error');
        this.addLog({
          uid: this.docID,
          message: 'Error in updating Account Status for domain: ' + account.domain,
          level: "error"
        });
      }).finally(() => {
        this.mainLoading = false;
        this.operationIndex = -1;
      });
    },
    unlock() {
      if (this.lockPlanLimit == false) {
        this.lockPlanLimit = true
        return
      }
      const self = this;
      let buttonHtml = '<div>' +
          '<div>Do you want to modify the plan limit?</div>' +
          '<br/>' +
          '<ul class="list-inline">' +
          '<li><button class="sw_butt1 swal2-styled" style="display: inline-block;background-color: rgb(106, 207, 152); border-left-color: rgb(106, 207, 152); border-right-color: rgb(106, 207, 152);">Yes</button></li>' +
          '<li><button class="sw_butt2 swal2-styled" style="display: inline-block; background: #e6c652" >No</button></li>' +
          '</ul></div>';
      swal({
        title: "Would you like to proceed?",
        html: buttonHtml,
        type: 'question',
        showCancelButton: false,
        showConfirmButton: false,
        onOpen: function () {
          console.log('On Opne');
          /* eslint-disable */
          $('.sw_butt1').on('click', function () {
            self.lockPlanLimit = false
            swal.close();
          });
          $('.sw_butt2').on('click', function () {
            swal.close();
          });
          /* eslint-enable */
        }
      });
    },
    checkDomainValidity(domain) {
      return isValidDomain(domain, {subdomain: true, wildcard: false})
    },
    async unlockDomain(data) {
      const uid =
          isMultiDocUser(this.docID)
              ? data.sourceUid
              : this.docID;
      console.log('2538', data)
      let newDomain = ''
      const self = this;
      const {value} = await swal.fire({
        title: "Modify domain",
        input: "text",
        inputPlaceholder: "Enter Domain",
        inputValue: newDomain,
        showCancelButton: true,
        confirmButtonText: 'Submit',
        inputValidator: (value) => {
          if (!value) {
            return "You need to add domain first!";
          } else if (value) {
            const isValidDomain = self.checkDomainValidity(value)
            if (!isValidDomain) {
              return "Please enter valid domain";
            }
          }
        }
      });
      if (value) {
        try {
          const ref = await db.collection('hostingAccounts').doc(uid).get();
          console.log('ref', ref.exists);
          if (ref.exists) {
            const {accounts} = ref.data();
            const {addonIndex, planIndex, domain, serverIP} = data;
            console.log('addon', data);
            if (addonIndex !== null) {
              const obj = accounts[planIndex].addon.find(el => el.domain === value);
              if (obj) {
                swal.fire('Duplicate Domain', 'Domain exists already in the plan', 'error')
                return;
              }
              console.log(accounts[planIndex].addon[addonIndex].domain)
              if (accounts[planIndex].addon[addonIndex].domain === domain) {
                console.log('addon matches')
                accounts[planIndex].addon[addonIndex].domain = value;
              }
            } else {
              if (accounts[planIndex].primary.domain === value) {
                swal.fire('Duplicate Domain', 'Domain exists already in the plan', 'error')
                return;
              }
              if (accounts[planIndex].primary.domain === domain) {
                console.log('primary matches')
                accounts[planIndex].primary.domain = value;
              }
            }
            console.log('modified accounts', accounts[planIndex])
            const domainRef = await db.collection('domains').where('ip', '==', serverIP).where('domain', '==', domain).get();
            if (domainRef.size) {
              const {id} = domainRef.docs[0];
              await db.collection('domains').doc(id).update({domain: value})
            }
            const userRef = await db.collection('users').doc(this.docID).get();
            if (userRef.exists) {
              const {collaborators} = userRef.data();
              if (collaborators && collaborators.length) {
                for (const collaborator of collaborators) {
                  if (collaborator.domains.includes(domain)) {
                    collaborator.domains.splice(collaborator.domains.indexOf(domain), 1);
                    collaborator.domains.push(value)
                  }
                  if (collaborator.uid !== '') {
                    const collaboratorData = await db.collection('users').doc(collaborator.uid).get();
                    if (collaboratorData.exists) {
                      const {supervisors} = collaboratorData.data();
                      for (const supervisor of supervisors) {
                        if (supervisor.supervisorId === this.docID) {
                          supervisor.allowedDomains = collaborator.domains;
                          break;
                        }
                      }
                      console.log(`Updating supervisors of collaborator: ${collaborator.name}`);
                      await db.collection('users').doc(collaborator.uid).update({
                        supervisors,
                      });
                    }
                  }
                }
                console.log('Updating collaborators of users');
                await db.collection('users').doc(this.docID).update({
                  collaborators,
                });
              }
            }
            await db.collection('hostingAccounts').doc(uid).update({accounts, updatedAt: new Date().toISOString()})
          }
        } catch (e) {
          console.log('error at 2632', e.toString())
        }

      }
    },
    deleteAccountItem(account) {
      if (account.isNew) {
        this.$store.commit('hosting/removeNewAccount', account)
        return
      }
      const self = this;
      let buttonHtml = '<div>' +
          '<div>Do you want to remove this domain from the server permanently?</div>' +
          '<br/>' +
          '<ul class="list-inline">' +
          '<li><button class="sw_butt1 swal2-styled" style="display: inline-block;background-color: rgb(106, 207, 152); border-left-color: rgb(106, 207, 152); border-right-color: rgb(106, 207, 152);">Yes</button></li>' +
          '<li><button class="sw_butt2 swal2-styled" style="display: inline-block; background: #e6c652" >No</button></li>' +
          '<li><button class="sw_butt3 swal2-styled" style="display: inline-block; background-color: rgb(238, 128, 87);">Do Not Proceed</button></li>' +
          '</ul></div>';
      swal({
        title: "Would you like to proceed?",
        html: buttonHtml,
        type: 'question',
        showCancelButton: false,
        showConfirmButton: false,
        onOpen: function () {
          console.log('On Opne');
          /* eslint-disable */
          $('.sw_butt1').on('click', function () {
            self.removeDomain(account, true);
            swal.close();
          });
          $('.sw_butt2').on('click', function () {
            self.removeDomain(account, false);
            swal.close();
          });
          $('.sw_butt3').on('click', function () {
            console.log('close');
            swal.close();
          });
          /* eslint-enable */
        }
      });
    },
    checkAddons(planIndex) {
      let proceed = true;
      const addons = this.realHostingAccounts[planIndex].addon
      if (addons.length > 0) {
        for (let addon of addons) {
          if (!this.processingDomainList.find(el => el.inputDomain === addon.domain && el.jobName === 'remove-domain')) {
            proceed = false
          }
        }
      }
      return proceed
    },
    async removeDomain(account, permanently) {
      this.removeLoader = true;
      const uid =
          isMultiDocUser(this.docID)
              ? account.sourceUid
              : this.docID;
      const isShowIt = isMultiDocUser(this.docID)
      try {
        await db.collection('new_plans').doc(account.domain).delete();
      } catch (e) {
        console.log('Error in deleting plan from check cron server');
        console.log(e.toString());
      }
      console.log('Account to be deleted:\n');
      console.log(account);
      if (account.type === 'Primary Domain') {
        const proceed = this.checkAddons(account.planIndex)
        if (!proceed) {
          await delay(300);
          this.addLog({
            message: 'This primary account has some add-on domains! Please first remove all add-on domains before removing this.',
            level: 'info'
          })
          this.removeLoader = false;
          swal('Please Note!', 'This primary account has some add-on domains! Please first remove all add-on domains before removing this.', 'warning');
          return;
        }
      }
      // this.$store.commit('hosting/mutateRemoveNewAccount', account.accountNumber);
      if (!account.isNew && validate.ipv4(account.serverIP) && account.domain) {
        console.log('Added in delete domain array');
        // account.removePermanently = permanently;
        // this.deleteDomains.push(account);
        // this.updateHostingAccounts();
        this.removeLoader = true;
        let allRecords = JSON.parse(JSON.stringify(this.$store.getters["hosting/accountsOrdered"]))
        let obj = allRecords.find(el => {
          return el.planIndex == account.planIndex && el.addonIndex == null
        })
        // await this.updateDomainForRemoval(account)
        this.$http.post('domain/remove_domain', {
          primaryDomain: account.addonPrimaryDomain,
          domain: account.domain,
          ip: account.serverIP,
          UID: this.docID,
          sourceUid: isShowIt ? account.sourceUid : '',
          clientId: this.custID,
          primaryIndex: account.planIndex,
          addonIndex: account.addonIndex,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          statusCakeTestId: account.statusCakeTestId,
          monitorId: account.monitorId || '',
          isAdmin: true,
          grant_type: "token",
          removePermanently: permanently
        }).then(async () => {
          this.removeLoader = false;
          swal({
            title: "Removing!",
            text: `We are now removing the domain ${permanently === true ? 'from server!' : ''}`,
            type: "success",
          });
          this.addLog({
            uid: this.docID,
            message: `User has enqueued remove domain job for domain: ${account.domain}`,
            level: "info"
          });
        }).catch(() => {
          this.removeLoader = false;
          swal({
            title: "Something went wrong!",
            text: 'Please contact support',
            type: "error",
          });
          this.addLog({
            uid: this.docID,
            message: `Error in enqueuing remove domain job for domain: ${account.domain}`,
            level: "error"
          });
        })
      } else {
        if (!account.isNew) {
          // const beforePayload = JSON.parse(JSON.stringify(this.realHostingAccounts));
          if (account.type === 'Primary Domain') {
            this.realHostingAccounts.splice(parseInt(account.planIndex, 10), 1)
          } else {
            this.realHostingAccounts[parseInt(account.planIndex, 10)].addon.splice(parseInt(account.addonIndex, 10), 1)
          }
          // await this.addHostingAccountEventLog({hostingAccountId : this.docID ,  afterPayload: this.realHostingAccounts , action: 'Remove Domain' , beforePayload: beforePayload})
          await db.collection('hostingAccounts').doc(uid).update({
            accounts: this.realHostingAccounts
          });
          await this.addLog({
            uid: this.docID,
            primaryPlan: this.realHostingAccounts[parseInt(account.planIndex, 10)].primary.domain,
            message: `User has removed the Domain: ${account.domain} locally, Plan Index: ${account.planIndex}`,
            level: "info"
          })
        } else {
          this.$store.commit('hosting/removeNewAccount', account)
        }
      }

      this.removeLoader = false;
    },
    async updateDomainForRemoval(data) {
      try {
        // let allAccounts=this.$store.getters["hosting/accountsOrdered"]
        const hostingAccountRef = await db.collection('hostingAccounts').doc(this.docID).get();
        const {accounts} = hostingAccountRef.data();
        const beforePayload = JSON.parse(JSON.stringify(accounts));
        const plan = accounts[data.planIndex]
        if (plan.primary.domain === data.domain && data.addonIndex === null) {
          plan.primary.deleted = true
        } else if (plan && plan.addon && data.addonIndex !== null && plan.addon[data.addonIndex].domain === data.domain) {
          plan.addon[data.addonIndex].deleted = true;
          // plan.addon.map((item) => {
          //   if (item.domain === data.domain) {
          //     item.deleted = true;
          //   }
          // });
        } else {
          for (const [index, row] of accounts.entries()) {
            if (row.primary.domain === data.domain) {
              row.primary.deleted = true;
              data.planIndex = index;
            } else {
              for (const [index1, addon] of row.addon.entries()) {
                if (addon.domain === data.domain) {
                  data.planIndex = index;
                  data.addonIndex = index1;
                  addon.deleted = true;
                }
              }
            }
          }
        }
        // await this.addHostingAccountEventLog({hostingAccountId : this.docID ,  afterPayload: accounts , action: 'Update Domain For Removal', beforePayload: beforePayload})
        await db.collection('hostingAccounts').doc(this.docID).update({
          accounts,
        });
      } catch (e) {
        console.log(e.toString())
      }
    },
    async runScriptAccountItem(account, fresh) {

      try {
        let currentDomain = account.domain;
        const {domain, ftp, serverIP} = account;
        if (!serverIP) {
          this.addLog({
            message: `You need fill server ip for ${domain}`,
            level: "danger"
          })
          swal('Error!', `You need fill server ip for ${domain}`, 'error');
          throw new Error(`You need fill server ip for ${domain}`);
        }

        this.$store.dispatch("async/stateUpdate", {state: false});

        const resp = await db.collection("users")
            .doc(this.docID).get();
        let user = resp.data();
        let realAccount;
        if (account.addonIndex !== null) {
          realAccount = this.realHostingAccounts[account.planIndex].addon[account.addonIndex];
        } else {
          realAccount = this.realHostingAccounts[account.planIndex].primary;
        }

        console.log(account.planIndex);
        console.log(account.addonIndex);
        console.log(this.realHostingAccounts[account.planIndex])
        console.log(this.realHostingAccounts);
        console.log(realAccount);
        const isShowIt = isMultiDocUser(this.docID)

        let res = await this.$http.post("domain/sync-domain-data", {
          ip: serverIP,
          domain: currentDomain,
          grant_type: "token",
          fresh: (fresh) ? 'true' : 'false',
          addonDomainStructure: JSON.stringify(realAccount),
          firstName: user.firstName,
          lastName: user.lastName,
          existingPlanIndex: account.planIndex,
          existingAdOnIndex: account.addonIndex, //passing the index of newly added adon domain object...
          UID: this.docID,
          custId: user.customerID,
          type: 'freash',
          source: '',
          isPrimary: (account.addonIndex === null),
          sourceUid: isShowIt ? account.sourceUid : '',
        });
        console.log(res.data.msg);
        this.addLog({
          message: `Start Processing The Domain Now!`,
          level: "info"
        })
        swal({
          title: 'Success!',
          text: 'Start Processing The Domain Now!',
          type: "success",
        });
        await this.addLog({
          uid: this.docID,
          primaryPlan: account.domain,
          message: 'User has Synchronized FTP / DB for' + account.domain,
          level: 'info'
        });
        this.$store.dispatch("async/stateUpdate", {state: true});
      } catch (e) {
        this.$store.dispatch("async/stateUpdate", {state: true});
        this.addLog({
          message: `Something went wrong ${e.message}`,
          level: "danger"
        })
        swal({
          title: "Something went wrong!",
          text: e.message,
          type: "error",
          confirmButtonText: "Try Again!",
          confirmButtonColor: "#EE8057"
        });
      }
    },
    autoPopulateData(data, index) {
      // First parse the received data in JSON format
      const jsonData = JSON.parse(data);
      // Now based on the details present in the jsonData update the respective details for the respective account
      if (jsonData.domain) {
        this.hostingAccounts[index].domain = jsonData.domain;
      }
      this.hostingAccounts[index].serverIP = jsonData.serverIP;
      if (jsonData.flushOpcacheURL) {
        this.hostingAccounts[index].flushOpcacheURL = jsonData.flushOpcacheURL;
      }
      this.hostingAccounts[index].ftp = jsonData.ftp;

      this.hostingAccounts[index].phpMyAdmin = jsonData.phpMyAdmin;

      /*this.hostingAccounts[index].cloudflare = jsonData.cloudflare || {
                  username: "",
                  password: "",
                  userKey: "",
                  apiKey: "",
                  zone_id: "",
                  nameserver1: "",
                  nameserver2: ""
              };*/
    },
    autoPopulateStagingData(data, index) {
      // Parse the received data into valid JSON format
      const stagingData = JSON.parse(data);
      // Once we have the JSON data, lets put it into the respective fields
      this.hostingAccounts[index].staging.domain = stagingData.domain;
      if (stagingData.flushOpcacheURL) {
        this.hostingAccounts[index].staging.flushOpcacheURL =
            stagingData.flushOpcacheURL;
      }
      this.hostingAccounts[index].staging.freashInstall = false;
      this.hostingAccounts[index].staging.ftp = stagingData.ftp;

      this.hostingAccounts[index].staging.phpMyAdmin = stagingData.phpMyAdmin;
    },
    removeStagingAcc(index) {
      this.hostingAccounts[index].staging.enabled = false;

      // Set all populated Staging data to blank
      this.hostingAccounts[index].staging.domain = "";
      this.hostingAccounts[index].staging.flushOpcacheURL = "";
      this.hostingAccounts[index].staging.freashInstall = false;
      // this.hostingAccounts[index].staging.ftp.host = "";
      // Do not clearing the FTP Port, Mode and PASV data as in most case it will remain default
      this.hostingAccounts[index].staging.ftp.username = "";
      this.hostingAccounts[index].staging.ftp.password = "";
      this.hostingAccounts[index].staging.phpMyAdmin.url = "";
      this.hostingAccounts[index].staging.phpMyAdmin.popupUsername = "";
      this.hostingAccounts[index].staging.phpMyAdmin.popupPassword = "";
      this.hostingAccounts[index].staging.phpMyAdmin.username = "";
      this.hostingAccounts[index].staging.phpMyAdmin.password = "";
      this.addLog({
        uid: this.docID,
        message: 'User has removed staging account for' + this.hostingAccounts[index].domain,
        level: "info"
      });
    },
    addNewHostingAccount() {
      if (confirm("Are you sure you want to add a new hosting account?")) {
        // this.hostingAccounts.unshift();
        this.$store.commit('hosting/mutateAddNewAccount', {
          domain: "",
          serverIP: "",
          planName: "",
          status: "pending",
          flushOpcacheURL: "",
          freashInstall: false,
          comparisonID: "",
          ftp: {
            host: "",
            port: "21",
            mode: "FTP (explicit SSL)",
            pasv: "Ensure is Checked/Enabled",
            username: "",
            password: "",
            accounts: [
              {
                username: "",
                password: "",
              }
            ]
          },
          phpMyAdmin: {
            url: "",
            popupUsername: "",
            popupPassword: "",
            username: "",
            password: ""
          },
          cloudflare: {
            username: "",
            password: "",
            userKey: "",
            apiKey: "",
            zone_id: "",
            nameserver1: "",
            nameserver2: ""
          },
          manualBackups: [],
          redirects: [],
          staging: {
            enabled: false,
            domain: "",
            flushOpcacheURL: "",
            freashInstall: false,
            ftp: {
              host: "",
              port: "21",
              mode: "FTP (explicit SSL)",
              pasv: "Ensure is Checked/Enabled",
              username: "",
              password: "",
              accounts: [
                {
                  username: "",
                  password: "",
                }
              ]
            },
            phpMyAdmin: {
              url: "",
              popupUsername: "",
              popupPassword: "",
              username: "",
              password: ""
            },
            manualBackups: [],
            redirects: []
          },
          accountNumber: parseInt(this.$store.getters['hosting/getNextAccountNumber']),
          isNew: true
        })
        this.addLog({
          uid: this.docID,
          message: 'User has added new hosting account',
          level: "info"
        });
      }
    },
    checkUndefined(data) {
      if (typeof data === "undefined" || data === null) {
        return "";
      } else {
        return data;
      }
    },
    checkFTPAccounts(account) {
      if (account.ftp && account.ftp.accounts) {
        return account.ftp.accounts
      } else if (account.ftp.username && account.ftp.password) {
        return [
          {
            username: this.checkUndefined(account.ftp.username),
            password: this.checkUndefined(account.ftp.password),
          }
        ]
      } else {
        return []
      }
    },
    async updateHostingAccounts2() {

      this.$store.commit("hosting/updateUserAccountFilters", {
        showRecords: this.showRecords,
        typeSearch: this.typeSearch,
        statusSearch: this.statusSearch,
        searchQuery: this.searchQuery
      });
      await this.addLog({
        primaryPlan: 'Account Based Operation',
        uid: this.docID,
        message: 'Start updating hosting accounts',
        level: "info"
      });
      // Updated the hosting account details to the Firestore Database
      //if (this.hostingAccounts.length > 0) {
      // Set asyncDone to false
      await this.$store.dispatch("async/stateUpdate", {state: false});
      const allAccountsToUpdate = this.$store.getters["hosting/accountsOrdered"];

      // const allDomains = []
      // let isDomainExists=false;
      // for(let acc of allAccountsToUpdate){
      //   if (allDomains.includes(acc.domain)) {
      //     isDomainExists = true
      //     break;
      //   } else {
      //     allDomains.push(acc.domain)
      //   }
      // }
      // console.log('isDomainExists',isDomainExists)
      // if (isDomainExists) {
      //   await this.$store.dispatch("async/stateUpdate", {state: true});
      //   swal({
      //     title: "Warning!",
      //     text: "Unable to update domain name as it already exists.",
      //     type: "error",
      //   });
      //   return false
      // }


      // Filter the hostingAccounts array and take out the autoPopulate data out of it
      const hostingAccountsFiltered = [];

      allAccountsToUpdate.forEach(acc => {
        delete acc["autopopulateData"];
        delete acc.staging["autopopulateData"];
        hostingAccountsFiltered.push(acc);
      });
      //console.log(hostingAccountsFiltered);
      // Loop through hostingAccountsFiltered and order the accounts accordingly
      const hostingAccOrdered = [];

      hostingAccountsFiltered.forEach(account => {
        if (account.type === "Primary Domain") {
          let cloudflarePlans = Array.isArray(account.cloudflarePlan) ? [] : account.cloudflarePlan || 'free';
          if (Array.isArray(account.cloudflarePlan) && account.cloudflarePlan.length) {
            if (!account.cloudflarePlan.includes('mediavine_integration') && !account.cloudflarePlan.includes('mediavine_security') && !account.cloudflarePlan.includes('mediavine_integration')) {
              cloudflarePlans = account.cloudflarePlan[0]
            } else {
              cloudflarePlans = account.cloudflarePlan
            }
          }
          console.log(cloudflarePlans)
          hostingAccOrdered.push({
            planName: account.planName,
            migration: account.migration || {count: 0, log: []},
            sourceUid: account.sourceUid || this.docID,
            primary: {
              uuid: account.uuid || uuidv4(),
              disableBackupAccess: account.disableBackupAccess || false,
              sslFlag: account.sslFlag || false,
              hbServiceID: this.checkUndefined(account.hbServiceID),
              solusVM_VPS_ID: this.checkUndefined(account.solusVM_VPS_ID),
              hbHostname: this.checkUndefined(account.hbHostname),
              hdd: this.checkUndefined(account.hdd),
              aliases: account.aliases || [],
              siteType: account.siteType || 'standalone',
              domain: account.domain,
              suspended: account.suspended || false,
              manualBackups: account.manualBackups || [],
              tags: account.tags || [],
              notes: account.notes || [],
              backupServer: this.checkUndefined(account.backupServer),
              backupUser: this.checkUndefined(account.backupUser),
              backupLimit: this.checkUndefined(account.backupLimit),
              serverIP: this.checkUndefined(account.serverIP),
              status: account.status,
              deleted: account.deleted || false,
              comparisonID: this.checkUndefined(account.comparisonID),
              flushOpcacheURL: this.checkUndefined(account.flushOpcacheURL),
              freashInstall: account.freashInstall || false,
              statusCakeTestId: account.statusCakeTestId || '',
              monitorId: account.monitorId || '',
              installation_type: account.installation_type || '',
              cloudflarePlan: cloudflarePlans,
              home_path: account.home_path || `/home/nginx/domains/${account.domain}`,
              ftp: {
                host: this.checkUndefined(account.serverIP),
                port: this.checkUndefined(account.ftp.port),
                mode: this.checkUndefined(account.ftp.mode),
                pasv: this.checkUndefined(account.ftp.pasv),
                username: this.checkUndefined(account.ftp.username),
                password: this.checkUndefined(account.ftp.password),
                accounts: this.checkFTPAccounts(account),
              },
              phpMyAdmin: {
                url: this.checkUndefined(account.phpMyAdmin.url),
                popupUsername: this.checkUndefined(
                    account.phpMyAdmin.popupUsername
                ),
                popupPassword: this.checkUndefined(
                    account.phpMyAdmin.popupPassword
                ),
                username: this.checkUndefined(account.phpMyAdmin.username),
                password: this.checkUndefined(account.phpMyAdmin.password)
              },
              redirects: account.redirects || [],
              cloudflare: {
                accountID: this.checkUndefined(account.cloudflare.accountID),
                username: this.checkUndefined(account.cloudflare.username),
                password: this.checkUndefined(account.cloudflare.password),
                userKey: this.checkUndefined(account.cloudflare.userKey),
                apiKey: this.checkUndefined(account.cloudflare.apiKey),
                zone_id: this.checkUndefined(account.cloudflare.zone_id),
                nameserver1: this.checkUndefined(account.cloudflare.nameserver1),
                nameserver2: this.checkUndefined(account.cloudflare.nameserver2)
              },
              blockIpsList: account.blockIpsList || [],
              diskSpace: account.diskSpace || [],
              maxSubSitesAddonLimit: account.maxSubSitesAddonLimit || 0,
              staging: {
                enabled: account.staging.enabled,
                domain: account.staging.domain,
                flushOpcacheURL: account.staging.flushOpcacheURL || '',
                freashInstall: account.staging.freashInstall || false,
                statusCakeTestId: account.staging.statusCakeTestId || '',
                manualBackups: account.staging.manualBackups || [],
                tags: account.staging.tags || [],
                redirects: account.staging.redirects || [],
                diskSpace: account.staging.diskSpace || [],
                ftp: {
                  host: this.checkUndefined(account.serverIP),
                  port: this.checkUndefined(account.staging.ftp.port),
                  mode: this.checkUndefined(account.staging.ftp.mode),
                  pasv: this.checkUndefined(account.staging.ftp.pasv),
                  username: this.checkUndefined(account.staging.ftp.username),
                  password: this.checkUndefined(account.staging.ftp.password),
                  accounts: this.checkFTPAccounts(account.staging),
                },
                phpMyAdmin: {
                  url: account.staging.phpMyAdmin ? this.checkUndefined(account.staging.phpMyAdmin.url) : '',
                  popupUsername: account.staging.phpMyAdmin ? this.checkUndefined(
                      account.staging.phpMyAdmin.popupUsername
                  ) : '',
                  popupPassword: account.staging.phpMyAdmin ? this.checkUndefined(
                      account.staging.phpMyAdmin.popupPassword
                  ) : '',
                  username: account.staging.phpMyAdmin ? this.checkUndefined(
                      account.staging.phpMyAdmin.username
                  ) : '',
                  password: account.staging.phpMyAdmin ? this.checkUndefined(
                      account.staging.phpMyAdmin.password
                  ) : ''
                }
              }
            },
            planLimit: account.planLimit,
            extraDomains: account.extraDomains,
            maxStorageSize: account.maxStorageSize,
            maxVisitors: account.maxVisitors,
            maxSubSitesLimit: account.maxSubSitesLimit || 0,
            planType: account.planType || 'standalone',
            maxMigrations: this.checkUndefined(account.maxMigrations),
            fullDiskSpace: account.fullDiskSpace || [],
            addon: [],
            pServerIp: account.pServerIp,
            pDomain: account.pDomain,
            tag: account.tag || '',
            tagColor: account.tagColor || '',
          });
        }
      });
      // Now add the addon domains
      hostingAccountsFiltered.forEach(account => {
        const pDomain = account.addonPrimaryPlan ? account.addonPrimaryPlan.split(':')[0] : ''
        if (account.type === "Addon Domain") {
          console.log(`type f ${account.cloudflarePlan}`)
          let cloudflarePlans = Array.isArray(account.cloudflarePlan) ? [] : account.cloudflarePlan || 'free';
          if (Array.isArray(account.cloudflarePlan) && account.cloudflarePlan.length) {
            if (!account.cloudflarePlan.includes('mediavine_integration') && !account.cloudflarePlan.includes('mediavine_security') && !account.cloudflarePlan.includes('mediavine_integration')) {
              cloudflarePlans = account.cloudflarePlan[0]
            } else {
              cloudflarePlans = account.cloudflarePlan
            }
          }
          console.log('addon plan', cloudflarePlans)
          let primaryDomainIndex = hostingAccOrdered.findIndex(acc => {
            return acc.primary.domain + ':' + acc.primary.serverIP === account.addonPrimaryPlan;
          });
          if (primaryDomainIndex < 0) { //pDomain
            primaryDomainIndex = hostingAccOrdered.findIndex(acc => {
              return acc.pDomain + ':' + acc.pServerIp === pDomain + ':' + account.pServerIp;
            });
          }
          if (primaryDomainIndex < 0) {
            primaryDomainIndex = hostingAccOrdered.findIndex(acc => {
              return acc.pDomain === account.addonPrimaryDomain;
            });
          }
          console.log(primaryDomainIndex)
          console.log('primaryDomainIndex')
          hostingAccOrdered[primaryDomainIndex].addon.push({
            uuid: account.uuid || uuidv4(),
            sslFlag: account.sslFlag || false,
            aliases: account.aliases || [],
            domain: account.domain,
            siteType: account.siteType || 'standalone',
            maxSubSitesAddonLimit: account.maxSubSitesAddonLimit || 0,
            manualBackups: account.manualBackups || [],
            tags: account.tags || [],
            notes: account.notes || [],
            chargable: false,
            serverIP: this.checkUndefined(account.serverIP),
            status: account.status,
            deleted: account.deleted || false,
            comparisonID: this.checkUndefined(account.comparisonID),
            flushOpcacheURL: this.checkUndefined(account.flushOpcacheURL),
            freashInstall: account.freashInstall || false,
            statusCakeTestId: account.statusCakeTestId || '',
            monitorId: account.monitorId || '',
            redirects: account.redirects || [],
            cloudflarePlan: cloudflarePlans,
            installation_type: account.installation_type || '',
            home_path: account.home_path || `/home/nginx/domains/${account.domain}`,
            ftp: {
              host: this.checkUndefined(account.serverIP),
              port: this.checkUndefined(account.ftp.port),
              mode: this.checkUndefined(account.ftp.mode),
              pasv: this.checkUndefined(account.ftp.pasv),
              username: this.checkUndefined(account.ftp.username),
              password: this.checkUndefined(account.ftp.password),
              accounts: this.checkFTPAccounts(account),
            },
            phpMyAdmin: {
              url: this.checkUndefined(account.phpMyAdmin.url),
              popupUsername: this.checkUndefined(
                  account.phpMyAdmin.popupUsername
              ),
              popupPassword: this.checkUndefined(
                  account.phpMyAdmin.popupPassword
              ),
              username: this.checkUndefined(account.phpMyAdmin.username),
              password: this.checkUndefined(account.phpMyAdmin.password)
            },
            cloudflare: {
              accountID: this.checkUndefined(account.cloudflare.accountID),
              username: this.checkUndefined(account.cloudflare.username),
              password: this.checkUndefined(account.cloudflare.password),
              userKey: this.checkUndefined(account.cloudflare.userKey),
              apiKey: this.checkUndefined(account.cloudflare.apiKey),
              zone_id: this.checkUndefined(account.cloudflare.zone_id),
              nameserver1: this.checkUndefined(account.cloudflare.nameserver1),
              nameserver2: this.checkUndefined(account.cloudflare.nameserver2)
            },
            diskSpace: account.diskSpace || [],
            staging: {
              enabled: account.staging.enabled,
              domain: account.staging.domain || '',
              flushOpcacheURL: account.staging.flushOpcacheURL || '',
              freashInstall: account.staging.freashInstall || false,
              statusCakeTestId: account.staging.statusCakeTestId || '',
              redirects: account.staging.redirects || [],
              manualBackups: account.staging.manualBackups || [],
              tags: account.staging.tags || [],
              diskSpace: account.staging.diskSpace || [],
              ftp: {
                host: this.checkUndefined(account.serverIP),
                port: account.staging.ftp.port ? this.checkUndefined(account.staging.ftp.port) : '21',
                mode: account.staging.ftp.mode ? this.checkUndefined(account.staging.ftp.mode) : '',
                pasv: account.staging.ftp.pasv ? this.checkUndefined(account.staging.ftp.pasv) : '',
                username: this.checkUndefined(account.staging.ftp.username),
                password: this.checkUndefined(account.staging.ftp.password),
                accounts: this.checkFTPAccounts(account.staging),
              },
              phpMyAdmin: {
                url: account.staging.phpMyAdmin ? this.checkUndefined(account.staging.phpMyAdmin.url) : '',
                popupUsername: account.staging.phpMyAdmin ? this.checkUndefined(
                    account.staging.phpMyAdmin.popupUsername
                ) : '',
                popupPassword: account.staging.phpMyAdmin ? this.checkUndefined(
                    account.staging.phpMyAdmin.popupPassword
                ) : '',
                username: account.staging.phpMyAdmin ? this.checkUndefined(
                    account.staging.phpMyAdmin.username
                ) : '',
                password: account.staging.phpMyAdmin ? this.checkUndefined(
                    account.staging.phpMyAdmin.password
                ) : ''
              }
            }
          });
        }
      });
      for (const ach of hostingAccOrdered) {
        delete ach.pServerIp
        delete ach.pDomain
      }
      console.log('Updating awaiting cron jobs for check new servers');
      for (const account of hostingAccountsFiltered) {
        if (account.type === "Primary Domain" && account.domain !== '') {
          const awaitingCronJobRef = await db.collection('new_plans').doc(account.domain).get();
          if (awaitingCronJobRef.exists) {
            const cronJobData = awaitingCronJobRef.data();
            cronJobData.ip = account.serverIP;
            await db.collection('new_plans').doc(account.domain).update(cronJobData);
          }
        }
      }
      const aaccc = JSON.parse(JSON.stringify(hostingAccOrdered))
      try {
        // Step 1: Group accounts by sourceUid
        const accountMap = {};

        aaccc.forEach(acc => {
          if (!accountMap[acc.sourceUid]) {
            accountMap[acc.sourceUid] = [];
          }
          accountMap[acc.sourceUid].push(acc);
        });
        // Step 2: Save each group to its respective document
        await Promise.all(
            Object.entries(accountMap).map(async ([docId, accounts]) => {
              return db.collection('hostingAccounts').doc(docId).set({
                uid: docId,
                updatedAt: new Date().toISOString(),
                accounts,
              });
            })
        );

        await this.addLog({
          uid: this.docID,
          message: 'User has updated Hosting Accounts!',
          level: "info"
        });
        await this.$http.post('/algolia/reinitialize-user-all-record', {
          grant_type: 'token',
          uid: this.docID,
        })
        await this.$store.dispatch("hosting/fetchAccountsAdmin", {
          UID: this.docID
        });
        //console.log("Update", this.hostingAccDB);

        // Set asyncDone to true
        await this.$store.dispatch("async/stateUpdate", {state: true});

        // Show success message to the admin for 8 sec
        await this.$store.dispatch("alert/update", {
          type: "success",
          message: `The hosting account details for the Customer (Cust ID#: ${
              this.custID
          }) has been updated successfully.`,
          show: true
        });

        setTimeout(() => {
          this.$store.dispatch("alert/showUpdate", {show: false});
        }, 8000);
      } catch (err) {
        // Set asyncDone to true
        this.$store.dispatch("async/stateUpdate", {state: true});

        // Show the error to the admin for 5 sections
        this.$store.dispatch("alert/update", {
          type: "danger",
          message: err,
          show: true
        });

        setTimeout(() => {
          this.$store.dispatch("alert/showUpdate", {show: false});
        }, 5000);
      }
      return
      // await this.addHostingAccountEventLog({hostingAccountId : this.docID ,  afterPayload: hostingAccOrdered , beforePayload: false, action: 'Update Account details' })
      const realHAccounts = aaccc.filter(el => el.sourceUid === this.docID)
      const dupHAccounts = aaccc.filter(el => el.sourceUid === `${this.docID}_dup2`)
      db
          .collection("hostingAccounts")
          .doc(this.docID)
          .set({
            uid: this.docID,
            updatedAt: new Date().toISOString(),
            accounts: realHAccounts
          })
          .then(async () => {
            if (this.docID === this.showItUID) {
              await db
                  .collection("hostingAccounts")
                  .doc(`${this.docID}_dup2`)
                  .set({
                    updatedAt: new Date().toISOString(),
                    accounts: dupHAccounts,
                    uid: `${this.docID}_dup2`
                  })
            }
            await this.addLog({
              uid: this.docID,
              message: 'User has updated Hosting Accounts!',
              level: "info"
            });
            await this.$http.post('/algolia/reinitialize-user-all-record', {
              grant_type: 'token',
              uid: this.docID,
            })
            await this.$store.dispatch("hosting/fetchAccountsAdmin", {
              UID: this.docID
            });
            //console.log("Update", this.hostingAccDB);

            // Set asyncDone to true
            await this.$store.dispatch("async/stateUpdate", {state: true});

            // Show success message to the admin for 8 sec
            await this.$store.dispatch("alert/update", {
              type: "success",
              message: `The hosting account details for the Customer (Cust ID#: ${
                  this.custID
              }) has been updated successfully.`,
              show: true
            });

            setTimeout(() => {
              this.$store.dispatch("alert/showUpdate", {show: false});
            }, 8000);
          })
          .catch(err => {
            // Set asyncDone to true
            this.$store.dispatch("async/stateUpdate", {state: true});

            // Show the error to the admin for 5 sections
            this.$store.dispatch("alert/update", {
              type: "danger",
              message: err,
              show: true
            });

            setTimeout(() => {
              this.$store.dispatch("alert/showUpdate", {show: false});
            }, 5000);
          });
      /*} else {
                  // Show error alert to the customer for 5 sec
                  this.$store.dispatch("alert/update", {
                      type: "danger",
                      message:
                          "Please make sure you have atleast one hosting account added",
                      show: true
                  });

                  setTimeout(() => {
                      this.$store.dispatch("alert/showUpdate", {show: false});
                  }, 8000);
              }*/
    },
    async updateHostingAccounts() {
      this.hostingLoading = true
      this.$parent.hostingLoading = true
      await this.$store.commit("hosting/updateUserAccountFilters", {
        showRecords: this.showRecords,
        typeSearch: this.typeSearch,
        statusSearch: this.statusSearch,
        searchQuery: this.searchQuery
      });
      await this.addLog({
        primaryPlan: 'Account Based Operation',
        uid: this.docID,
        message: 'Start updating hosting accounts',
        level: "info"
      });
      console.log('3997 hostingLoading', this.hostingLoading)
      // Updated the hosting account details to the Firestore Database
      //if (this.hostingAccounts.length > 0) {
      // Set asyncDone to false
      // await this.$store.dispatch("async/stateUpdate", {state: false});
      const allAccountsToUpdate = this.$store.getters["hosting/accountsOrdered"];

      // const allDomains = []
      // let isDomainExists=false;
      // for(let acc of allAccountsToUpdate){
      //   if (allDomains.includes(acc.domain)) {
      //     isDomainExists = true
      //     break;
      //   } else {
      //     allDomains.push(acc.domain)
      //   }
      // }
      // console.log('isDomainExists',isDomainExists)
      // if (isDomainExists) {
      //   await this.$store.dispatch("async/stateUpdate", {state: true});
      //   swal({
      //     title: "Warning!",
      //     text: "Unable to update domain name as it already exists.",
      //     type: "error",
      //   });
      //   return false
      // }


      // Filter the hostingAccounts array and take out the autoPopulate data out of it
      const hostingAccountsFiltered = [];
      console.log('4028 hostingLoading', this.hostingLoading)

      allAccountsToUpdate.forEach(acc => {
        delete acc["autopopulateData"];
        delete acc.staging["autopopulateData"];
        hostingAccountsFiltered.push(acc);
      });
      //console.log(hostingAccountsFiltered);
      // Loop through hostingAccountsFiltered and order the accounts accordingly
      const hostingAccOrdered = [];

      for (const account of hostingAccountsFiltered) {
        if (account.type === "Primary Domain") {
          let cloudflarePlans = Array.isArray(account.cloudflarePlan) ? [] : account.cloudflarePlan || 'free';
          if (Array.isArray(account.cloudflarePlan) && account.cloudflarePlan.length) {
            if (!account.cloudflarePlan.includes('mediavine_integration') && !account.cloudflarePlan.includes('mediavine_security') && !account.cloudflarePlan.includes('optimization_pro') && !account.cloudflarePlan.includes('security_pro') && !account.cloudflarePlan.includes('mediavine_integration')) {
              cloudflarePlans = account.cloudflarePlan[0]
            } else {
              cloudflarePlans = account.cloudflarePlan
            }
          }
          console.log(cloudflarePlans)
          hostingAccOrdered.push({
            planName: account.planName,
            migration: account.migration || {count: 0, log: []},
            sourceUid: account.sourceUid || this.docID,
            primary: {
              uuid: account.uuid || uuidv4(),
              disableBackupAccess: account.disableBackupAccess || false,
              sslFlag: account.sslFlag || false,
              hbServiceID: this.checkUndefined(account.hbServiceID),
              solusVM_VPS_ID: this.checkUndefined(account.solusVM_VPS_ID),
              hbHostname: this.checkUndefined(account.hbHostname),
              hdd: this.checkUndefined(account.hdd),
              aliases: account.aliases || [],
              siteType: account.siteType || 'standalone',
              domain: account.domain,
              suspended: account.suspended || false,
              manualBackups: account.manualBackups || [],
              tags: account.tags || [],
              notes: account.notes || [],
              backupServer: this.checkUndefined(account.backupServer),
              backupUser: this.checkUndefined(account.backupUser),
              backupLimit: this.checkUndefined(account.backupLimit),
              serverIP: this.checkUndefined(account.serverIP),
              status: account.status,
              deleted: account.deleted || false,
              comparisonID: this.checkUndefined(account.comparisonID),
              flushOpcacheURL: this.checkUndefined(account.flushOpcacheURL),
              freashInstall: account.freashInstall || false,
              statusCakeTestId: account.statusCakeTestId || '',
              monitorId: account.monitorId || '',
              installation_type: account.installation_type || '',
              cloudflarePlan: cloudflarePlans,
              home_path: account.home_path || `/home/nginx/domains/${account.domain}`,
              ftp: {
                host: this.checkUndefined(account.serverIP),
                port: this.checkUndefined(account.ftp.port),
                mode: this.checkUndefined(account.ftp.mode),
                pasv: this.checkUndefined(account.ftp.pasv),
                username: this.checkUndefined(account.ftp.username),
                password: this.checkUndefined(account.ftp.password),
                accounts: this.checkFTPAccounts(account),
              },
              phpMyAdmin: {
                url: this.checkUndefined(account.phpMyAdmin.url),
                popupUsername: this.checkUndefined(
                    account.phpMyAdmin.popupUsername
                ),
                popupPassword: this.checkUndefined(
                    account.phpMyAdmin.popupPassword
                ),
                username: this.checkUndefined(account.phpMyAdmin.username),
                password: this.checkUndefined(account.phpMyAdmin.password)
              },
              redirects: account.redirects || [],
              cloudflare: {
                accountID: this.checkUndefined(account.cloudflare.accountID),
                username: this.checkUndefined(account.cloudflare.username),
                password: this.checkUndefined(account.cloudflare.password),
                userKey: this.checkUndefined(account.cloudflare.userKey),
                apiKey: this.checkUndefined(account.cloudflare.apiKey),
                zone_id: this.checkUndefined(account.cloudflare.zone_id),
                nameserver1: this.checkUndefined(account.cloudflare.nameserver1),
                nameserver2: this.checkUndefined(account.cloudflare.nameserver2)
              },
              blockIpsList: account.blockIpsList || [],
              diskSpace: account.diskSpace || [],
              maxSubSitesAddonLimit: account.maxSubSitesAddonLimit || 0,
              staging: {
                enabled: account.staging.enabled,
                domain: account.staging.domain,
                flushOpcacheURL: account.staging.flushOpcacheURL || '',
                freashInstall: account.staging.freashInstall || false,
                statusCakeTestId: account.staging.statusCakeTestId || '',
                manualBackups: account.staging.manualBackups || [],
                tags: account.staging.tags || [],
                redirects: account.staging.redirects || [],
                diskSpace: account.staging.diskSpace || [],
                ftp: {
                  host: this.checkUndefined(account.serverIP),
                  port: this.checkUndefined(account.staging.ftp.port),
                  mode: this.checkUndefined(account.staging.ftp.mode),
                  pasv: this.checkUndefined(account.staging.ftp.pasv),
                  username: this.checkUndefined(account.staging.ftp.username),
                  password: this.checkUndefined(account.staging.ftp.password),
                  accounts: this.checkFTPAccounts(account.staging),
                },
                phpMyAdmin: {
                  url: account.staging.phpMyAdmin ? this.checkUndefined(account.staging.phpMyAdmin.url) : '',
                  popupUsername: account.staging.phpMyAdmin ? this.checkUndefined(
                      account.staging.phpMyAdmin.popupUsername
                  ) : '',
                  popupPassword: account.staging.phpMyAdmin ? this.checkUndefined(
                      account.staging.phpMyAdmin.popupPassword
                  ) : '',
                  username: account.staging.phpMyAdmin ? this.checkUndefined(
                      account.staging.phpMyAdmin.username
                  ) : '',
                  password: account.staging.phpMyAdmin ? this.checkUndefined(
                      account.staging.phpMyAdmin.password
                  ) : ''
                }
              }
            },
            planLimit: account.planLimit,
            extraDomains: account.extraDomains,
            maxStorageSize: account.maxStorageSize,
            maxVisitors: account.maxVisitors,
            maxSubSitesLimit: account.maxSubSitesLimit || 0,
            planType: account.planType || 'standalone',
            maxMigrations: this.checkUndefined(account.maxMigrations),
            fullDiskSpace: account.fullDiskSpace || [],
            addon: [],
            pServerIp: account.pServerIp,
            pDomain: account.pDomain,
            tag: account.tag || '',
            tagColor: account.tagColor || '',
          });
        }
      }
      // Now add the addon domain
      for (const account of hostingAccountsFiltered) {
        const pDomain = account.addonPrimaryPlan ? account.addonPrimaryPlan.split(':')[0] : ''
        if (account.type === "Addon Domain") {
          console.log(`type f ${account.cloudflarePlan}`)
          let cloudflarePlans = Array.isArray(account.cloudflarePlan) ? [] : account.cloudflarePlan || 'free';
          if (Array.isArray(account.cloudflarePlan) && account.cloudflarePlan.length) {
            if (!account.cloudflarePlan.includes('mediavine_integration') && !account.cloudflarePlan.includes('mediavine_security') && !account.cloudflarePlan.includes('mediavine_integration') && !account.cloudflarePlan.includes('optimization_pro') && !account.cloudflarePlan.includes('security_pro')) {
              cloudflarePlans = account.cloudflarePlan[0]
            } else {
              cloudflarePlans = account.cloudflarePlan
            }
          }
          console.log('addon plan', cloudflarePlans)
          let primaryDomainIndex = hostingAccOrdered.findIndex(acc => {
            return acc.primary.domain + ':' + acc.primary.serverIP === account.addonPrimaryPlan;
          });
          if (primaryDomainIndex < 0) { //pDomain
            primaryDomainIndex = hostingAccOrdered.findIndex(acc => {
              return acc.pDomain + ':' + acc.pServerIp === pDomain + ':' + account.pServerIp;
            });
          }
          if (primaryDomainIndex < 0) {
            primaryDomainIndex = hostingAccOrdered.findIndex(acc => {
              return acc.pDomain === account.addonPrimaryDomain;
            });
          }
          console.log(primaryDomainIndex)
          console.log('primaryDomainIndex')
          hostingAccOrdered[primaryDomainIndex].addon.push({
            uuid: account.uuid || uuidv4(),
            sslFlag: account.sslFlag || false,
            aliases: account.aliases || [],
            domain: account.domain,
            siteType: account.siteType || 'standalone',
            maxSubSitesAddonLimit: account.maxSubSitesAddonLimit || 0,
            manualBackups: account.manualBackups || [],
            tags: account.tags || [],
            notes: account.notes || [],
            chargable: false,
            serverIP: this.checkUndefined(account.serverIP),
            status: account.status,
            deleted: account.deleted || false,
            comparisonID: this.checkUndefined(account.comparisonID),
            flushOpcacheURL: this.checkUndefined(account.flushOpcacheURL),
            freashInstall: account.freashInstall || false,
            statusCakeTestId: account.statusCakeTestId || '',
            monitorId: account.monitorId || '',
            redirects: account.redirects || [],
            cloudflarePlan: cloudflarePlans,
            installation_type: account.installation_type || '',
            home_path: account.home_path || `/home/nginx/domains/${account.domain}`,
            ftp: {
              host: this.checkUndefined(account.serverIP),
              port: this.checkUndefined(account.ftp.port),
              mode: this.checkUndefined(account.ftp.mode),
              pasv: this.checkUndefined(account.ftp.pasv),
              username: this.checkUndefined(account.ftp.username),
              password: this.checkUndefined(account.ftp.password),
              accounts: this.checkFTPAccounts(account),
            },
            phpMyAdmin: {
              url: this.checkUndefined(account.phpMyAdmin.url),
              popupUsername: this.checkUndefined(
                  account.phpMyAdmin.popupUsername
              ),
              popupPassword: this.checkUndefined(
                  account.phpMyAdmin.popupPassword
              ),
              username: this.checkUndefined(account.phpMyAdmin.username),
              password: this.checkUndefined(account.phpMyAdmin.password)
            },
            cloudflare: {
              accountID: this.checkUndefined(account.cloudflare.accountID),
              username: this.checkUndefined(account.cloudflare.username),
              password: this.checkUndefined(account.cloudflare.password),
              userKey: this.checkUndefined(account.cloudflare.userKey),
              apiKey: this.checkUndefined(account.cloudflare.apiKey),
              zone_id: this.checkUndefined(account.cloudflare.zone_id),
              nameserver1: this.checkUndefined(account.cloudflare.nameserver1),
              nameserver2: this.checkUndefined(account.cloudflare.nameserver2)
            },
            diskSpace: account.diskSpace || [],
            staging: {
              enabled: account.staging.enabled,
              domain: account.staging.domain || '',
              flushOpcacheURL: account.staging.flushOpcacheURL || '',
              freashInstall: account.staging.freashInstall || false,
              statusCakeTestId: account.staging.statusCakeTestId || '',
              redirects: account.staging.redirects || [],
              manualBackups: account.staging.manualBackups || [],
              tags: account.staging.tags || [],
              diskSpace: account.staging.diskSpace || [],
              ftp: {
                host: this.checkUndefined(account.serverIP),
                port: account.staging.ftp.port ? this.checkUndefined(account.staging.ftp.port) : '21',
                mode: account.staging.ftp.mode ? this.checkUndefined(account.staging.ftp.mode) : '',
                pasv: account.staging.ftp.pasv ? this.checkUndefined(account.staging.ftp.pasv) : '',
                username: this.checkUndefined(account.staging.ftp.username),
                password: this.checkUndefined(account.staging.ftp.password),
                accounts: this.checkFTPAccounts(account.staging),
              },
              phpMyAdmin: {
                url: account.staging.phpMyAdmin ? this.checkUndefined(account.staging.phpMyAdmin.url) : '',
                popupUsername: account.staging.phpMyAdmin ? this.checkUndefined(
                    account.staging.phpMyAdmin.popupUsername
                ) : '',
                popupPassword: account.staging.phpMyAdmin ? this.checkUndefined(
                    account.staging.phpMyAdmin.popupPassword
                ) : '',
                username: account.staging.phpMyAdmin ? this.checkUndefined(
                    account.staging.phpMyAdmin.username
                ) : '',
                password: account.staging.phpMyAdmin ? this.checkUndefined(
                    account.staging.phpMyAdmin.password
                ) : ''
              }
            }
          });
        }
      }
      console.log('4290 hostingLoading', this.hostingLoading)

      for (const ach of hostingAccOrdered) {
        delete ach.pServerIp
        delete ach.pDomain
      }
      console.log('Updating awaiting cron jobs for check new servers');
      for (const account of hostingAccountsFiltered) {
        if (account.type === "Primary Domain" && account.domain !== '') {
          const awaitingCronJobRef = await db.collection('new_plans').doc(account.domain).get();
          if (awaitingCronJobRef.exists) {
            const cronJobData = awaitingCronJobRef.data();
            cronJobData.ip = account.serverIP;
            await db.collection('new_plans').doc(account.domain).update(cronJobData);
          }
          // update plans in vz to lxd migration page
          const ref = await db.collection('vzToLxdMigration').where('hostname', '==', account.hbHostname).get();
          if(ref.size) {
            await Promise.all(
                ref.docs.map(doc =>
                    db.collection('vzToLxdMigration')
                        .doc(doc.id)
                        .update({ planName: account.planName })
                )
            )
          }
        }
      }
      console.log('4307 hostingLoading', this.hostingLoading)

      const aaccc = JSON.parse(JSON.stringify(hostingAccOrdered))
      try {
        // Step 1: Group accounts by sourceUid
        const accountMap = {};

        aaccc.forEach(acc => {
          if (!accountMap[acc.sourceUid]) {
            accountMap[acc.sourceUid] = [];
          }
          accountMap[acc.sourceUid].push(acc);
        });
        // Step 2: Save each group to its respective document
        await Promise.all(
            Object.entries(accountMap).map(async ([docId, accounts]) => {
              return db.collection('hostingAccounts').doc(docId).set({
                uid: docId,
                updatedAt: new Date().toISOString(),
                accounts,
              });
            })
        );
        console.log('4330 hostingLoading', this.hostingLoading)

        await this.addLog({
          uid: this.docID,
          message: 'User has updated Hosting Accounts!',
          level: "info"
        });
        await this.$http.post('/algolia/reinitialize-user-all-record', {
          grant_type: 'token',
          uid: this.docID,
        })
        await this.$store.dispatch("hosting/fetchAccountsAdmin", {
          UID: this.docID
        });
        //console.log("Update", this.hostingAccDB);

        // Set asyncDone to true
        // await  this.$store.dispatch("async/stateUpdate", {state: true});

        // Show success message to the admin for 8 sec
        // await   this.$store.dispatch("alert/update", {
        //   type: "success",
        //   message: `The hosting account details for the Customer (Cust ID#: ${
        //       this.custID
        //   }) has been updated successfully.`,
        //   show: true
        // });
        this.showToast({
          message: `The hosting account details for the Customer (Cust ID#: ${
              this.custID
          }) has been updated successfully.`, duration: 4000
        }, true, 'success')

        console.log('4357 hostingLoading', this.hostingLoading)
        this.$parent.hostingLoading = false
        // setTimeout(() => {
        //   this.$store.dispatch("alert/showUpdate", {show: false});
        // }, 8000);
      } catch (err) {
        // Set asyncDone to true
        // this.$store.dispatch("async/stateUpdate", {state: true});

        // Show the error to the admin for 5 sections
        // this.$store.dispatch("alert/update", {
        //   type: "danger",
        //   message: err,
        //   show: true
        // });
        this.showToast({message: `${err}`, duration: 4000}, true, 'danger')
        this.$parent.hostingLoading = false
        // setTimeout(() => {
        //   this.$store.dispatch("alert/showUpdate", {show: false});
        // }, 5000);
      }
      return
      // await this.addHostingAccountEventLog({hostingAccountId : this.docID ,  afterPayload: hostingAccOrdered , beforePayload: false, action: 'Update Account details' })
      const realHAccounts = aaccc.filter(el => el.sourceUid === this.docID)
      const dupHAccounts = aaccc.filter(el => el.sourceUid === `${this.docID}_dup2`)
      db
          .collection("hostingAccounts")
          .doc(this.docID)
          .set({
            uid: this.docID,
            updatedAt: new Date().toISOString(),
            accounts: realHAccounts
          })
          .then(async () => {
            if (this.docID === this.showItUID) {
              await db
                  .collection("hostingAccounts")
                  .doc(`${this.docID}_dup2`)
                  .set({
                    updatedAt: new Date().toISOString(),
                    accounts: dupHAccounts,
                    uid: `${this.docID}_dup2`
                  })
            }
            await this.addLog({
              uid: this.docID,
              message: 'User has updated Hosting Accounts!',
              level: "info"
            });
            await this.$http.post('/algolia/reinitialize-user-all-record', {
              grant_type: 'token',
              uid: this.docID,
            })
            await this.$store.dispatch("hosting/fetchAccountsAdmin", {
              UID: this.docID
            });
            //console.log("Update", this.hostingAccDB);

            // Set asyncDone to true
            await this.$store.dispatch("async/stateUpdate", {state: true});

            // Show success message to the admin for 8 sec
            await this.$store.dispatch("alert/update", {
              type: "success",
              message: `The hosting account details for the Customer (Cust ID#: ${
                  this.custID
              }) has been updated successfully.`,
              show: true
            });

            setTimeout(() => {
              this.$store.dispatch("alert/showUpdate", {show: false});
            }, 8000);
          })
          .catch(err => {
            // Set asyncDone to true
            this.$store.dispatch("async/stateUpdate", {state: true});

            // Show the error to the admin for 5 sections
            this.$store.dispatch("alert/update", {
              type: "danger",
              message: err,
              show: true
            });

            setTimeout(() => {
              this.$store.dispatch("alert/showUpdate", {show: false});
            }, 5000);
          });
      /*} else {
                  // Show error alert to the customer for 5 sec
                  this.$store.dispatch("alert/update", {
                      type: "danger",
                      message:
                          "Please make sure you have atleast one hosting account added",
                      show: true
                  });

                  setTimeout(() => {
                      this.$store.dispatch("alert/showUpdate", {show: false});
                  }, 8000);
              }*/
    },
    cloudflareApi(account, accountFlag = false, index) {
      this.mainLoading = true;
      this.operationIndex = index;
      this.$http.post("provider/check", {
        user_id: this.docID,
        cust_id: this.custID,
        grant_type: "token",
        email: this.user.email,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        domain: account.domain,
        planIndex: account.planIndex,
        ip: account.serverIP,
        allAccount: accountFlag,
      }).then(() => { // Update Cloudflare Settings
        this.addLog({
          uid: this.docID,
          message: 'User has updated Cloudflare Settings!',
          level: "info"
        });
        swal({
          title: "Request Received!",
          text: 'We are processing your request regarding Cloudflare settings for domain: ' + account.domain,
          type: "success",
        });
      }).catch(() => {
        this.addLog({
          message: 'Error when updating Cloudflare settings of domain: ' + account.domain,
          level: "danger"
        });
        swal({
          title: "Error!",
          text: 'Error when updating Cloudflare settings of domain: ' + account.domain,
          type: "error",
        });
      }).finally(() => {
        this.mainLoading = false;
        this.operationIndex = -1;
      });
    },
    async saveCloudflareDetails(account, type, index) {
      this.mainLoading = true;
      this.operationIndex = index;
      const uid =
          isMultiDocUser(this.docID)
              ? account.sourceUid
              : this.docID;
      try {
        if (type === 'primary') {
          const ref = await db.collection('hostingAccounts').doc(uid).get()
          if (ref.exists) {
            const {accounts} = ref.data()
            // const beforePayload = JSON.parse(JSON.stringify(accounts))

            if (
                !accounts[account.planIndex].primary.cloudflare.username || accounts[account.planIndex].primary.cloudflare.username === 'N/A'
            ) {
              this.mainLoading = false;
              this.operationIndex = -1;
              swal({
                title: "Error!",
                text: 'Unable to fetch cloudflare api key / email from primary domain! Please add api key first!',
                type: "error",
              });
              return
            } else {
              accounts[account.planIndex].addon.map(el => {
                if (el.domain === account.domain) {
                  el.cloudflare.apiKey = accounts[account.planIndex].primary.cloudflare.apiKey
                  el.cloudflare.password = accounts[account.planIndex].primary.cloudflare.password
                  el.cloudflare.userKey = accounts[account.planIndex].primary.cloudflare.userKey
                  el.cloudflare.username = accounts[account.planIndex].primary.cloudflare.username
                }
              })

            }
            // await this.addHostingAccountEventLog({hostingAccountId : this.docID ,  afterPayload: accounts ,beforePayload : beforePayload,  action: 'Update Cloudfare Details'})
            await db.collection('hostingAccounts').doc(uid).update({accounts})
          }
        } else if (type === 'current') {
          if (
              !account.cloudflare.username || account.cloudflare.username === 'N/A'
          ) {
            setTimeout(() => {
              swal({
                title: "Error!",
                text: 'No cloudflare api key / email found for the this domain! Please add api key first!',
                type: "error",
              });
            }, 300);

            return
          }
        }
        await this.cloudflareApi(account)

      } catch (e) {
        this.mainLoading = false;
        this.operationIndex = -1;
        swal({
          title: "Error!",
          text: 'Unable to fetch cloudflare credentials!',
          type: "error",
        });
      }
    },
    openCloudflareModal(account) {
      this.$refs.updateBulkCFModal.load(account)
    },
    openCustomSyncBetterUpTimeModal(account) {
      this.$refs.customSyncBetterUpTimeModal.load(account)
    },
    async syncPluginDatabase(data, syncAll, index) {
      try {
        this.mainLoading = true;
        this.operationIndex = index;
        const response = await this.$patchStackService.post('/patchstack/sync_plugins', {
          grant_type: 'token',
          ip: data.serverIP,
          domain: data.domain,
          syncAll,
          planIndex: data.planIndex,
          uid: this.docID
        });
        console.log('response', response)
        swal({title: 'Success', text: 'Plugins have been synchronized successfully!', type: 'success'});
      } catch (e) {
        swal({title: "Error", text: 'Something went wrong while synchronizing plugins', type: "error",});
      } finally {
        this.mainLoading = false;
        this.operationIndex = -1;
      }
    },
    syncPatchStackPlugins(account, index) {
      console.log('account', account)
      if (account.type === 'Primary Domain') {
        this.mainLoading = false;
        this.operationIndex = -1;
        const self = this;
        let buttonHtml = '<div>' +
            '<div>Do you want to refresh plugin database for  </div>' +
            '<br/>' +
            '<ul class="list-inline">' +
            '<li><button class="sw_butt1 swal2-styled" style="display: inline-block;background-color: rgb(106, 207, 152); border-left-color: rgb(106, 207, 152); border-right-color: rgb(106, 207, 152);">Primary </button></li>' +
            '<li><button class="sw_butt2 swal2-styled" style="display: inline-block; background: #e6c652" >Primary + Addons</button></li>' +
            '<li><button class="sw_butt3 swal2-styled" style="display: inline-block; background-color: rgb(238, 128, 87);">Cancel</button></li>' +
            '</ul></div>'
        swal({
          title: "Would you like to proceed?",
          html: buttonHtml,
          type: 'question',
          showCancelButton: false,
          showConfirmButton: false,
          onOpen: function () {
            /* eslint-disable */
            $('.sw_butt1').on('click', function () {
              console.log('primary');
              self.syncPluginDatabase(account, false, index)
              swal.close();
            });
            $('.sw_butt2').on('click', function () {
              console.log('All Accounts');
              self.syncPluginDatabase(account, true, index)
              swal.close();
            });
            $('.sw_butt3').on('click', function () {
              console.log('close');
              self.mainLoading = false;
              self.operationIndex = -1;
              swal.close();
            });
            /* eslint-enable */
          }
        });

      } else {
        this.syncPluginDatabase(account, false, index)
      }
    },
    checkCloudflareSettings(account, index) {
      if (account.type === 'Primary Domain') {
        if (
            !account.cloudflare.username || account.cloudflare.username === 'N/A'
        ) {

          swal({
            title: "Error!",
            text: 'Cloudflare api key or cloudflare email is missing!',
            type: "error",
          });
          return
        }
        this.mainLoading = false;
        this.operationIndex = -1;
        const self = this;
        let buttonHtml = '<div>' +
            '<div>Do you want to update CF Details for </div>' +
            '<br/>' +
            '<ul class="list-inline">' +
            '<li><button class="sw_butt1 swal2-styled" style="display: inline-block;background-color: rgb(106, 207, 152); border-left-color: rgb(106, 207, 152); border-right-color: rgb(106, 207, 152);">Primary Account</button></li>' +
            '<li><button class="sw_butt2 swal2-styled" style="display: inline-block; background: #e6c652" >Primary + Addons</button></li>' +
            '<li><button class="sw_butt4 swal2-styled" style="display: inline-block; background: #7f7962" >Custom Sync</button></li>' +
            '<li><button class="sw_butt3 swal2-styled" style="display: inline-block; background-color: rgb(238, 128, 87);">Cancel</button></li>' +
            '</ul></div>'
        swal({
          title: "Would you like to proceed?",
          html: buttonHtml,
          type: 'question',
          showCancelButton: false,
          showConfirmButton: false,
          onOpen: function () {
            console.log('On Opne');
            /* eslint-disable */
            $('.sw_butt1').on('click', function () {
              console.log('primary');
              self.cloudflareApi(account, false, index)
              swal.close();
            });
            $('.sw_butt2').on('click', function () {
              console.log('primary+addons', account);
              self.cloudflareApi(account, true, index)
              // self.openCloudflareModal(account)
              swal.close();
            });
            $('.sw_butt3').on('click', function () {
              console.log('close');
              self.mainLoading = false;
              self.operationIndex = -1;
              swal.close();
            });
            $('.sw_butt4').on('click', function () {
              console.log('Bulk Update', account);
              // self.cloudflareApi(account, true, index)
              self.openCloudflareModal(account)
              swal.close();
            });
            /* eslint-enable */
          }
        });

      } else {
        const self = this;
        let buttonHtml = '<div>' +
            '<div>Do you want to synchronize details from</div>' +
            '<br/>' +
            '<ul class="list-inline">' +
            '<li><button class="sw_butt1 swal2-styled" style="display: inline-block;background-color: rgb(106, 207, 152); border-left-color: rgb(106, 207, 152); border-right-color: rgb(106, 207, 152);">Primary</button></li>' +
            '<li><button class="sw_butt2 swal2-styled" style="display: inline-block; background: #e6c652" >Current Details</button></li>' +
            '<li><button class="sw_butt3 swal2-styled" style="display: inline-block; background-color: rgb(238, 128, 87);">Cancel</button></li>' +
            '</ul></div>'
        swal({
          title: "Would you like to proceed?",
          html: buttonHtml,
          type: 'question',
          showCancelButton: false,
          showConfirmButton: false,
          onOpen: function () {
            console.log('On Opne');
            /* eslint-disable */
            $('.sw_butt1').on('click', function () {
              console.log('primary');
              self.saveCloudflareDetails(account, 'primary', index)
              swal.close();
            });
            $('.sw_butt2').on('click', function () {
              console.log('current details');
              self.saveCloudflareDetails(account, 'current', index);
              swal.close();
            });
            $('.sw_butt3').on('click', function () {
              console.log('close');
              self.mainLoading = false;
              self.operationIndex = -1;
              swal.close();
            });
            /* eslint-enable */
          }
        });
      }
    },
    async proceedSyncVersion(account, type, index) {
      try {
        this.mainLoading = true;
        this.operationIndex = index;
        console.log('account', account)
        if (type) {
          // const response = await this.$http.post("utilities/sync-version", {
          //   grant_type: "token",
          //   ip: account.serverIP,
          //   domain: account.domain,
          //   syncType: 'bulk',
          //   planIndex: account.planIndex,
          //   docId: this.docID
          // })
          const response = await this.$patchStackService.post('/sync-versions/wp_and_auto_updates', {
            grant_type: 'token',
            ip: account.serverIP,
            domain: account.domain,
            syncAll: true,
            docId: this.docID
          });
          console.log('response from api', response)
        } else {
          const response = await this.$patchStackService.post('/sync-versions/wp_and_auto_updates', {
            grant_type: 'token',
            ip: account.serverIP,
            domain: account.domain,
          });
          console.log('response from api', response)
        }
        swal('Success', 'Version has been synchronized successfully', 'success')
        this.mainLoading = false;
      } catch (e) {
        swal('Error', 'Failed to synchronize versions', 'error')
      } finally {
        this.mainLoading = false;
        this.operatingIndex = -1
      }
    },
    async refreshDomainTags(account, index) {
      console.log('account', account)
      try {
        this.mainLoading = true;
        this.operationIndex = index;
        const resp = await this.$http.post('/hooks/wpo/tag-categories', {
          ip: account.pServerIp,
          domain: account.domain,
          hash: '1a18fefe16e4ab6ae1967a2ad980f396'
        })
        console.log(resp)
        await this.updateData()
      } catch (e) {
        console.log('error while refreshing domain tags', e.toString())
      } finally {
        this.operatingIndex = -1
        this.mainLoading = false
      }
    },
    syncVersions(account, index) {
      if (account.type === 'Primary Domain') {
        this.mainLoading = false;
        this.operationIndex = -1;
        const self = this;
        let buttonHtml = '<div>' +
            '<div>Do you want to synchronize versions for </div>' +
            '<br/>' +
            '<ul class="list-inline">' +
            '<li><button class="sw_butt1 swal2-styled" style="display: inline-block;background-color: rgb(106, 207, 152); border-left-color: rgb(106, 207, 152); border-right-color: rgb(106, 207, 152);">Primary Account</button></li>' +
            '<li><button class="sw_butt2 swal2-styled" style="display: inline-block; background: #e6c652" >Primary + Addons</button></li>' +
            '<li><button class="sw_butt3 swal2-styled" style="display: inline-block; background-color: rgb(238, 128, 87);">Cancel</button></li>' +
            '</ul></div>'
        swal({
          title: "Would you like to proceed?",
          html: buttonHtml,
          type: 'question',
          showCancelButton: false,
          showConfirmButton: false,
          onOpen: function () {
            console.log('On Opne');
            /* eslint-disable */
            $('.sw_butt1').on('click', function () {
              console.log('primary');
              self.proceedSyncVersion(account, false, index)
              swal.close();
            });
            $('.sw_butt2').on('click', function () {
              console.log('All Accounts');
              self.proceedSyncVersion(account, true, index)
              swal.close();
            });
            $('.sw_butt3').on('click', function () {
              console.log('close');
              self.mainLoading = false;
              self.operationIndex = -1;
              swal.close();
            });
            /* eslint-enable */
          }
        });

      } else {
        this.proceedSyncVersion(account, false, index)
      }
    },
    async syncStaging(account, index) {
      console.log(account);
      this.stagingLoading = true;
      this.operationIndex = index;
      try {
        const resp = await this.$http.post("staging-request/sync", {
          UID: account.sourceUid || this.docID,
          custId: this.custID,
          grant_type: "token",
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          domain: account.staging.domain,
          ip: account.serverIP,
          planIndex: account.planIndex,
          addonIndex: account.addonIndex,
        });
        swal({
          title: "Request Received!",
          text: resp.data.msg,
          type: "success",
        });
        this.addLog({
          uid: this.docID,
          message: 'User has Synchronized staging domain: ' + account.staging.domain,
          level: "info"
        });
      } catch (e) {
        swal({
          title: "Error!",
          text: 'Something went wrong',
          type: "error",
        });
        this.addLog({
          uid: this.docID,
          message: 'Error in Sync Staging Domain: ' + account.staging.domain,
          level: "error"
        });
      }
      this.stagingLoading = false;
      this.operationIndex = -1;
    }
  }
}
</script>
<style>
.multiselect__option--highlight {
  background: #5a7cfd !important;
}

.multiselect__option--highlight:after {
  background: #5a7cfd !important;
}

.multiselect__tag {
  background: #5a7cfd !important;
}

.multiselect__tag-icon:hover {
  background: red !important;
}

.multiselect__tag-icon:after {
  color: white !important;
}

.pagination {
  display: inline-flex !important;
}
</style>
<style lang="scss" scoped>
.custom-button {
  font-size: .8571em;
  border-radius: 3px;
  padding: 5px 15px;
  border: none !important;
  color: white;
  outline: none;
  cursor: pointer;
}

.custom-button:hover {
  border: none !important;
  background-color: var(--focus-color) !important;
}

.custom-button:focus {
  background-color: var(--focus-color) !important;
  outline: none;
  border: none;
}

.filter-btn, .filter-btn:active, .filter-btn:focus {
  background-color: transparent !important;
  color: black !important;
}

.filter-btn:hover {
  background-color: black !important;
  color: white !important;
}

.dropdown-menu {
  transform: translate3d(-85px, 28px, 0px) !important;
}

.cpy-btn {
  margin: 0;
}

.fs-28 {
  font-size: 28px;
}

.position {
  display: flex;
  align-items: center;
}

.align-end {
  display: flex;
  align-items: end;

  .btn {
    margin-bottom: 0px;
  }
}

.fs-10 {
  font-size: 10px;
}

.h-43 {
  height: 43px;
}

.domain-card {
  background: #f0f0f4;
  box-shadow: none;
  border-radius: 8px !important;

  &:hover {
    box-shadow: 0 6px 10px 3px rgba(0, 0, 0, 0.15);;
  }

  .collapse-btn {
    //margin-top: 0.5rem !important;
  }

  .domain-head {
    display: flex;
    justify-content: space-between;

    .h5-m0 {
      margin: 0;
    }

    .ul-m0 {
      margin: 0;
    }
  }

  .domain-info {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .badge {
      text-transform: none !important;
    }
  }
}

.bl-bt {
  display: flex;
  align-items: flex-end;

  button {
    margin: 0 !important;
  }
}

.lds-ellipsis {
  display: inline-block;
  position: absolute;
  top: 0;
  right: 370px;
}

.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #5B7CFB;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}

@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

.cf-status-icons {
  i {
    font-size: 25px;
    margin: 0 !important;

    &.disabled {
      color: #7E7E7E;
    }

    &.enabled {
      color: #47f260;
    }

    &.yellow {
      color: #f2b61d;
    }

    &.default {
      color: currentColor;
    }

    //&:hover{
    //  background-color:transparent !important;
    //  color: currentColor !important;
    //}
  }
}

.plan-limit > input[type="number"]::-webkit-outer-spin-button,
.plan-limit > input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

::v-deep .plan-limit > input {
  z-index: 0 !important;
}

.lock {
  background-color: #E3E3E3;
}

.unlock {
  background-color: #fff;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

::v-deep .plan-limit > input:focus {
  border-right: 0px solid #ddd !important;
  border-left: 1px solid #ddd !important;
  border-top: 1px solid #ddd !important;
  border-bottom: 1px solid #ddd !important;
}

.multiselect {
  .multiselect__tags-wrap {
    display: flex !important;
    flex-wrap: wrap
  }
}

/* 🔹 Base skeleton style */
.skeleton {
  display: inline-block;
  background: #E3E3E3;
  border-radius: 0.25rem;
  position: relative;
  overflow: hidden;
}

/* 🔹 Shimmer effect */
.skeleton::after {
  content: '';
  position: absolute;
  top: 0;
  left: -150%;
  width: 150%;
  height: 100%;
  background: linear-gradient(
          90deg,
          rgba(227, 227, 227, 0) 0%,
          rgba(255, 255, 255, 0.5) 50%,
          rgba(227, 227, 227, 0) 100%
  );
  animation: shimmer 1.6s infinite;
}

@keyframes shimmer {
  100% {
    left: 150%;
  }
}

/* 🔹 Specific components */
.skeleton-label {
  width: 80px; /* small label width */
  height: 10px;
}

.skeleton-input {
  width: 100%;
  height: 38px;
  border-radius: 0.375rem;
}
</style>
